(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-add-iframe"] && !Shopify.designMode) return;
  try {
    
(function(){
let iframe = document.querySelector('#iframe-after-add');
  /// 更新PC iframe的高度
function initPCIframeHeight(height) {
    if (iframe) {
        iframe.style.height = height + 100 + 'px';
    }else {
      iframe = document.querySelector('#iframe-after-add');
      initPCIframeHeight(height);
    }
}

/// 初始化当前售后iframe的高度
function initIframeHeight(height) {
    if (iframe) {
        const client = document.documentElement.clientHeight;
        height = client > height ? client : height;
        iframe.style.height = height + "px";
    }
}
let timer = null;
document.addEventListener('scroll', function(e) {
  clearTimeout(timer);
  
  timer = setTimeout(function(){
    let top = 0;
    if (window.scrollY !== undefined) {
      top = window.scrollY;
    } else {
     top = document.documentElement.scrollTop; 
    }
     
    if (iframe) {
        iframe.contentWindow.postMessage({top: top, type: 'scroll'}, '*');
    }
  }, 500);
});
  /// 接受子组件传来的消息
window.addEventListener('message', function (e) {
    try {
        const data = e.data;
        switch (data.type) {
            case 'load':
                initIframeHeight(data.height);
                break;
            case 'init':
                initPCIframeHeight(data.height);
                break;
            case 'top':
                window.scroll(0, 0);
                break;
            case 'link':
                window.location.href = data.options;
                break;
        }
    } catch (e) {
    }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balcony"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('balcony-next');
      const events = Array.prototype.slice.apply(document.getElementById('balcony-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected'); 
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bathroom"]) return;
  try {
    
  (function() {
      let lastTar = null;
      const btn = document.getElementById('bathroom-next');
      const events = Array.prototype.slice.apply(document.getElementById('bathroom-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');  
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[0].result = 'yes';
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question2';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-scroll-to-top"] && !Shopify.designMode) return;
  try {
    
  class FooterScrollToTop extends BaseElement {
    init() {
      this._button = this.querySelector('.footer-scroll-to-top__button');
      if (!this._button) return;

      this._onScroll = this._handleScroll.bind(this);
      this._onResize = this._handleScroll.bind(this);
      this._onClick = this._handleClick.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._button.addEventListener('click', this._onClick);
      this._handleScroll();
    }

    dispose() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      this._button?.removeEventListener('click', this._onClick);
      this.classList.remove('is-visible');
      this._button = null;
      this._onScroll = null;
      this._onResize = null;
      this._onClick = null;
    }

    _handleScroll() {
      const forceVisible = Boolean(window.Shopify?.designMode);
      this.classList.toggle('is-visible', forceVisible || window.scrollY > window.innerHeight);
    }

    _handleClick() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  if (!customElements.get('footer-scroll-to-top')) {
    customElements.define('footer-scroll-to-top', FooterScrollToTop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-animation-coverage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-animation-coverage';
    const ROOT_SELECTOR = '[data-ndev-animation-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function clamp01(n) {
      if (n <= 0) return 0;
      if (n >= 1) return 1;
      return n;
    }

    function parseNumber(v, fallback) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function toPx(value, unit, viewportHeight) {
      if (unit === 'percent') return (value / 100) * viewportHeight;
      return value;
    }

    function computeProgress(elementTopPx, startPx, endPx) {
      const denom = (startPx - endPx);
      if (!denom) {
        if (elementTopPx <= endPx) return 1;
        return 0;
      }
      return clamp01((startPx - elementTopPx) / denom);
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const items = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-scroll-opacity]'));
      let rafId = 0;
      let destroyed = false;

      function update() {
        rafId = 0;
        if (destroyed) return;

        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        for (let i = 0; i < items.length; i++) {
          const el = items[i];
          if (!el || !el.getBoundingClientRect) continue;

          const rect = el.getBoundingClientRect();
          const elementBottom = rect.bottom;

          const unit = el.dataset.scrollUnit || 'percent';
          const startVal = parseNumber(el.dataset.scrollStart, 80);
          const endVal = parseNumber(el.dataset.scrollEnd, 30);
          const fromOpacity = clamp01(parseNumber(el.dataset.scrollFromOpacity, 0));

          const startPx = toPx(startVal, unit, vh);
          const endPx = toPx(endVal, unit, vh);
          const p = computeProgress(elementBottom, startPx, endPx);

          const opacity = fromOpacity + (1 - fromOpacity) * p;
          el.style.opacity = String(opacity);
        }
      }

      function scheduleUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(update);
      }

      function onScroll() { scheduleUpdate(); }
      function onResize() { scheduleUpdate(); }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      scheduleUpdate();

      controllers.set(root, {
        root: root,
        destroy: function () {
          destroyed = true;
          try { window.removeEventListener('scroll', onScroll); } catch (e) {}
          try { window.removeEventListener('resize', onResize); } catch (e) {}
          try { if (rafId) window.cancelAnimationFrame(rafId); } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class NdevAnnouncementBar extends BaseElement {
    init() {
      this.dispose();

      this.listeners = [];
      this.index = 0;
      this.timer = null;
      this.closeTimer = null;
      this.pauseReasons = new Set();
      this.inView = true;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.autoplaySpeed = Math.min(10000, Math.max(2000, Number(this.getAttribute('autoplay-speed')) || 5000));
      this.fingerprint = this.getAttribute('fingerprint') || '';
      this.isDesignMode = Boolean(window.Shopify?.designMode);
      this.removeAttribute('hidden');

      try {
        if (!this.isDesignMode && this.fingerprint && sessionStorage.getItem('ndev-announcement-bar:closed') === this.fingerprint) {
          this.setAttribute('hidden', '');
          return;
        }
      } catch (error) {}

      this.viewport = this.querySelector('.ndev-announcement-bar__viewport');
      this.track = this.querySelector('.ndev-announcement-bar__track');
      this.slides = Array.from(this.querySelectorAll('.ndev-announcement-bar__slide'));
      this.status = this.querySelector('.ndev-announcement-bar__status');
      this.closeButton = this.querySelector('.ndev-announcement-bar__close');
      this.prevButton = this.querySelector('.ndev-announcement-bar__arrow--prev');
      this.nextButton = this.querySelector('.ndev-announcement-bar__arrow--next');

      if (!this.viewport || !this.track || this.slides.length === 0) return;

      this.updateSlideLayers(this.index, (this.index + 1) % this.slides.length);

      this.on(this, 'click', (event) => this.handleBarClick(event));
      if (this.closeButton) this.on(this.closeButton, 'click', (event) => this.handleClose(event));

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      }

      if (this.slides.length > 1) {
        if (this.prevButton) this.on(this.prevButton, 'click', () => this.goTo(this.index - 1, true));
        if (this.nextButton) this.on(this.nextButton, 'click', () => this.goTo(this.index + 1, true));
        this.on(this, 'mouseenter', () => this.pause('hover'));
        this.on(this, 'mouseleave', () => this.resume('hover'));
        this.on(this, 'focusin', () => this.pause('focus'));
        this.on(this, 'focusout', () => this.resume('focus'));
        this.on(document, 'visibilitychange', () => this.syncAutoplay());
        this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
        this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
        this.observeVisibility();
      }

      this.setAttribute('ready', '');
      this.updateSlides();
      this.updateClickable();
      this.syncAutoplay();
    }

    dispose() {
      clearTimeout(this.timer);
      clearTimeout(this.closeTimer);
      this.timer = null;
      this.closeTimer = null;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.slides) {
        this.slides.forEach((slide) => {
          slide.removeAttribute('aria-hidden');
          slide.inert = false;
          slide.classList.remove('is-active', 'is-next', 'is-other', 'is-exiting');
        });
      }
      this.classList.remove('is-closing', 'has-url');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.inView = Boolean(entry && entry.isIntersecting);
        this.syncAutoplay();
      }, { threshold: 0 });
      this.intersectionObserver.observe(this);
    }

    goTo(index, manual) {
      const count = this.slides.length;
      if (count === 0) return;
      const nextIndex = ((index % count) + count) % count;
      if (nextIndex === this.index) return;

      const previousIndex = this.index;
      this.index = nextIndex;
      this.updateSlideLayers(nextIndex, (nextIndex + 1) % count, previousIndex);
      this.updateSlides();
      this.updateClickable();
      if (manual) this.syncAutoplay();
      if (manual) this.announceSlide();
    }

    announceSlide() {
      if (!this.status) return;
      const slide = this.slides[this.index];
      const text = slide ? slide.textContent.replace(/\s+/g, ' ').trim() : '';
      this.status.textContent = text
        ? `${this.index + 1} of ${this.slides.length}: ${text}`
        : `${this.index + 1} of ${this.slides.length}`;
    }

    updateSlides() {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.inert = !isActive;
      });
    }

    updateSlideLayers(activeIndex, nextIndex, previousIndex) {
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
        slide.classList.toggle('is-exiting', slideIndex === previousIndex && slideIndex !== activeIndex);
        slide.classList.toggle('is-next', slideIndex === nextIndex && slideIndex !== activeIndex && slideIndex !== previousIndex);
        slide.classList.toggle('is-other', slideIndex !== activeIndex && slideIndex !== nextIndex && slideIndex !== previousIndex);
      });
    }

    updateClickable() {
      const slide = this.slides[this.index];
      const link = slide ? slide.querySelector('.ndev-announcement-bar__slide-link') : null;
      this.classList.toggle('has-url', Boolean(link));
    }

    isAutoplayRunning() {
      return this.autoplayEnabled
        && this.slides.length > 1
        && !this.motionQuery.matches
        && this.pauseReasons.size === 0
        && this.inView
        && !document.hidden;
    }

    syncAutoplay() {
      clearTimeout(this.timer);
      this.timer = null;
      if (!this.isAutoplayRunning()) return;
      this.timer = setTimeout(() => {
        this.goTo(this.index + 1, false);
        this.syncAutoplay();
      }, this.autoplaySpeed);
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.syncAutoplay();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.syncAutoplay();
    }

    handleMotionChange() {
      this.syncAutoplay();
    }

    handleBarClick(event) {
      if (event.target.closest('a, button')) return;
      const slide = this.slides[this.index];
      const link = slide ? slide.querySelector('.ndev-announcement-bar__slide-link') : null;
      if (link) link.click();
    }

    handleClose(event) {
      event.stopPropagation();

      if (!this.isDesignMode) {
        try {
          sessionStorage.setItem('ndev-announcement-bar:closed', this.fingerprint);
        } catch (error) {}
      }

      this.dispatchEvent(new CustomEvent('ndev:announcement-bar-closed', { bubbles: true }));

      clearTimeout(this.timer);
      this.timer = null;

      if (this.motionQuery.matches) {
        this.setAttribute('hidden', '');
        return;
      }

      this.classList.add('is-closing');
      this.closeTimer = setTimeout(() => {
        this.setAttribute('hidden', '');
        this.classList.remove('is-closing');
      }, 260);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const slide = event.target.closest('.ndev-announcement-bar__slide');
      const slideIndex = this.slides.indexOf(slide);
      if (slideIndex < 0) return;
      this.pause('editor');
      this.goTo(slideIndex, false);
    }

    handleBlockDeselect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      this.resume('editor');
    }
  }

  if (!customElements.get('ndev-announcement-bar')) {
    customElements.define('ndev-announcement-bar', NdevAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-ax26-coverage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-ax26-coverage';
    const ROOT_SELECTOR = '[data-ndev-ax26-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function clamp01(n) {
      if (n <= 0) return 0;
      if (n >= 1) return 1;
      return n;
    }

    function parseNumber(v, fallback) {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : fallback;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const masks = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-ax26-coverage-mask]'));
      const stickyEl = root.querySelector('.ndev-ax26-coverage');
      let rafId = 0;
      let destroyed = false;
      let lastProgress = -1;
      let lastTextProgress = -1;

      // 从 wrapper 的 CSS 变量读取行程
      const travelDistanceVh = parseNumber(getComputedStyle(root).getPropertyValue('--wrapper-height'), 300) - 100;
      const textTravelShare = Math.min(
        1,
        Math.max(0.08, parseNumber(getComputedStyle(root).getPropertyValue('--coverage-text-travel-ratio'), 0.32))
      );

      function update() {
        rafId = 0;
        if (destroyed) return;

        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rect = root.getBoundingClientRect();
        const wrapperTopPx = rect.top + scrollTop;

        const travelPx = (travelDistanceVh / 100) * vh;
        const scrollDistance = scrollTop - wrapperTopPx;
        const progress = 1 - clamp01(scrollDistance / travelPx);

        const textTravelPx = travelPx * textTravelShare;
        const textProgress = 1 - clamp01(scrollDistance / textTravelPx);

        // 变化检测：值未变时跳过 DOM 写入，减少 style recalc
        if (Math.abs(textProgress - lastTextProgress) >= 0.001) {
          lastTextProgress = textProgress;
          stickyEl.style.setProperty('--coverage-text-scroll-progress', String(textProgress));
        }
        if (Math.abs(progress - lastProgress) >= 0.001) {
          lastProgress = progress;
          for (let i = 0; i < masks.length; i++) {
            const mask = masks[i];
            if (!mask) continue;
            mask.style.setProperty('--mask-opacity', progress);
          }
        }
      }

      function scheduleUpdate() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(update);
      }

      function onScroll() {
        scheduleUpdate();
      }

      function onResize() {
        scheduleUpdate();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      scheduleUpdate();

      controllers.set(root, {
        root: root,
        destroy: function () {
          destroyed = true;
          stickyEl.style.removeProperty('--coverage-text-scroll-progress');
          try { window.removeEventListener('scroll', onScroll); } catch (e) {}
          try { window.removeEventListener('resize', onResize); } catch (e) {}
          try { if (rafId) window.cancelAnimationFrame(rafId); } catch (e) {}
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-brand-trust-marquee"] && !Shopify.designMode) return;
  try {
    
  class NdevBrandTrustMarquee extends BaseElement {
    init() {
      this.dispose();

      this.viewport = this.querySelector('.ndev-brand-trust-marquee__viewport');
      this.track = this.querySelector('.ndev-brand-trust-marquee__track');
      this.originalGroup = this.querySelector('.ndev-brand-trust-marquee__group:not(.ndev-brand-trust-marquee__group--clone)');
      this.listeners = [];
      this.clones = [];
      this.offset = 0;
      this.period = 0;
      this.maxOverflow = 0;
      this.lastTimestamp = null;
      this.animationFrame = null;
      this.measureFrame = null;
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.userPaused = false;
      this.editorPaused = false;
      this.inView = !('IntersectionObserver' in window);
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.speed = Math.max(0, Number(this.getAttribute('speed')) || 30);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.track || !this.originalGroup) return;

      this.on(document, 'visibilitychange', () => this.syncRuntimeState());
      this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
      this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
      this.on(this.viewport, 'keydown', (event) => this.handleKeyDown(event));
      this.on(this.viewport, 'pointerdown', (event) => this.handlePointerDown(event));
      this.on(this.viewport, 'pointermove', (event) => this.handlePointerMove(event));
      this.on(this.viewport, 'pointerup', (event) => this.endDrag(event));
      this.on(this.viewport, 'pointercancel', (event) => this.endDrag(event));
      this.on(this.viewport, 'lostpointercapture', (event) => this.endDrag(event));

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      } else if (this.motionQuery.addListener) {
        this.motionListener = () => this.handleMotionChange();
        this.motionQuery.addListener(this.motionListener);
      }

      this.observeVisibility();
      this.observeSize();
      this.scheduleMeasure();
      this.updateInteractionMetadata();
    }

    dispose() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.animationFrame = null;
      this.measureFrame = null;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.intersectionObserver = null;
      this.resizeObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.motionListener && this.motionQuery?.removeListener) {
        this.motionQuery.removeListener(this.motionListener);
      }
      this.motionListener = null;

      if (this.viewport && this.dragPointerId !== null && this.viewport.hasPointerCapture?.(this.dragPointerId)) {
        this.viewport.releasePointerCapture(this.dragPointerId);
      }

      this.querySelectorAll('.ndev-brand-trust-marquee__group--clone').forEach((clone) => clone.remove());
      this.clones = [];
      this.period = 0;
      this.maxOverflow = 0;
      this.offset = 0;
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.editorPaused = false;
      this.userPaused = false;
      if (this.track) this.track.style.removeProperty('transform');
      if (this.viewport) this.viewport.scrollLeft = 0;
      this.classList.remove('is-draggable', 'is-dragging', 'is-user-paused');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    isLoopMode() {
      return this.autoplayEnabled && this.speed > 0 && !this.motionQuery.matches && this.period > 0;
    }

    isDraggable() {
      return this.isLoopMode() || this.maxOverflow > 0;
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
        this.syncRuntimeState();
      }, { threshold: [0, 0.01] });
      this.intersectionObserver.observe(this);
    }

    observeSize() {
      if (!('ResizeObserver' in window)) return;
      this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.originalGroup);
    }

    scheduleMeasure() {
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => {
        this.measureFrame = null;
        this.rebuildTrack();
      });
    }

    rebuildTrack() {
      this.removeClones();
      this.period = this.originalGroup.getBoundingClientRect().width;
      this.maxOverflow = Math.max(0, this.period - this.getViewportContentWidth());

      if (this.isLoopMode()) {
        const cloneCount = Math.max(1, Math.ceil(this.viewport.clientWidth / this.period) + 1);
        for (let index = 0; index < cloneCount; index += 1) {
          const clone = this.originalGroup.cloneNode(true);
          clone.classList.add('ndev-brand-trust-marquee__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          this.sanitizeClone(clone);
          this.track.appendChild(clone);
          this.clones.push(clone);
        }
        this.offset = this.normalizeOffset(this.offset);
      } else {
        this.offset = this.clampOffset(this.offset);
      }

      this.viewport.scrollLeft = 0;
      this.applyOffset();
      this.setAttribute('ready', '');
      this.updateDraggableState();
      this.updateInteractionMetadata();
      this.syncRuntimeState();
    }

    getViewportContentWidth() {
      const styles = getComputedStyle(this.viewport);
      const padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
      return Math.max(0, this.viewport.clientWidth - padding);
    }

    removeClones() {
      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
    }

    sanitizeClone(clone) {
      [clone, ...clone.querySelectorAll('*')].forEach((element) => {
        element.removeAttribute('id');
        Array.from(element.attributes).forEach((attribute) => {
          if (attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
        });
      });
    }

    normalizeOffset(value) {
      if (this.period <= 0) return 0;
      return ((value % this.period) + this.period) % this.period;
    }

    clampOffset(value) {
      return Math.min(this.maxOverflow, Math.max(0, value));
    }

    applyOffset() {
      if (!this.track) return;
      this.track.style.transform = 'translate3d(' + (-this.offset) + 'px, 0, 0)';
    }

    updateDraggableState() {
      this.classList.toggle('is-draggable', this.isDraggable());
    }

    syncRuntimeState() {
      const shouldRun = this.isLoopMode()
        && !this.userPaused
        && !this.editorPaused
        && !this.dragging
        && this.inView
        && !document.hidden;

      if (shouldRun) {
        if (!this.animationFrame) this.animationFrame = requestAnimationFrame((timestamp) => this.tick(timestamp));
      } else {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.lastTimestamp = null;
      }

      this.updateInteractionMetadata();
    }

    tick(timestamp) {
      this.animationFrame = null;
      if (this.lastTimestamp !== null) {
        const elapsed = Math.min(64, timestamp - this.lastTimestamp) / 1000;
        this.offset = this.normalizeOffset(this.offset + this.speed * elapsed);
        this.applyOffset();
      }
      this.lastTimestamp = timestamp;
      this.syncRuntimeState();
    }

    handleKeyDown(event) {
      if (event.key !== 'Escape' || !this.isLoopMode()) return;
      event.preventDefault();
      this.toggleUserPaused();
    }

    handlePointerDown(event) {
      if (!this.isDraggable()) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = true;
      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartOffset = this.offset;
      this.pointerMoved = false;
      this.lastTimestamp = null;
      this.classList.add('is-dragging');
      this.viewport.setPointerCapture(event.pointerId);
      this.syncRuntimeState();
    }

    handlePointerMove(event) {
      if (!this.dragging || event.pointerId !== this.dragPointerId) return;
      const deltaX = event.clientX - this.dragStartX;
      if (Math.abs(deltaX) > 6) this.pointerMoved = true;
      const nextOffset = this.dragStartOffset - deltaX;
      this.offset = this.isLoopMode() ? this.normalizeOffset(nextOffset) : this.clampOffset(nextOffset);
      this.applyOffset();
      if (this.pointerMoved && event.cancelable) event.preventDefault();
    }

    endDrag(event) {
      if (!this.dragging || event.pointerId !== this.dragPointerId) return;

      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.classList.remove('is-dragging');

      this.syncRuntimeState();
    }

    toggleUserPaused() {
      if (!this.isLoopMode()) return;
      this.userPaused = !this.userPaused;
      this.classList.toggle('is-user-paused', this.userPaused);
      this.syncRuntimeState();
    }

    updateInteractionMetadata() {
      if (!this.viewport) return;

      let label = 'Brand trust statistics. Drag to browse.';
      if (this.isLoopMode()) {
        label = this.userPaused
          ? 'Brand trust statistics. Autoplay paused. Press Escape to resume; drag to browse.'
          : 'Brand trust statistics. Press Escape to pause; drag to browse.';
      }

      this.viewport.setAttribute('aria-label', label);
      this.viewport.setAttribute('title', label);
    }

    handleMotionChange() {
      if (this.viewport && this.dragPointerId !== null && this.viewport.hasPointerCapture?.(this.dragPointerId)) {
        this.viewport.releasePointerCapture(this.dragPointerId);
      }
      this.dragging = false;
      this.dragPointerId = null;
      this.pointerMoved = false;
      this.classList.remove('is-dragging');
      this.scheduleMeasure();
      this.syncRuntimeState();
    }

    findOriginalHost(target) {
      let current = target instanceof Element ? target : target?.parentElement;
      while (current && current !== this.originalGroup) {
        if (current.parentElement === this.originalGroup) return current;
        current = current.parentElement;
      }
      return null;
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const host = this.findOriginalHost(event.target);
      if (!host) return;

      this.editorPaused = true;
      this.offset = this.isLoopMode()
        ? this.normalizeOffset(host.offsetLeft)
        : this.clampOffset(host.offsetLeft);
      this.applyOffset();
      this.syncRuntimeState();
    }

    handleBlockDeselect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      this.editorPaused = false;
      this.syncRuntimeState();
    }
  }

  if (!customElements.get('ndev-brand-trust-marquee')) {
    customElements.define('ndev-brand-trust-marquee', NdevBrandTrustMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-bundle-save"] && !Shopify.designMode) return;
  try {
    
  /* <bundle-pure> —— 纯函数区段：无 DOM 依赖，由本地单测原样抽取执行 */
  // 有效划线价：compare > price 才有效，否则回退 price（不虚构）
  function bundleRegular(v) {
    var price = Number(v.price) || 0;
    var cmp = Number(v.compare) || 0;
    return cmp > price ? cmp : price;
  }

  // permille：组合折扣率（千分比，整数，0–1000）；与 Liquid 同一取整规则：折扣 = floor((合计 × 千分比 + 500) / 1000)
  function bundleCalcCombo(a, b, permille) {
    var sum = a.price + b.price;
    var rate = Number(permille) || 0;
    var total = sum - Math.floor((sum * rate + 500) / 1000);
    var was = bundleRegular(a) + bundleRegular(b);
    var save = was > total ? was - total : 0;
    var savePct = save > 0 ? Math.floor((save * 100 + Math.floor(was / 2)) / was) : 0;
    return { sum: sum, total: total, was: was, showWas: save > 0, save: save, savePct: savePct };
  }

  // 由店铺 money 过滤器输出的样例（123456789 → 如 "$1,234,567.89"）反推格式，保证符号/币种/分隔符与服务端一致
  function bundleMakeMoney(sample) {
    var m = /\d[\d.,'’\s  ]*\d/.exec(sample || '');
    var fallback = function (cents) {
      return (cents / 100).toFixed(2);
    };
    if (!m) return fallback;
    var run = m[0];
    var prefix = sample.slice(0, m.index);
    var suffix = sample.slice(m.index + run.length);
    var dec = /([.,])(\d{1,2})$/.exec(run);
    var decSep = dec && dec[2].length === 2 ? dec[1] : '';
    var thouSep = '';
    var body = decSep ? run.slice(0, run.length - 3) : run;
    var t = /[.,'’\s  ]/.exec(body);
    if (t) thouSep = t[0];
    return function (cents) {
      cents = Math.round(cents);
      var neg = cents < 0;
      if (neg) cents = -cents;
      var whole = decSep ? Math.floor(cents / 100) : Math.round(cents / 100);
      var frac = decSep ? String(cents % 100).padStart(2, '0') : '';
      var ws = String(whole);
      if (thouSep) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      return (neg ? '-' : '') + prefix + ws + (decSep ? decSep + frac : '') + suffix;
    };
  }

  function bundleFillTemplate(tpl, fmt, save, pct) {
    return String(tpl).split('[amount]').join(fmt(save)).split('[percent]').join(String(pct));
  }

  function bundleQty(cart, variantId) {
    var items = (cart && cart.items) || [];
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].variant_id || items[i].id) === Number(variantId)) n += Number(items[i].quantity) || 0;
    }
    return n;
  }

  // need: { variantId: qty }；before 可为 null（基线读取失败）→ 只能按"车内数量 ≥ 需求"判断，标记 baseline=false
  function bundleVerifyCart(before, after, need) {
    var ids = Object.keys(need);
    var ok = 0;
    var any = 0;
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      var base = before ? bundleQty(before, id) : 0;
      var delta = bundleQty(after, id) - base;
      if (delta >= need[id]) ok++;
      if (delta > 0) any++;
    }
    return { status: ok === ids.length ? 'full' : any > 0 ? 'partial' : 'none', baseline: !!before };
  }

  // 加购后单次回读：车内每个所需变体数量 >= 需求为 full；有部分为 partial；否则 none
  function bundleCartHas(cart, need) {
    var ids = Object.keys(need);
    var ok = 0;
    var any = 0;
    for (var i = 0; i < ids.length; i++) {
      var q = bundleQty(cart, ids[i]);
      if (q >= need[ids[i]]) ok++;
      if (q > 0) any++;
    }
    return ok === ids.length ? 'full' : any > 0 ? 'partial' : 'none';
  }

  // '+0800' / '-0530' -> 分钟；无法解析按 0
  function bundleParseOffset(z) {
    var m = /^([+-])(\d{2}):?(\d{2})$/.exec(String(z || '').trim());
    if (!m) return 0;
    return (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]);
  }

  function bundleFindItem(side, id) {
    for (var i = 0; i < side.items.length; i++) if (side.items[i].id === id) return side.items[i];
    return null;
  }

  function bundleFindVariant(item, vid) {
    if (!item) return null;
    for (var i = 0; i < item.variants.length; i++) if (item.variants[i].id === vid) return item.variants[i];
    return null;
  }

  function bundleFirstAvailableVariant(item) {
    for (var i = 0; i < item.variants.length; i++) if (item.variants[i].available) return item.variants[i];
    return item.variants[0] || null;
  }

  // 选择合法性：两侧都有商品与变体且可售（左右允许选同一个商品）
  function bundleCanBuy(selA, selB) {
    if (!selA || !selB || !selA.variant || !selB.variant) return { ok: false, reason: 'empty' };
    if (!selA.variant.available || !selB.variant.available) return { ok: false, reason: 'soldout' };
    return { ok: true, reason: '' };
  }
  /* </bundle-pure> */

  class NdevBundleSave extends BaseElement {
    init() {
      if (this._ready) return;
      var node = this.querySelector('script[data-role="data"]');
      if (!node) return;
      try {
        this.data = JSON.parse(node.textContent);
      } catch (e) {
        return;
      }
      this.querySelectorAll('script[data-role="side-data"]').forEach(function (side) {
        this.data[side.getAttribute('data-side')] = JSON.parse(side.textContent);
      }, this);
      this._ready = true;
      if (window.__ndevStandardSelect__) window.__ndevStandardSelect__.scan(this);
      this.fmt = bundleMakeMoney(this.dataset.moneySample);
      this.busy = false;
      this._generation = (this._generation || 0) + 1;
      this.sides = {};
      this.els = {
        badge: this.querySelector('[data-role="badge"]'),
        title: this.querySelector('[data-role="combo-title"]'),
        total: this.querySelector('[data-role="total"]'),
        was: this.querySelector('[data-role="was"]'),
        status: this.querySelector('[data-role="status"]'),
        add: this.querySelector('[data-action="add"]'),
        buy: this.querySelector('[data-action="buy"]')
      };
      var self = this;
      ['a', 'b'].forEach(function (key) {
        var root = self.querySelector('.ndev-bundle-save__item[data-side="' + key + '"]');
        var side = self.data[key] || { init: 0, vid: 0, items: [] };
        self.data[key] = side;
        if (!root) { self.sides[key] = { root: null, item: null, variant: null, els: {} }; return; }
        var input = root.querySelector('.ndev-standard-select__hidden-input');
        var currentValue = input ? input.value : '';
        var item = side.items.find(function (candidate) { return !!bundleFindVariant(candidate, Number(currentValue)); }) || bundleFindItem(side, side.init);
        self.sides[key] = {
          root: root,
          item: item,
          variant: item ? (bundleFindVariant(item, Number(currentValue)) || bundleFindVariant(item, side.vid) || bundleFirstAvailableVariant(item)) : null,
          // 覆盖图只属于初始商品，由 JSON 里该商品自身的 img 承载，切换到其它商品自然回退自动数据
          els: {
            img: root.querySelector('.ndev-bundle-save__img'),
            fallback: root.querySelector('[data-role="image-fallback"]'),
            select: root.querySelector('[data-ndev-select-root]')
          }
        };
      });
      this._onSelect = function (e) { if (window.Shopify && Shopify.inspectMode) return; if (e.detail && self.contains(e.detail.element)) self.onChange(e); };
      this._onClick = function (e) {
        if (window.Shopify && Shopify.inspectMode) return;
        var btn = e.target.closest ? e.target.closest('[data-action]') : null;
        if (btn && self.contains(btn)) self.purchase(btn.dataset.action === 'buy');
      };
      document.addEventListener('ndev-select:change', this._onSelect);
      this.addEventListener('click', this._onClick);
      this.canBuy = bundleCanBuy(this.sides.a, this.sides.b).ok;
      this.refreshOptions();
    }

    dispose() {
      this._generation = (this._generation || 0) + 1;
      document.removeEventListener('ndev-select:change', this._onSelect);
      this.removeEventListener('click', this._onClick);
      this.querySelectorAll('[data-ndev-select-root]').forEach(function (root) { if (root.ndevSelect) root.ndevSelect.destroy(); });
      this._ready = false;
    }

    onChange(e) {
      if (this.busy) return;
      var rootEl = e.detail.element.closest('.ndev-bundle-save__item');
      if (!rootEl || !this.contains(rootEl)) return;
      var key = rootEl.dataset.side;
      var selected = null, item = null;
      this.data[key].items.some(function (candidate) {
        selected = bundleFindVariant(candidate, Number(e.detail.value));
        if (selected) { item = candidate; return true; }
        return false;
      });
      if (!item || !selected || !selected.available) return;
      this.sides[key].item = item;
      this.sides[key].variant = selected;
      this.setStatus('', '');
      this.render();
      this.refreshOptions();
    }

    refreshOptions() {
      var self = this;
      ['a', 'b'].forEach(function (key) {
        var api = self.sides[key].els.select && self.sides[key].els.select.ndevSelect;
        if (!api) return;
        self.data[key].items.forEach(function (item) {
          item.variants.forEach(function (variant) {
            api.setOptionDisabled(variant.id, !variant.available, '');
          });
        });
      });
    }

    render() {
      var self = this;
      ['a', 'b'].forEach(function (key) {
        var s = self.sides[key];
        var e = s.els;
        var v = s.variant;
        if (!v) return;
        if (e.img && !v.img) {
          e.img.removeAttribute('srcset');
          e.img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        }
        if (e.img && v.img && e.img.getAttribute('src') !== v.img) {
          e.img.srcset = v.img + ' 600w' + (v.img2x ? ', ' + v.img2x + ' 1200w' : '');
          e.img.sizes = '(min-width: 1024px) 300px, 45vw';
          e.img.src = v.img;
        }
        if (e.img) e.img.alt = v.img ? (v.label || s.item.name) : self.data.t.imageUnavailable;
        if (e.fallback) e.fallback.hidden = !!v.img;
      });
      var a = this.sides.a;
      var b = this.sides.b;
      if (!a.variant || !b.variant) {
        this.canBuy = false; this.setStatus(this.data.t.empty, 'error'); this.syncButtons(); return;
      }
      var calc = bundleCalcCombo(a.variant, b.variant, this.data.rate);
      var fixedBadge = ''; // Savings always come from real SKU values.
      var badgeText = fixedBadge || (calc.save > 0 ? bundleFillTemplate(this.data.t.badge, this.fmt, calc.save, calc.savePct) : '');
      this.els.badge.textContent = badgeText;
      this.els.badge.hidden = !badgeText;
      var comboTitle = this.querySelector('.ndev-bundle-save__summary').dataset.comboFixed || (a.variant.label || a.item.name) + ' + ' + (b.variant.label || b.item.name);
      this.els.title.textContent = comboTitle;
      this.els.title.title = comboTitle;
      this.els.total.textContent = this.fmt(calc.total);
      this.els.was.textContent = calc.showWas ? this.fmt(calc.was) : '';
      this.els.was.hidden = !calc.showWas;
      this.canBuy = bundleCanBuy(a, b).ok;
      this.syncButtons();
    }

    syncButtons() {
      var off = this.busy || !this.canBuy;
      [this.els.add, this.els.buy].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = off;
        btn.setAttribute('aria-disabled', String(off));
      });
    }

    setStatus(text, tone) {
      var el = this.els.status;
      el.textContent = text || '';
      el.hidden = !text;
      if (tone) el.setAttribute('data-tone', tone);
      else el.removeAttribute('data-tone');
    }

    setBusy(on) {
      this.busy = on;
      var self = this;
      [this.els.add, this.els.buy].forEach(function (btn) {
        if (!btn) return;
        if (on) btn.setAttribute('aria-busy', 'true');
        else btn.removeAttribute('aria-busy');
      });
      this.setAttribute('aria-busy', on ? 'true' : 'false');
      this.syncButtons();
      this.querySelectorAll('[data-ndev-select-root]').forEach(function (sel) {
        if (sel.ndevSelect) sel.ndevSelect.setDisabled(on);
      });
      if (!on) self.refreshOptions();
    }

    async readCart(root, signal) {
      try {
        var res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', signal: signal });
        if (!res.ok) return null;
        return await res.json();
      } catch (err) {
        return null;
      }
    }

    async purchase(buyNow) {
      if (this.busy || !this.canBuy || (window.Shopify && Shopify.inspectMode)) return;
      var generation = this._generation;
      var a = this.sides.a;
      var b = this.sides.b;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var need = {};
      need[a.variant.id] = (need[a.variant.id] || 0) + 1;
      need[b.variant.id] = (need[b.variant.id] || 0) + 1;
      var items = Object.keys(need).map(function (id) {
        return { id: Number(id), quantity: need[id] };
      });
      this.setBusy(true);
      this.setStatus('', '');
      var failMessage = this.data.t.error;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
      // outcome: 'ok' 服务端 2xx / 'rejected' 服务端明确拒绝（422 整体失败，不会部分加入）/ 'unknown' 网络错误或超时
      var outcome = 'unknown';
      try {
        if (buyNow) {
          // G04（2026-10-22 定）：Buy Now 与全站一致，先清空购物车，再加购并进结账
          var clearRes = await fetch(root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            signal: controller ? controller.signal : undefined
          });
          if (!clearRes.ok) throw new Error('cart-clear-failed');
        }
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
          signal: controller ? controller.signal : undefined
        });
        if (res.ok) {
          outcome = 'ok';
        } else {
          outcome = 'rejected';
          try {
            var errBody = await res.json();
            failMessage = errBody.description || errBody.message || failMessage;
          } catch (ignore) {}
        }
      } catch (err) {
        // 网络错误/超时：结果不明，不重试
      } finally {
        if (timer) clearTimeout(timer);
      }
      if (generation !== this._generation) return;
      if (outcome === 'rejected') {
        this.setBusy(false);
        this.setStatus(failMessage, 'error');
        return;
      }
      // 加购后只回读一次 cart.js（无加购前快照：422 整体失败，2xx 即两件都已加入）
      var after = await this.readCart(root);
      if (generation !== this._generation) return;
      this.setBusy(false);
      if (!after) {
        this.setStatus(this.data.t.unconfirmed, 'error');
        return;
      }
      var verdict = bundleCartHas(after, need);
      if (outcome === 'ok' && verdict === 'full') {
        this.afterSuccess(after, buyNow, root);
      } else if (outcome === 'ok' && verdict === 'partial') {
        this.setStatus(this.data.t.partial, 'error');
        this.notifyCart(after);
      } else {
        // 2xx 但车里没有 / 结果不明：不能确认，提示核对购物车
        this.setStatus(verdict === 'none' ? failMessage : this.data.t.unconfirmed, 'error');
        this.notifyCart(after);
      }
    }

    notifyCart(cart) {
      document.dispatchEvent(new CustomEvent('ndev:cart:changed', { detail: { source: 'bundle', cart: cart } }));
    }

    afterSuccess(cart, buyNow, root) {
      this.notifyCart(cart);
      if (buyNow) {
        // G04（2026-10-22 定）：已在 purchase 里先清空购物车，这里直接进入 checkout
        window.location.href = root + 'checkout';
        return;
      }
      this.setStatus(this.data.t.added + (this.data.t.final ? ' ' + this.data.t.final : ''), '');
      // 与既有 Add to Cart 约定一致：非 Buy Now 才触发内部 addToCart 事件
      if (typeof $narwal !== 'undefined' && $narwal && typeof $narwal.emit === 'function') {
        $narwal.emit('addToCart', { multiple: true });
      }
      // 只刷新一次：优先购物车适配层，否则回退旧抽屉刷新
      if (window.ndevCart && typeof window.ndevCart.refresh === 'function') {
        window.ndevCart.refresh({ source: 'bundle' });
      } else if (typeof $360 !== 'undefined' && $360 && typeof $360.showHeaderCart === 'function') {
        $360.showHeaderCart({ update: true });
      }
    }
  }

  class NdevBundleCountdown extends HTMLElement {
    connectedCallback() {
      var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/.exec(this.dataset.end || '');
      if (!m) return;
      // end_time 按店铺时区解释：data-offset 为 Liquid 'now' | date: '%z' 输出（如 -0800 / +0530）。
      // 偏移取渲染时刻的值；截止日与当前跨夏令时切换时可能差 1 小时。
      var off = bundleParseOffset(this.dataset.offset);
      this.endMs = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59)) - off * 60000;
      this.label = this.dataset.prefix || '';
      this.tick();
      if (this.endMs > Date.now()) {
        var self = this;
        this.timer = setInterval(function () {
          self.tick();
        }, 1000);
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    tick() {
      var left = this.endMs - Date.now();
      if (left <= 0) {
        this.hidden = true;
        this.disconnectedCallback();
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var mi = Math.floor((s % 3600) / 60);
      var pad = function (n) {
        return String(n).padStart(2, '0');
      };
      this.textContent = this.label + ' ' + (d > 0 ? d + this.dataset.day + ' ' : '') + pad(h) + this.dataset.hour + ' ' + pad(mi) + this.dataset.minute + ' ' + pad(s % 60) + this.dataset.second;
      this.hidden = false;
    }
  }

  if (!customElements.get('ndev-bundle-save')) customElements.define('ndev-bundle-save', NdevBundleSave);
  if (!customElements.get('ndev-bundle-countdown')) customElements.define('ndev-bundle-countdown', NdevBundleCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-category-navbar"] && !Shopify.designMode) return;
  try {
    
  class NdevCategoryNavbar extends HTMLElement {
    static LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    static LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    connectedCallback() {
      this._headerEl = document.querySelector('#site-header');
      this._sections = Array.from(document.querySelectorAll('#main-content .shopify-section'));
      this._container = this.querySelector('.ndev-category-navbar__container');
      this._wrapper = this.closest('.ndev-category-navbar-section');
      this._activeItem = this.querySelector('[data-ndev-category-navbar-item].is-active');
      this._lock = null;
      this._naturalTop = null;
      this._ticking = false;

      const mainContent = document.querySelector('#main-content');
      if (mainContent && window.MutationObserver) {
        this._sectionsObserver = new MutationObserver(() => {
          this._sections = Array.from(document.querySelectorAll('#main-content .shopify-section'));
        });
        this._sectionsObserver.observe(mainContent, { childList: true });
      }

      // 收集所有锚点导航项，构建 section index → 导航项映射
      this._anchorItemMap = {};
      this.querySelectorAll('[data-ndev-category-navbar-item]').forEach((el) => {
        if (el.getAttribute('data-item-type') !== 'anchor') return;
        const ai = parseInt(el.getAttribute('data-anchor-index') || '', 10);
        if (ai) this._anchorItemMap[ai] = el;
      });
      this._anchorKeys = Object.keys(this._anchorItemMap)
        .map(Number)
        .sort((a, b) => a - b);

      this._onScroll = this._onScroll.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);

      this.addEventListener('click', this._onClickCapture);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      this._onScroll();
    }

    disconnectedCallback() {
      this._clearLock();
      this.removeEventListener('click', this._onClickCapture);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._sectionsObserver) this._sectionsObserver.disconnect();
      if (this._wrapper) this._wrapper.classList.remove('is-stuck');
    }

    _getHeaderOffsetHeight() {
      let offset = 0;
      if (this._headerEl) offset += Math.round(this._headerEl.getBoundingClientRect().height || 0);
      if (this.classList.contains('is-sticky')) offset += Math.round(this.getBoundingClientRect().height || 0);
      return offset;
    }

    _updateStuckState() {
      if (!this._wrapper || !this.classList.contains('is-sticky')) return;
      const hh = this._headerEl ? this._headerEl.getBoundingClientRect().height : 0;
      const top = this._wrapper.getBoundingClientRect().top;
      if (top > hh + 1) {
        this._naturalTop = top + window.scrollY;
        this._wrapper.classList.remove('is-stuck');
        return;
      }
      const stuck = this._naturalTop != null ? window.scrollY + hh > this._naturalTop + 1 : window.scrollY > 1;
      this._wrapper.classList.toggle('is-stuck', stuck);
    }

    _setActive(item) {
      if (!item || this._activeItem === item) return;

      this.querySelectorAll('[data-ndev-category-navbar-item]').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });

      item.classList.add('is-active');
      item.setAttribute('aria-current', item.getAttribute('data-item-type') === 'link' ? 'page' : 'true');
      this._activeItem = item;

      // 激活项滚动居中（仅在容器可横向滚动时）
      if (!this._container) return;
      if (this._container.scrollWidth <= this._container.clientWidth + 1) return;
      const r = item.getBoundingClientRect();
      const c = this._container.getBoundingClientRect();
      const center = r.left - c.left + r.width / 2;
      const left = Math.max(0, center - this._container.clientWidth / 2);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      this._container.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    _scrollToAnchorIndex(anchorIndex) {
      const idx = parseInt(anchorIndex, 10);
      if (!idx || idx < 1) return null;
      const target = this._sections.length ? this._sections[idx - 1] : null;
      if (!target || !target.getBoundingClientRect) return null;

      const offset = this._getHeaderOffsetHeight();
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
      return { idx, target };
    }

    _computeMatchedAnchorIndex() {
      if (!this._sections.length) return null;

      const marker = this._getHeaderOffsetHeight() + 1;
      let globalIdx = 1;
      for (let i = this._sections.length - 1; i >= 0; i--) {
        const rect = this._sections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (this._anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      let matched = null;
      for (const key of this._anchorKeys) {
        if (key <= globalIdx) matched = key;
      }
      return matched;
    }

    _clearLock() {
      this._lock = null;
      if (this._lockIdleTimer) {
        clearTimeout(this._lockIdleTimer);
        this._lockIdleTimer = null;
      }
      if (this._lockMaxTimer) {
        clearTimeout(this._lockMaxTimer);
        this._lockMaxTimer = null;
      }
      if (this._unbindUserCancel) {
        this._unbindUserCancel();
        this._unbindUserCancel = null;
      }
    }

    _syncActiveByScroll() {
      if (this._lock) return;
      const matched = this._computeMatchedAnchorIndex();
      if (matched !== null && this._anchorItemMap[matched]) this._setActive(this._anchorItemMap[matched]);
    }

    _bindUserIntentCancel() {
      const onUserIntent = () => {
        if (this._lock) this._clearLock();
      };
      const onKeyDown = (ev) => {
        if (!this._lock) return;
        const k = ev && ev.key ? ev.key : '';
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].includes(k)) {
          this._clearLock();
        }
      };
      window.addEventListener('wheel', onUserIntent, { passive: true, capture: true });
      window.addEventListener('touchstart', onUserIntent, { passive: true, capture: true });
      window.addEventListener('pointerdown', onUserIntent, { passive: true, capture: true });
      window.addEventListener('keydown', onKeyDown, true);
      return () => {
        window.removeEventListener('wheel', onUserIntent, true);
        window.removeEventListener('touchstart', onUserIntent, true);
        window.removeEventListener('pointerdown', onUserIntent, true);
        window.removeEventListener('keydown', onKeyDown, true);
      };
    }

    _beginLock() {
      this._clearLock();
      this._lock = true;
      this._unbindUserCancel = this._bindUserIntentCancel();
      this._lockMaxTimer = setTimeout(() => {
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevCategoryNavbar.LOCK_MAX_MS);
    }

    _armIdleUnlock() {
      if (this._lockIdleTimer) clearTimeout(this._lockIdleTimer);
      this._lockIdleTimer = setTimeout(() => {
        if (!this._lock) return;
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevCategoryNavbar.LOCK_IDLE_MS);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._ticking = false;
        this._updateStuckState();

        if (this._lock) {
          this._armIdleUnlock();
          return;
        }

        this._syncActiveByScroll();
      });
    }

    _onClickCapture(ev) {
      const target = ev && ev.target ? ev.target : null;
      if (!target || !target.closest) return;
      const item = target.closest('[data-ndev-category-navbar-item]');
      if (!item || !this.contains(item)) return;

      const type = item.getAttribute('data-item-type');
      if (type === 'link') return;

      if (type === 'anchor') {
        ev.preventDefault();
        this._setActive(item);
        const info = this._scrollToAnchorIndex(item.getAttribute('data-anchor-index'));
        if (info) this._beginLock();
      }
    }
  }

  if (!customElements.get('ndev-category-navbar')) {
    customElements.define('ndev-category-navbar', NdevCategoryNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class NdevCollectionTabs extends BaseElement {
    init() {
      this.dispose();

      this.listeners = [];
      this.swipers = {};
      this.paginationHandlers = {};
      this.arrowsFrame = null;

      this.navSide = this.getAttribute('nav-side') !== 'false';
      this.paginationPc = this.getAttribute('pagination-pc') !== 'false';
      this.paginationMb = this.getAttribute('pagination-mb') !== 'false';
      this.columns = parseInt(this.getAttribute('columns'), 10) || 4;

      this.tabsViewport = this.querySelector('.ndev-collection-tabs__tabs-viewport');
      this.tablist = this.querySelector('.ndev-collection-tabs__tablist');
      this.indicator = this.querySelector('[data-tab-indicator]');
      this.prevArrow = this.querySelector('.ndev-collection-tabs__arrow--prev');
      this.nextArrow = this.querySelector('.ndev-collection-tabs__arrow--next');
      this.tabs = Array.from(this.querySelectorAll('.ndev-collection-tabs__tab'));

      this.activeGroup = this.readInitialGroup();

      this.tabs.forEach((tab) => {
        this.listen(tab, 'click', () => this.switchTab(this.tabIndex(tab)));
      });

      if (this.tablist) {
        this.listen(this.tablist, 'keydown', (event) => this.handleTabKeydown(event));
      }
      this.listen(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));

      if (this.tabsViewport) {
        this.listen(this.tabsViewport, 'scroll', () => this.scheduleTabArrows(), { passive: true });
      }
      if (this.prevArrow) this.listen(this.prevArrow, 'click', () => this.scrollTabs(-1));
      if (this.nextArrow) this.listen(this.nextArrow, 'click', () => this.scrollTabs(1));

      this.listen(window, 'resize', () => this.scheduleTabArrows());

      if (typeof ResizeObserver === 'function') {
        this.resizeObserver = new ResizeObserver(() => this.scheduleTabArrows());
        if (this.tabsViewport) this.resizeObserver.observe(this.tabsViewport);
        if (this.tablist) this.resizeObserver.observe(this.tablist);
      }

      if (document.fonts && document.fonts.addEventListener) {
        this.onFontsLoaded = () => this.scheduleTabArrows();
        document.fonts.addEventListener('loadingdone', this.onFontsLoaded);
      }

      this.initSwiper(this.activeGroup);
      if (this.placeIndicator()) this.setAttribute('ready', '');
      this.scheduleTabArrows();
    }

    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    tabIndex(tab) {
      return parseInt(tab.dataset.tabIndex, 10) || 0;
    }

    readInitialGroup() {
      const activeTab = this.querySelector('.ndev-collection-tabs__tab[aria-selected="true"]');
      return activeTab ? this.tabIndex(activeTab) : 0;
    }

    /* ---------- Tabs：溢出箭头 ---------- */

    setArrowState(button, isAvailable) {
      if (!button) return;
      button.disabled = !isAvailable;
      button.setAttribute('aria-hidden', isAvailable ? 'false' : 'true');
    }

    updateTabArrows() {
      const viewport = this.tabsViewport;
      if (!viewport || !this.prevArrow || !this.nextArrow) return;

      if (!window.matchMedia('(max-width: 1023px)').matches) {
        this.setArrowState(this.prevArrow, false);
        this.setArrowState(this.nextArrow, false);
        viewport.scrollLeft = 0;
        return;
      }

      const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const overflowing = maxLeft > 1;
      const atStart = viewport.scrollLeft <= 1;
      const atEnd = viewport.scrollLeft >= maxLeft - 1;

      this.setArrowState(this.prevArrow, overflowing && !atStart);
      this.setArrowState(this.nextArrow, overflowing && !atEnd);
    }

    scheduleTabArrows() {
      if (this.arrowsFrame !== null) return;
      this.arrowsFrame = window.requestAnimationFrame(() => {
        this.arrowsFrame = null;
        this.updateTabArrows();
        if (this.placeIndicator()) this.setAttribute('ready', '');
      });
    }

    scrollTabs(direction) {
      const viewport = this.tabsViewport;
      if (!viewport) return;
      const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const step = viewport.clientWidth * 0.75;
      const nextLeft = Math.max(0, Math.min(viewport.scrollLeft + direction * step, maxLeft));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      viewport.scrollTo({ left: nextLeft, behavior: reduced ? 'auto' : 'smooth' });
    }

    /* ---------- 滑动指示器 ---------- */

    placeIndicator() {
      if (!this.indicator || !this.tablist) return false;

      const activeTab = this.querySelector('.ndev-collection-tabs__tab[aria-selected="true"]');
      if (!activeTab) return false;

      const listRect = this.tablist.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();
      if (!tabRect.width || !tabRect.height) return false;

      this.indicator.style.width = tabRect.width + 'px';
      this.indicator.style.height = tabRect.height + 'px';
      this.indicator.style.transform =
        'translate3d(' + (tabRect.left - listRect.left) + 'px, ' + (tabRect.top - listRect.top) + 'px, 0)';
      return true;
    }

    /* ---------- Swiper ---------- */

    formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    renderPagination(current, total) {
      return (
        '<div class="ndev-collection-tabs__pagination-info">' +
        '<span class="ndev-collection-tabs__pagination-current">' +
        this.formatPageNum(current) +
        '</span>' +
        '<span class="ndev-collection-tabs__pagination-total">/' +
        this.formatPageNum(total) +
        '</span>' +
        '</div>' +
        '<div class="ndev-collection-tabs__pagination-buttons">' +
        '<button class="ndev-collection-tabs__pagination-button ndev-collection-tabs__pagination-button--prev" type="button" aria-label="Previous slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button class="ndev-collection-tabs__pagination-button ndev-collection-tabs__pagination-button--next" type="button" aria-label="Next slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div>'
      );
    }

    checkNavigationButtons(group) {
      const swiper = this.swipers[group];
      if (!swiper) return;

      const swiperEl = this.querySelector('[data-swiper-instance="' + group + '"]');
      let navButtons = this.querySelector('[data-nav-prev="' + group + '"]');
      if (!swiperEl || !navButtons) return;

      navButtons = navButtons.closest('.ndev-collection-tabs__nav-buttons');
      if (!navButtons) return;

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      if (wrapper.scrollWidth > swiperEl.offsetWidth + 1) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    destroySwiper(group) {
      const swiper = this.swipers[group];
      if (!swiper) return;

      const handlers = this.paginationHandlers || {};
      const pag = handlers[group];
      if (pag && pag.el) pag.el.removeEventListener('click', pag.handler);
      if (handlers[group]) delete handlers[group];

      try {
        swiper.destroy(true, true);
      } catch (error) {}

      delete this.swipers[group];
    }

    initSwiper(group) {
      if (this.swipers[group]) return;
      if (typeof window.Swiper === 'undefined') return;

      const groupEl = this.querySelector('[data-tab-group="' + group + '"]');
      if (!groupEl) return;

      const swiperEl = groupEl.querySelector('[data-swiper-instance="' + group + '"]');
      const paginationEl = groupEl.querySelector('[data-pagination="' + group + '"]');
      const navPrevEl = groupEl.querySelector('[data-nav-prev="' + group + '"]');
      const navNextEl = groupEl.querySelector('[data-nav-next="' + group + '"]');
      if (!swiperEl) return;

      const isMobile = window.innerWidth < 1024;
      const enablePagination = isMobile ? this.paginationMb : this.paginationPc;

      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: this.columns,
            spaceBetween: 20,
          },
        },
        on: {
          init: () => {
            if (this.navSide) {
              window.setTimeout(() => this.checkNavigationButtons(group), 100);
            }
          },
          resize: () => {
            if (this.navSide) this.checkNavigationButtons(group);
          },
        },
      };

      if (this.navSide && navNextEl && navPrevEl) {
        config.navigation = {
          nextEl: navNextEl,
          prevEl: navPrevEl,
          disabledClass: 'swiper-button-disabled',
        };
      }

      if (enablePagination && paginationEl) {
        config.pagination = {
          el: paginationEl,
          type: 'custom',
          renderCustom: (swiper, current, total) => {
            if (total <= 1) return '';
            return this.renderPagination(current, total);
          },
        };
      }

      const swiper = new window.Swiper(swiperEl, config);
      this.swipers[group] = swiper;

      if (enablePagination && paginationEl) {
        const handlePaginationClick = (event) => {
          let target = event.target;
          while (target && target !== paginationEl) {
            if (target.classList && target.classList.contains('ndev-collection-tabs__pagination-button--prev')) {
              swiper.slidePrev();
              return;
            }
            if (target.classList && target.classList.contains('ndev-collection-tabs__pagination-button--next')) {
              swiper.slideNext();
              return;
            }
            target = target.parentElement;
          }
        };
        paginationEl.addEventListener('click', handlePaginationClick);
        this.paginationHandlers[group] = { el: paginationEl, handler: handlePaginationClick };
      }
    }

    /* ---------- Tab 切换 ---------- */

    switchTab(targetIndex) {
      if (targetIndex === this.activeGroup) return;

      this.destroySwiper(this.activeGroup);

      const oldGroup = this.querySelector('[data-tab-group="' + this.activeGroup + '"]');
      const newGroup = this.querySelector('[data-tab-group="' + targetIndex + '"]');
      if (oldGroup) oldGroup.setAttribute('hidden', '');
      if (newGroup) newGroup.removeAttribute('hidden');

      this.tabs.forEach((tab) => {
        const isActive = this.tabIndex(tab) === targetIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.activeGroup = targetIndex;
      this.initSwiper(targetIndex);
      this.scheduleTabArrows();
    }

    handleTabKeydown(event) {
      if (!this.tabs.length) return;

      const currentIndex = this.tabs.indexOf(event.target);
      if (currentIndex < 0) return;

      let nextIndex = null;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = currentIndex - 1;
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = currentIndex + 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }
      if (nextIndex == null) return;

      event.preventDefault();
      nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
      this.switchTab(nextIndex);

      const nextTab = this.tabs[nextIndex];
      if (!nextTab) return;
      nextTab.focus();

      if (this.tabsViewport) {
        const viewportRect = this.tabsViewport.getBoundingClientRect();
        const tabRect = nextTab.getBoundingClientRect();
        if (tabRect.left < viewportRect.left || tabRect.right > viewportRect.right) {
          nextTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }
    }

    /* 编辑器选中 Block（画布点击或侧边栏）时，激活其所属 Tab */
    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;

      const tab = event.target.closest('.ndev-collection-tabs__tab');
      if (!tab) return;

      this.switchTab(this.tabIndex(tab));
    }

    /* ---------- 生命周期 ---------- */

    dispose() {
      if (this.arrowsFrame !== null && this.arrowsFrame !== undefined) {
        window.cancelAnimationFrame(this.arrowsFrame);
      }
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onFontsLoaded && document.fonts && document.fonts.removeEventListener) {
        document.fonts.removeEventListener('loadingdone', this.onFontsLoaded);
      }

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }

      Object.keys(this.swipers || {}).forEach((key) => this.destroySwiper(parseInt(key, 10)));

      if (this.indicator) {
        this.indicator.style.width = '';
        this.indicator.style.height = '';
        this.indicator.style.transform = '';
      }
      this.removeAttribute('ready');

      this.listeners = [];
      this.swipers = {};
      this.paginationHandlers = {};
      this.arrowsFrame = null;
      this.resizeObserver = null;
      this.onFontsLoaded = null;
    }
  }

  if (!customElements.get('ndev-collection-tabs')) {
    customElements.define('ndev-collection-tabs', NdevCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-community-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const NS = 'ndev-community-video';
    const ROOT_SELECTOR = `[data-${NS}]`;
    const INIT_ATTR = `data-${NS}-initialized`;

    const instances = new WeakMap();

    function getModule(root) {
      const sectionId = root?.dataset?.sectionId || '';
      if (!sectionId) return '';
      const parts = sectionId.split('__');
      return parts[parts.length - 1] || sectionId;
    }

    function checkNavigationButtons(root, swiper, swiperContainer, navButtons) {
      if (!root || !swiper || !swiperContainer || !navButtons) return;
      const wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperContainer.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const swiperContainer = root.querySelector('.swiper-container');
      const navButtons = root.querySelector('.ndev-community-video__nav-buttons');
      const tabItems = Array.from(root.querySelectorAll('.tab-item'));
      const swiperSlides = Array.from(root.querySelectorAll('.swiper-slide'));

      let swiper = null;

      const destroySwiper = () => {
        swiper?.destroy?.(true, true);
        swiper = null;
      };

      const createSwiper = () => {
        if (!swiperContainer || typeof window.Swiper === 'undefined') return;
        destroySwiper();
        swiper = new window.Swiper(swiperContainer, {
          slidesPerView: 'auto',
          initialSlide: 0,
          spaceBetween: 0,
          navigation: {
            nextEl: root.querySelector('.ndev-community-video__nav-button--next'),
            prevEl: root.querySelector('.ndev-community-video__nav-button--prev'),
            disabledClass: 'swiper-button-disabled',
          },
          on: {
            init: function () {
              window.setTimeout(() => checkNavigationButtons(root, swiper, swiperContainer, navButtons), 100);
            },
          },
        });
      };

      const switchTab = (targetCategory) => {
        tabItems.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });

        const targetTab = tabItems.find((item) => item.dataset.category === targetCategory) || null;
        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.setAttribute('aria-selected', 'true');
        }

        swiperSlides.forEach((slide) => {
          const slideCategory = slide.dataset.category;
          if (!slideCategory || slideCategory === targetCategory) {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        });

        window.setTimeout(() => {
          createSwiper();
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
          swiper?.slideTo?.(0, 0);
        }, 0);

        if (window.$narwal && typeof window.$narwal.report === 'function') {
          window.$narwal.report({
            event: 'tab_switch',
            params: {
              page: 'self',
              module: getModule(root),
              btn: targetTab ? targetTab.textContent.trim() : targetCategory,
            },
          });
        }
      };

      const onTabClick = (ev) => {
        const btn = ev.currentTarget;
        const category = btn?.dataset?.category;
        if (!category) return;
        switchTab(category);
      };

      tabItems.forEach((item) => item.addEventListener('click', onTabClick));

      // initial
      if (tabItems.length > 0) {
        const first = tabItems[0].dataset.category;
        if (first) switchTab(first);
      } else {
        swiperSlides.forEach((slide) => slide.classList.remove('hidden'));
        createSwiper();
        checkNavigationButtons(root, swiper, swiperContainer, navButtons);
      }

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          checkNavigationButtons(root, swiper, swiperContainer, navButtons);
          swiper?.update?.();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, {
        destroy: () => {
          tabItems.forEach((item) => item.removeEventListener('click', onTabClick));
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          destroySwiper();
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;
      inst.destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-faq"] && !Shopify.designMode) return;
  try {
    
  class NdevFaq extends BaseElement {
    init() {
      this.singleOpen = this.hasAttribute('single-open');
      this.onClick = (event) => {
        const trigger = event.target.closest('.ndev-faq-item__trigger');
        if (!trigger || !this.contains(trigger)) return;
        this.toggle(trigger);
      };
      this.addEventListener('click', this.onClick);

      this.onBlockSelect = (event) => {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const item = event.target.closest('.ndev-faq-item');
        const trigger = item ? item.querySelector('.ndev-faq-item__trigger') : null;
        if (trigger) this.expand(trigger);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      if (this.singleOpen) {
        const expanded = Array.from(this.querySelectorAll('.ndev-faq-item__trigger[aria-expanded="true"]'));
        expanded.slice(1).forEach((trigger) => this.setExpanded(trigger, false));
      }
    }

    toggle(trigger) {
      this.setExpanded(trigger, trigger.getAttribute('aria-expanded') !== 'true');
    }

    expand(trigger) {
      this.setExpanded(trigger, true);
    }

    setExpanded(trigger, expanded) {
      if (expanded && this.singleOpen) {
        this.querySelectorAll('.ndev-faq-item__trigger[aria-expanded="true"]').forEach((other) => {
          if (other !== trigger) this.setExpanded(other, false);
        });
      }
      const panelId = trigger.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (panel) panel.hidden = !expanded;
    }

    dispose() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  if (!customElements.get('ndev-faq')) {
    customElements.define('ndev-faq', NdevFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-home-member-service"] && !Shopify.designMode) return;
  try {
    
  class NdevHomeMemberService extends BaseElement {
    init() {
      this.dispose();

      this.hasPlayed = Boolean(this.hasPlayed);
      this.animationMode = this.getAttribute('animation-mode') === 'repeat' ? 'repeat' : 'once';
      const configuredDuration = Number.parseFloat(this.getAttribute('animation-duration'));
      this.timelineDuration = Number.isFinite(configuredDuration) && configuredDuration > 0 ? configuredDuration : 1401;
      this.animations = [];
      this.listeners = [];
      this.repeatReady = false;
      this.repeatResetPending = false;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.background = this.querySelector('.ndev-home-member-service__background');
      this.layout = this.querySelector('.ndev-home-member-service__layout');
      this.advantagesStage = this.querySelector('.ndev-home-member-service__heading-stage--advantages');
      this.exclusiveMotion = this.querySelector('.ndev-home-member-service__heading-motion--exclusive');
      this.advantagesMotion = this.querySelector('.ndev-home-member-service__heading-motion--advantages');
      this.exclusiveScale = this.querySelector('.ndev-home-member-service__heading-scale--exclusive');
      this.advantagesScale = this.querySelector('.ndev-home-member-service__heading-scale--advantages');
      this.contentMotion = this.querySelector('.ndev-home-member-service__content-motion');

      if (this.motionQuery.matches || !this.supportsAnimation() || (this.hasPlayed && this.animationMode === 'once')) {
        this.setFinalState();
        return;
      }

      this.on(document, 'visibilitychange', () => this.handleVisibilityChange());
      this.on(window, 'resize', () => this.handleResize(), { passive: true });

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      } else if (this.motionQuery.addListener) {
        this.motionListener = () => this.handleMotionChange();
        this.motionQuery.addListener(this.motionListener);
      }

      this.entranceFrame = requestAnimationFrame(() => {
        this.entranceFrame = requestAnimationFrame(() => this.setupEntrance());
      });
    }

    dispose() {
      if (this.entranceFrame) cancelAnimationFrame(this.entranceFrame);
      this.entranceFrame = null;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = null;

      if (this.animations) this.animations.forEach((animation) => animation.cancel());
      this.animations = [];

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.motionListener && this.motionQuery?.removeListener) {
        this.motionQuery.removeListener(this.motionListener);
      }
      this.motionListener = null;
      this.isPlaying = false;
      this.setFinalState();
    }

    supportsAnimation() {
      return 'IntersectionObserver' in window
        && typeof Element.prototype.animate === 'function';
    }

    on(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    setupEntrance() {
      this.entranceFrame = null;
      if (!this.isConnected || (this.hasPlayed && this.animationMode === 'once')) return;

      if (this.isInTriggerZone()) {
        this.hasPlayed = true;
        this.repeatReady = false;
        this.setFinalState();
        if (this.animationMode === 'repeat') this.observeEntrance();
        return;
      }

      this.prepareInitialState();
      this.repeatReady = true;
      this.observeEntrance();
    }

    observeEntrance() {
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const isActive = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.15);
        if (isActive) this.playTimeline();
        else this.handleRepeatExit();
      }, {
        threshold: [0.15],
        rootMargin: '0px 0px -20% 0px'
      });
      this.intersectionObserver.observe(this);
    }

    isInTriggerZone() {
      const rect = this.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return false;

      const rootRight = window.innerWidth || document.documentElement.clientWidth;
      const rootBottom = (window.innerHeight || document.documentElement.clientHeight) * 0.8;
      const intersectionWidth = Math.max(0, Math.min(rect.right, rootRight) - Math.max(rect.left, 0));
      const intersectionHeight = Math.max(0, Math.min(rect.bottom, rootBottom) - Math.max(rect.top, 0));
      const intersectionRatio = intersectionWidth * intersectionHeight / (rect.width * rect.height);
      return intersectionRatio >= 0.15;
    }

    prepareInitialState() {
      this.setFinalState();

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const stageHeight = Math.min(this.offsetHeight || viewportHeight, viewportHeight);
      const rootTop = this.getBoundingClientRect().top;
      const layoutRect = this.layout?.getBoundingClientRect();
      const advantagesRect = this.advantagesStage?.getBoundingClientRect();
      const contentRect = this.contentMotion?.getBoundingClientRect();
      const advantagesTop = advantagesRect ? advantagesRect.top - rootTop : 0;
      const advantagesHeight = advantagesRect?.height || 0;
      const contentTop = contentRect ? contentRect.top - rootTop : 0;
      this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const getStartScale = (element) => {
        if (this.isDesktop) return 2;

        const textRect = element?.getBoundingClientRect();
        if (!layoutRect || !textRect || textRect.width <= 0) return 1;

        const availableWidth = Math.max(0, layoutRect.right - textRect.left);
        return Math.min(2, Math.max(1, availableWidth / textRect.width));
      };
      this.exclusiveStartScale = getStartScale(this.exclusiveScale);
      this.advantagesStartScale = getStartScale(this.advantagesScale);
      this.advantagesStartY = Math.max(
        0,
        stageHeight - 56 - advantagesTop - advantagesHeight * this.advantagesStartScale
      );
      this.contentStartY = Math.max(0, stageHeight - contentTop);
      this.exclusiveStartX = this.isDesktop ? 89.8364 : 0;
      this.advantagesStartX = this.isDesktop ? -123.0952 : 0;

      if (this.background) {
        const styles = getComputedStyle(this);
        const blur = styles.getPropertyValue('--ndev-home-member-service-background-start-blur').trim() || '0px';
        this.background.style.filter = 'blur(' + blur + ')';
      }
      if (this.advantagesStage) this.advantagesStage.style.transform = 'translate3d(0, ' + this.advantagesStartY + 'px, 0)';
      if (this.exclusiveMotion) this.exclusiveMotion.style.transform = 'translate3d(' + this.exclusiveStartX + 'px, 0, 0)';
      if (this.advantagesMotion) this.advantagesMotion.style.transform = 'translate3d(' + this.advantagesStartX + 'px, 0, 0)';
      if (this.exclusiveScale) this.exclusiveScale.style.transform = 'scale(' + this.exclusiveStartScale + ')';
      if (this.advantagesScale) this.advantagesScale.style.transform = 'scale(' + this.advantagesStartScale + ')';
      if (this.contentMotion) this.contentMotion.style.transform = 'translate3d(0, ' + this.contentStartY + 'px, 0)';
      this.setAttribute('animation-ready', '');
    }

    playTimeline() {
      if (this.isPlaying || this.motionQuery.matches) return;
      if (this.animationMode === 'once' && this.hasPlayed) return;
      if (this.animationMode === 'repeat' && !this.repeatReady) return;

      this.hasPlayed = true;
      this.isPlaying = true;
      this.repeatReady = false;
      this.repeatResetPending = false;
      if (this.animationMode === 'once') {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        this.intersectionObserver = null;
      }

      const styles = getComputedStyle(this);
      const finalBlur = styles.getPropertyValue('--ndev-home-member-service-background-final-blur').trim() || '5px';
      const startBlur = styles.getPropertyValue('--ndev-home-member-service-background-start-blur').trim() || '0px';
      const timeAt = (percent) => this.timelineDuration * percent / 100;
      const phase = (startPercent, endPercent, easing) => ({
        delay: timeAt(startPercent),
        duration: timeAt(endPercent - startPercent),
        easing
      });

      this.addAnimation(this.background, [
        { filter: 'blur(' + startBlur + ')' },
        { filter: 'blur(' + finalBlur + ')' }
      ], phase(0, 100, 'ease-in-out'));

      this.addAnimation(this.advantagesStage, [
        { transform: 'translate3d(0, ' + this.advantagesStartY + 'px, 0)' },
        { transform: 'translate3d(0, 0, 0)' }
      ], phase(0, 56.745182, 'cubic-bezier(0.42, 0, 0.58, 1)'));

      this.addAnimation(this.contentMotion, [
        { transform: 'translate3d(0, ' + this.contentStartY + 'px, 0)' },
        { transform: 'translate3d(0, 0, 0)' }
      ], phase(28.551035, 100, 'cubic-bezier(0.45, 1.2, 0.8, 1)'));

      this.addAnimation(this.exclusiveMotion, [
        { transform: 'translate3d(' + this.exclusiveStartX + 'px, 0, 0)' },
        { transform: 'translate3d(0, 0, 0)' }
      ], phase(56.863455, 85.581727, 'cubic-bezier(0.42, 0, 1, 1)'));

      this.addAnimation(this.advantagesMotion, [
        { transform: 'translate3d(' + this.advantagesStartX + 'px, 0, 0)' },
        { transform: 'translate3d(0, 0, 0)' }
      ], phase(57.030692, 85.748965, 'cubic-bezier(0.42, 0, 1, 1)'));

      this.addAnimation(this.exclusiveScale, [
        { transform: 'scale(' + this.exclusiveStartScale + ')' },
        { transform: 'scale(1)' }
      ], phase(56.863455, 85.562955, 'linear'));

      this.addAnimation(this.advantagesScale, [
        { transform: 'scale(' + this.advantagesStartScale + ')' },
        { transform: 'scale(1)' }
      ], phase(57.030692, 85.748965, 'linear'));

      if (document.hidden) this.animations.forEach((animation) => animation.pause());

      Promise.all(this.animations.map((animation) => animation.finished.catch(() => null))).then(() => {
        if (this.isPlaying) this.finishImmediately();
      });
    }

    addAnimation(target, keyframes, options) {
      if (!target) return;
      this.animations.push(target.animate(keyframes, { ...options, fill: 'forwards' }));
    }

    handleVisibilityChange() {
      if (!this.isPlaying) return;
      this.animations.forEach((animation) => {
        if (document.hidden) animation.pause();
        else animation.play();
      });
    }

    handleResize() {
      if (this.isPlaying) {
        this.finishImmediately();
        return;
      }

      if (!this.hasPlayed) this.prepareInitialState();
    }

    handleMotionChange() {
      if (this.motionQuery.matches) {
        this.hasPlayed = true;
        this.finishImmediately();
        return;
      }

      if (this.animationMode === 'repeat' && !this.isInTriggerZone()) {
        this.prepareInitialState();
        this.repeatReady = true;
      }
    }

    handleRepeatExit() {
      if (this.animationMode !== 'repeat' || !this.hasPlayed || this.motionQuery.matches) return;
      if (this.isPlaying) {
        this.repeatResetPending = true;
        return;
      }

      this.prepareInitialState();
      this.repeatReady = true;
    }

    finishImmediately() {
      if (this.animations) this.animations.forEach((animation) => animation.cancel());
      this.animations = [];
      this.isPlaying = false;
      this.setFinalState();

      if (this.animationMode === 'repeat' && this.repeatResetPending && !this.motionQuery.matches) {
        this.repeatResetPending = false;
        this.prepareInitialState();
        this.repeatReady = true;
      }
    }

    setFinalState() {
      const targets = [
        this.background,
        this.advantagesStage,
        this.exclusiveMotion,
        this.advantagesMotion,
        this.exclusiveScale,
        this.advantagesScale,
        this.contentMotion
      ];
      targets.forEach((target) => {
        if (!target) return;
        target.style.removeProperty('transform');
        target.style.removeProperty('filter');
      });
      this.removeAttribute('animation-ready');
    }
  }

  if (!customElements.get('ndev-home-member-service')) {
    customElements.define('ndev-home-member-service', NdevHomeMemberService);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-nav"] && !Shopify.designMode) return;
  try {
    
  class NdevNav extends BaseElement {
    static LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    static LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    init() {
      this.dispose();

      this._listeners = [];
      this._lock = false;
      this._ticking = false;
      this._isSticky = this.classList.contains('is-sticky');
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this._track = this.querySelector('.ndev-nav__track');
      this._pillBackground = this.querySelector('.ndev-nav__pill-background');
      this._items = Array.from(this.querySelectorAll('[data-ndev-nav-item]'));
      this._scrollItems = this._items.filter((item) => item.getAttribute('data-purpose') === 'scroll');
      if (!this._track || this._items.length === 0) return;

      this._activeItem = this.querySelector('[data-ndev-nav-item].is-active');

      this._on(this, 'click', (event) => this._handleClick(event));
      this._on(window, 'scroll', () => this._scheduleSync(), { passive: true });
      this._on(window, 'resize', () => {
        this._schedulePillBackground();
        this._scheduleSync();
      }, { passive: true });
      this._on(document, 'shopify:block:select', (event) => this._handleBlockSelect(event));

      if (this._pillBackground && window.ResizeObserver) {
        this._pillBackgroundObserver = new ResizeObserver(() => this._schedulePillBackground());
        this._pillBackgroundObserver.observe(this._track);
        this._items.forEach((item) => this._pillBackgroundObserver.observe(item));
      }
      this._on(document.fonts, 'loadingdone', () => this._schedulePillBackground());

      const main = document.querySelector('#main-content');
      if (main && window.MutationObserver) {
        this._sectionsObserver = new MutationObserver(() => {
          this._scheduleSync();
        });
        this._sectionsObserver.observe(main, { childList: true });
      }

      this._updatePillBackground();
      if (this._activeItem) this._centerItem(this._activeItem);
      this._scheduleSync();
    }

    dispose() {
      if (this._listeners) {
        this._listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this._listeners = [];
      if (this._sectionsObserver) this._sectionsObserver.disconnect();
      this._sectionsObserver = null;
      if (this._pillBackgroundObserver) this._pillBackgroundObserver.disconnect();
      this._pillBackgroundObserver = null;
      if (this._pillBackgroundFrame) window.cancelAnimationFrame(this._pillBackgroundFrame);
      if (this._syncFrame) window.cancelAnimationFrame(this._syncFrame);
      this._pillBackgroundFrame = null;
      this._syncFrame = null;
      this._ticking = false;
      this.classList.remove('has-pill-background');
      if (this._pillBackground) this._pillBackground.removeAttribute('style');
      this._clearLock();
      this._activeItem = null;
    }

    _on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this._listeners.push({ target, type, handler, options });
    }

    _getHeaderOffset() {
      const raw = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const value = parseFloat(raw);
      return Number.isFinite(value) ? Math.max(0, value) : 0;
    }

    _getNavOffset() {
      let offset = this._getHeaderOffset();
      if (this._isSticky) offset += Math.round(this.getBoundingClientRect().height || 0);
      return offset;
    }

    // 目标解析不做跨帧缓存：sections 列表每次调用实时查询，避免 MutationObserver 失效回调前的竞态
    _resolveTarget(item, sections) {
      if (item.getAttribute('data-scroll-type') === 'anchor') {
        const selector = (item.getAttribute('data-scroll-anchor') || '').trim();
        if (!selector) return null;
        try {
          return document.querySelector(selector);
        } catch (error) {
          return null;
        }
      }

      const index = parseInt(item.getAttribute('data-scroll-section-index'), 10) || 1;
      const list = sections || document.querySelectorAll('#main-content .shopify-section');
      return list[index - 1] || null;
    }

    _handleClick(event) {
      const item = event.target && event.target.closest ? event.target.closest('[data-ndev-nav-item]') : null;
      if (!item || !this.contains(item)) return;
      if (item.getAttribute('data-purpose') !== 'scroll') return;

      const target = this._resolveTarget(item);
      if (!target) {
        console.warn('[ndev-nav][NN-SCR-01]');
        return;
      }

      event.preventDefault();
      this._setActive(item);
      this._beginLock();

      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - this._getNavOffset());
      const reduced = Boolean(this._motionQuery && this._motionQuery.matches);
      window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
    }

    _setActive(item) {
      if (!item || this._activeItem === item) return;

      this._items.forEach((entry) => {
        entry.classList.remove('is-active');
        entry.removeAttribute('aria-current');
      });

      item.classList.add('is-active');
      item.setAttribute('aria-current', 'true');
      this._activeItem = item;
      this._updatePillBackground();
      this._centerItem(item);
    }

    _schedulePillBackground() {
      if (this._pillBackgroundFrame) return;
      this._pillBackgroundFrame = window.requestAnimationFrame(() => {
        this._pillBackgroundFrame = null;
        this._updatePillBackground();
      });
    }

    _updatePillBackground() {
      if (!this._pillBackground || !this._track || !this._activeItem) return;
      const itemRect = this._activeItem.getBoundingClientRect();
      if (!itemRect.width || !itemRect.height) return;
      const trackRect = this._track.getBoundingClientRect();
      // Content coordinates keep the capsule attached during native overflow scrolling, including RTL.
      const left = itemRect.left - trackRect.left + this._track.scrollLeft - this._track.clientLeft;
      const top = itemRect.top - trackRect.top + this._track.scrollTop - this._track.clientTop;
      this._pillBackground.style.width = `${itemRect.width}px`;
      this._pillBackground.style.height = `${itemRect.height}px`;
      this._pillBackground.style.translate = `${left}px ${top}px`;
      if (!this.classList.contains('has-pill-background')) {
        // Commit the first position before enabling transitions; never animate from the origin.
        this._pillBackground.getBoundingClientRect();
        this.classList.add('has-pill-background');
      }
    }

    _centerItem(item) {
      if (!this._track || this._track.scrollWidth <= this._track.clientWidth + 1) return;

      const itemRect = item.getBoundingClientRect();
      const trackRect = this._track.getBoundingClientRect();
      const center = itemRect.left - trackRect.left + this._track.scrollLeft + itemRect.width / 2;
      const rtl = window.getComputedStyle(this._track).direction === 'rtl';
      const overflow = this._track.scrollWidth - this._track.clientWidth;
      const desired = center - this._track.clientWidth / 2;
      const left = rtl ? Math.max(-overflow, Math.min(0, desired)) : Math.max(0, Math.min(overflow, desired));
      const reduced = Boolean(this._motionQuery && this._motionQuery.matches);
      this._track.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    _scheduleSync() {
      if (this._ticking) return;
      this._ticking = true;
      this._syncFrame = window.requestAnimationFrame(() => {
        this._syncFrame = null;
        this._ticking = false;
        if (this._lock) {
          this._armIdleUnlock();
          return;
        }
        this._syncActiveByScroll();
      });
    }

    _syncActiveByScroll() {
      if (this._scrollItems.length === 0) return;

      const marker = this._getNavOffset() + 24;
      const sections = document.querySelectorAll('#main-content .shopify-section');
      let matched = null;
      this._scrollItems.forEach((item) => {
        const target = this._resolveTarget(item, sections);
        if (!target) return;
        if (target.getBoundingClientRect().top <= marker) matched = item;
      });

      if (!matched) {
        matched = this.querySelector('[data-ndev-nav-item][data-default-active]') || this._scrollItems[0] || null;
      }

      if (matched) this._setActive(matched);
    }

    _clearLock() {
      this._lock = false;
      if (this._lockIdleTimer) {
        clearTimeout(this._lockIdleTimer);
        this._lockIdleTimer = null;
      }
      if (this._lockMaxTimer) {
        clearTimeout(this._lockMaxTimer);
        this._lockMaxTimer = null;
      }
      if (this._unbindUserCancel) {
        this._unbindUserCancel();
        this._unbindUserCancel = null;
      }
    }

    _beginLock() {
      this._clearLock();
      this._lock = true;
      this._unbindUserCancel = this._bindUserIntentCancel();
      this._lockMaxTimer = setTimeout(() => {
        this._clearLock();
        this._scheduleSync();
      }, NdevNav.LOCK_MAX_MS);
    }

    _armIdleUnlock() {
      if (!this._lock) return;
      if (this._lockIdleTimer) clearTimeout(this._lockIdleTimer);
      this._lockIdleTimer = setTimeout(() => {
        if (!this._lock) return;
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevNav.LOCK_IDLE_MS);
    }

    _bindUserIntentCancel() {
      const onUserIntent = () => {
        if (!this._lock) return;
        this._clearLock();
        this._scheduleSync();
      };
      const onKeyDown = (event) => {
        if (!this._lock) return;
        const key = event && event.key ? event.key : '';
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(key)) onUserIntent();
      };
      window.addEventListener('wheel', onUserIntent, { passive: true, capture: true });
      window.addEventListener('touchstart', onUserIntent, { passive: true, capture: true });
      window.addEventListener('pointerdown', onUserIntent, { passive: true, capture: true });
      window.addEventListener('keydown', onKeyDown, true);
      return () => {
        window.removeEventListener('wheel', onUserIntent, true);
        window.removeEventListener('touchstart', onUserIntent, true);
        window.removeEventListener('pointerdown', onUserIntent, true);
        window.removeEventListener('keydown', onKeyDown, true);
      };
    }

    _handleBlockSelect(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this.contains(target)) return;
      const item = target.closest('[data-ndev-nav-item]');
      if (item) this._setActive(item);
    }
  }

  if (!customElements.get('ndev-nav')) {
    customElements.define('ndev-nav', NdevNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-navbar"] && !Shopify.designMode) return;
  try {
    
  class NdevNavbar extends HTMLElement {
    static LOCK_IDLE_MS = 220; // 停止滚动多久后解锁
    static LOCK_MAX_MS = 6000; // 最大锁定时间兜底，避免极端情况锁死

    connectedCallback() {
      this._headerEl = document.querySelector('#site-header');
      this._sections = Array.from(document.querySelectorAll('#main-content .shopify-section'));
      this._listContainer = this.querySelector('.ndev-navbar__list');
      this._wrapper = this.closest('.ndev-navbar-section');
      this._activeItem = null;
      this._lock = null;
      this._naturalTop = null;
      this._ticking = false;

      const mainContent = document.querySelector('#main-content');
      if (mainContent && window.MutationObserver) {
        this._sectionsObserver = new MutationObserver(() => {
          this._sections = Array.from(document.querySelectorAll('#main-content .shopify-section'));
        });
        this._sectionsObserver.observe(mainContent, { childList: true });
      }

      // 收集所有滚动定位按钮，构建 section index → 按钮映射
      this._anchorItemMap = {};
      if (this._listContainer) {
        this._listContainer.querySelectorAll('[data-btn-purpose="scroll"]').forEach((el) => {
          const ai = parseInt(el.getAttribute('data-scroll-section-index') || '', 10);
          if (ai) this._anchorItemMap[ai] = el;
        });
      }
      this._anchorKeys = Object.keys(this._anchorItemMap)
        .map(Number)
        .sort((a, b) => a - b);

      // 默认激活第一个
      if (this._anchorKeys.length > 0) {
        this._setActive(this._anchorItemMap[this._anchorKeys[0]]);
      }

      this._onScroll = this._onScroll.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);

      this.addEventListener('click', this._onClickCapture, true);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });

      this._onScroll();
    }

    disconnectedCallback() {
      this._clearLock();
      this.removeEventListener('click', this._onClickCapture, true);
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._sectionsObserver) this._sectionsObserver.disconnect();
      if (this._wrapper) this._wrapper.classList.remove('is-stuck');
    }

    _getHeaderOffsetHeight() {
      let offset = 0;
      if (this._headerEl) offset += Math.round(this._headerEl.getBoundingClientRect().height || 0);
      if (this.classList.contains('is-sticky')) offset += Math.round(this.getBoundingClientRect().height || 0);
      return offset;
    }

    _updateStuckState() {
      if (!this._wrapper || !this.classList.contains('is-sticky')) return;
      const hh = this._headerEl ? this._headerEl.getBoundingClientRect().height : 0;
      const top = this._wrapper.getBoundingClientRect().top;
      if (top > hh + 1) {
        this._naturalTop = top + window.scrollY;
        this._wrapper.classList.remove('is-stuck');
        return;
      }
      const stuck = this._naturalTop != null ? window.scrollY + hh > this._naturalTop + 1 : window.scrollY > 1;
      this._wrapper.classList.toggle('is-stuck', stuck);
    }

    _setActive(item) {
      if (!item || !this._listContainer || this._activeItem === item) return;

      // 只更新导航列表中的按钮（不影响右侧区域）
      this._listContainer.querySelectorAll('.ndev-button .ndev-button__btn').forEach((el) => {
        el.classList.remove('is-active');
      });

      item.classList.add('is-active');
      this._activeItem = item;

      // 激活按钮滚动居中（PC 和移动端都适用）
      const btnWrapper = item.closest('.ndev-button');
      const r = (btnWrapper || item).getBoundingClientRect();
      const c = this._listContainer.getBoundingClientRect();
      const center = r.left - c.left + r.width / 2;
      const left = Math.max(0, center - this._listContainer.clientWidth / 2);
      const reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      this._listContainer.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
    }

    _computeMatchedAnchorIndex() {
      if (!this._sections.length) return null;

      const marker = this._getHeaderOffsetHeight() + 1;
      let globalIdx = 1;
      for (let i = this._sections.length - 1; i >= 0; i--) {
        const rect = this._sections[i].getBoundingClientRect();
        if (rect && rect.top <= marker) {
          globalIdx = i + 1;
          break;
        }
      }

      // 精确匹配
      if (this._anchorItemMap[globalIdx]) return globalIdx;

      // 找最近的小于等于当前 section index
      let matched = null;
      for (const key of this._anchorKeys) {
        if (key <= globalIdx) matched = key;
      }
      return matched;
    }

    _clearLock() {
      this._lock = null;
      if (this._lockIdleTimer) {
        clearTimeout(this._lockIdleTimer);
        this._lockIdleTimer = null;
      }
      if (this._lockMaxTimer) {
        clearTimeout(this._lockMaxTimer);
        this._lockMaxTimer = null;
      }
      if (this._unbindUserCancel) {
        this._unbindUserCancel();
        this._unbindUserCancel = null;
      }
    }

    _syncActiveByScroll() {
      if (this._lock) return;
      const matched = this._computeMatchedAnchorIndex();
      if (matched !== null && this._anchorItemMap[matched]) this._setActive(this._anchorItemMap[matched]);
    }

    _bindUserIntentCancel() {
      const onUserIntent = () => {
        if (this._lock) this._clearLock();
      };
      const onKeyDown = (ev) => {
        if (!this._lock) return;
        const k = ev && ev.key ? ev.key : '';
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].includes(k)) {
          this._clearLock();
        }
      };
      window.addEventListener('wheel', onUserIntent, { passive: true, capture: true });
      window.addEventListener('touchstart', onUserIntent, { passive: true, capture: true });
      window.addEventListener('pointerdown', onUserIntent, { passive: true, capture: true });
      window.addEventListener('keydown', onKeyDown, true);
      return () => {
        window.removeEventListener('wheel', onUserIntent, true);
        window.removeEventListener('touchstart', onUserIntent, true);
        window.removeEventListener('pointerdown', onUserIntent, true);
        window.removeEventListener('keydown', onKeyDown, true);
      };
    }

    _beginLock() {
      this._clearLock();
      this._lock = true;
      this._unbindUserCancel = this._bindUserIntentCancel();
      this._lockMaxTimer = setTimeout(() => {
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevNavbar.LOCK_MAX_MS);
    }

    _armIdleUnlock() {
      if (this._lockIdleTimer) clearTimeout(this._lockIdleTimer);
      this._lockIdleTimer = setTimeout(() => {
        if (!this._lock) return;
        this._clearLock();
        this._syncActiveByScroll();
      }, NdevNavbar.LOCK_IDLE_MS);
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._ticking = false;
        this._updateStuckState();

        if (this._lock) {
          this._armIdleUnlock();
          return;
        }

        this._syncActiveByScroll();
      });
    }

    // 监听按钮点击（capture 阶段），设置锁定，防止滚动回显覆盖
    _onClickCapture(ev) {
      const target = ev && ev.target ? ev.target : null;
      if (!target || !target.closest) return;
      const btn = target.closest('[data-btn-purpose="scroll"]');
      if (!btn || !this.contains(btn)) return;

      this._setActive(btn);
      this._beginLock();
    }
  }

  if (!customElements.get('ndev-navbar')) {
    customElements.define('ndev-navbar', NdevNavbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-our-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-our-journey')) {
    class NdevOurJourney extends BaseElement {
      init() {
        this.dispose();

        const yearsContainer = this.querySelector('.ndev-our-journey__years');
        const cardsContainer = this.querySelector('.ndev-our-journey__cards');
        if (!yearsContainer || !cardsContainer) return;

        const cards = Array.from(cardsContainer.querySelectorAll('.ndev-our-journey__card'));
        const yearItems = Array.from(yearsContainer.querySelectorAll('.ndev-our-journey__year'));
        const indicatorItems = Array.from(this.querySelectorAll('.ndev-our-journey__indicator'));
        if (cards.length === 0) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const enableAnimation = this.getAttribute('enable-animation') === 'true' && !reduceMotion;
        const scrollBehavior = enableAnimation ? 'smooth' : 'auto';

        // 初始事件由 Liquid 输出的 is-active 决定
        let currentIndex = Math.max(
          0,
          cards.findIndex((card) => card.classList.contains('is-active'))
        );
        let isScrolling = false;
        // 相邻卡片的滚动步长（卡片等宽：PC 为卡宽，M 为卡宽 + gap）；对齐某卡时 scrollLeft = index * step
        let cardStep = 0;

        this._ac = new AbortController();
        const { signal } = this._ac;

        const measure = () => {
          cardStep =
            cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        };

        const setCurrent = (index, isCurrent) => {
          cards[index]?.classList.toggle('is-active', isCurrent);
          [yearItems[index], indicatorItems[index]].forEach((item) => {
            if (!item) return;
            item.classList.toggle('is-active', isCurrent);
            if (isCurrent) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });
        };

        const yearScrollLeft = (index) => {
          const item = yearItems[index];
          if (!item) return null;
          return Math.max(0, item.offsetLeft - yearsContainer.offsetWidth / 2 + item.offsetWidth / 2);
        };

        // 先读几何、再写 class、最后滚动，避免强制同步布局
        const activate = (index, behavior, scrollCards) => {
          if (!cardStep) measure();
          const yearLeft = yearScrollLeft(index);
          setCurrent(currentIndex, false);
          setCurrent(index, true);
          currentIndex = index;
          if (scrollCards) cardsContainer.scrollTo({ left: index * cardStep, behavior });
          if (yearLeft !== null) yearsContainer.scrollTo({ left: yearLeft, behavior });
        };

        const goToIndex = (index) => {
          if (index === currentIndex && !isScrolling) return;
          isScrolling = true;
          activate(index, scrollBehavior, true);

          clearTimeout(this._scrollTimer);
          this._scrollTimer = setTimeout(
            () => {
              isScrolling = false;
            },
            enableAnimation ? 500 : 100
          );
        };

        yearItems.concat(indicatorItems).forEach((control) => {
          control.addEventListener(
            'click',
            () => {
              const index = parseInt(control.getAttribute('data-index'), 10);
              if (!isNaN(index)) goToIndex(index);
            },
            { signal }
          );
        });

        cardsContainer.addEventListener(
          'scroll',
          () => {
            if (isScrolling) return;
            if (!cardStep) measure();
            if (!cardStep) return;
            const index = Math.min(
              cards.length - 1,
              Math.max(0, Math.round(cardsContainer.scrollLeft / cardStep))
            );
            if (index !== currentIndex) activate(index, scrollBehavior, false);
          },
          { passive: true, signal }
        );

        window.addEventListener(
          'resize',
          () => {
            if (this._raf) return;
            this._raf = requestAnimationFrame(() => {
              this._raf = 0;
              measure();
            });
          },
          { passive: true, signal }
        );

        // 升级后全部卡片进入横向滚动，下一帧无动画对齐到默认事件；默认是第一个时已对齐
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          measure();
          if (currentIndex === 0) return;
          cardsContainer.scrollTo({ left: currentIndex * cardStep, behavior: 'auto' });
          const yearLeft = yearScrollLeft(currentIndex);
          if (yearLeft !== null) yearsContainer.scrollTo({ left: yearLeft, behavior: 'auto' });
        });
      }

      dispose() {
        clearTimeout(this._scrollTimer);
        cancelAnimationFrame(this._raf);
        this._raf = 0;
        this._ac?.abort();
        this._ac = null;
      }
    }

    customElements.define('ndev-our-journey', NdevOurJourney);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-product-compare-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-product-compare-table';
    const ROOT_SELECTOR = '[data-ndev-product-compare-table]';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    const raf2 = (fn) => {
      if (typeof window.requestAnimationFrame !== 'function') {
        window.setTimeout(fn, 0);
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    };

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    function isSwiperAvailable() {
      return typeof window.Swiper !== 'undefined';
    }

    function getGroupSize(swiper) {
      const size = parseInt(swiper?.params?.slidesPerGroup || '1', 10);
      return Number.isFinite(size) && size > 0 ? size : 1;
    }

    function getPageCount(total, groupSize) {
      if (!total || total < 1) return 1;
      const gs = groupSize > 0 ? groupSize : 1;
      return Math.max(1, Math.ceil(total / gs));
    }

    function getMaxStart(total, groupSize) {
      const gs = groupSize > 0 ? groupSize : 1;
      return Math.max(0, (total || 0) - gs);
    }

    function startForPage(pageIndex, total, groupSize) {
      const pageCount = getPageCount(total, groupSize);
      const maxStart = getMaxStart(total, groupSize);
      const idx = clamp(pageIndex || 0, 0, pageCount - 1);
      if (idx >= pageCount - 1) return maxStart;
      return clamp(idx * groupSize, 0, maxStart);
    }

    function pageForStart(start, total, groupSize) {
      const pageCount = getPageCount(total, groupSize);
      const maxStart = getMaxStart(total, groupSize);
      if (start >= maxStart) return pageCount - 1;
      return Math.floor(start / groupSize);
    }

    function buildPagination(paginationEl, pageCount) {
      if (!paginationEl) return;
      paginationEl.innerHTML = '';
      if (!pageCount || pageCount < 2) return;
      for (let i = 0; i < pageCount; i++) {
        const seg = document.createElement('span');
        seg.className = 'ndev-pctable__page-seg';
        seg.setAttribute('data-page-index', String(i));
        seg.setAttribute('role', 'button');
        seg.setAttribute('tabindex', '0');
        seg.setAttribute('aria-label', 'Go to page ' + String(i + 1));
        paginationEl.appendChild(seg);
      }
    }

    function setActivePagination(paginationEl, activeIndex) {
      if (!paginationEl) return;
      const segs = paginationEl.querySelectorAll('[data-page-index]');
      segs.forEach((seg) => {
        const isActive = seg.getAttribute('data-page-index') === String(activeIndex);
        seg.classList.toggle('is-active', isActive);
      });
    }

    function ensureRowCells(root, totalProducts) {
      if (!root || !totalProducts || totalProducts < 1) return;
      const blankAsCross = root.closest(ROOT_SELECTOR)?.getAttribute('data-blank-as-cross') === '1';

      root.querySelectorAll('[data-ndev-pctable-row]').forEach((row) => {
        const cells = Array.from(row.querySelectorAll('[data-ndev-pctable-cell]'));
        const missing = totalProducts - cells.length;
        if (missing > 0) {
          for (let i = 0; i < missing; i++) {
            const cell = document.createElement('div');
            cell.className = 'ndev-product-compare-table__cell ndev-product-compare-table__cell--blank';
            cell.setAttribute('data-ndev-pctable-cell', '1');
            cell.setAttribute('data-cell-type', blankAsCross ? 'cross' : 'blank');
            cell.innerHTML = blankAsCross ? '<span class="ndev-product-compare-table__icon is-cross" aria-hidden="true"></span>' : '';
            row.appendChild(cell);
          }
        }

        const finalCells = Array.from(row.querySelectorAll('[data-ndev-pctable-cell]'));
        finalCells.forEach((cell, idx) => cell.setAttribute('data-col-index', String(idx)));
      });
    }

    function syncVisibleColumns(root, visibleIndexes, visibleCount) {
      if (!root) return;
      const set = new Set(visibleIndexes.map((n) => String(n)));

      root.style.setProperty('--ndev-pctable-visible-cols', String(visibleCount));
      root.style.setProperty('--ndev-pctable-cols', String((visibleCount || 0) + 1));

      root.querySelectorAll('[data-ndev-pctable-row]').forEach((row) => {
        row.querySelectorAll('[data-ndev-pctable-cell]').forEach((cell) => {
          const idx = cell.getAttribute('data-col-index');
          const show = idx != null && set.has(String(idx));
          cell.classList.toggle('is-hidden', !show);
        });
      });

      if (!root.classList.contains('is-ready')) root.classList.add('is-ready');
    }

    function initCompareRoot(sectionRoot, compareRoot) {
      const swiperEl = compareRoot.querySelector('[data-ndev-pctable-swiper]');
      const paginationEl = compareRoot.querySelector('[data-ndev-pctable-pagination]');
      if (!swiperEl) return null;
      const slidesStatic = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const totalStatic = slidesStatic.length;

      const getStaticVisibleCount = () => (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches ? 3 : 2);

      // Swiper 不存在时：降级为“静态首屏列展示”，避免表格网格错乱
      if (!isSwiperAvailable()) {
        ensureRowCells(compareRoot, totalStatic);

        const apply = () => {
          const visibleCount = Math.min(getStaticVisibleCount(), totalStatic || getStaticVisibleCount());
          const visible = [];
          for (let i = 0; i < visibleCount; i++) visible.push(i);
          const pageCount = visibleCount > 0 ? Math.ceil((totalStatic || 0) / visibleCount) : 1;
          buildPagination(paginationEl, pageCount);
          setActivePagination(paginationEl, 0);
          syncVisibleColumns(compareRoot, visible, visible.length);
        };

        apply();

        const onResize = () => apply();
        window.addEventListener('resize', onResize);

        return {
          destroy: () => {
            try {
              window.removeEventListener('resize', onResize);
            } catch (e) {}
          },
        };
      }

      const readGap = () => {
        try {
          const v = window.getComputedStyle(compareRoot).getPropertyValue('--ndev-pctable-gap').trim();
          const n = parseFloat(v);
          return Number.isFinite(n) && n > 0 ? n : 20;
        } catch (e) {
          return 20;
        }
      };

      const gap = readGap();

      // 注意：Swiper 的 init 回调可能在构造时同步触发，
      // 因此所有会在回调里访问的变量必须在 new Swiper() 之前完成初始化（避免 TDZ）。
      let isSyncing = false;

      function syncFromSwiper(sw) {
        if (!sw || isSyncing) return;
        isSyncing = true;

        try {
          const total = sw.slides ? sw.slides.length : 0;
          const perViewRaw = sw?.params?.slidesPerView;
          const perView = parseInt(String(perViewRaw || '1'), 10) || 1;
          const maxStart = Math.max(0, total - perView);
          const start = clamp(sw.activeIndex || 0, 0, maxStart);

          ensureRowCells(compareRoot, total);

          const visible = [];
          for (let i = 0; i < perView; i++) {
            const v = start + i;
            if (v < total) visible.push(v);
          }
          syncVisibleColumns(compareRoot, visible, visible.length);
        } finally {
          isSyncing = false;
        }
      }

      paginationEl.setAttribute('data-page-count', String(totalStatic));

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        spaceBetween: gap,
        speed: 300,
        watchOverflow: true,
        resistanceRatio: 0.85,
        freeMode: false,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              bulletClass: 'ndev-pctable__page-seg',
              bulletActiveClass: 'is-active',
              renderBullet: function (index, className) {
                return `<span class="${className}" role="button" tabindex="0" aria-label="Go to page ${index + 1}"></span>`;
              },
            }
          : undefined,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: gap,
          },
        },
        on: {
          init: function () {
            syncFromSwiper(this);
          },
          slideChangeTransitionEnd: function () {
            syncFromSwiper(this);
          },
          transitionEnd: function () {
            syncFromSwiper(this);
          },
          breakpoint: function () {
            syncFromSwiper(this);
          },
          resize: function () {
            syncFromSwiper(this);
          },
        },
      });

      // 首次强制同步（避免 swiper init 前后闪动）
      raf2(() => {
        try {
          swiper.update();
          syncFromSwiper(swiper);
        } catch (e) {}
      });

      return {
        destroy: () => {
          try {
            swiper?.destroy?.(true, true);
          } catch (e) {}
        },
      };
    }

    function destroyOne(sectionRoot) {
      const controller = sectionRoot ? controllers.get(sectionRoot) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (sectionRoot) controllers.delete(sectionRoot);
    }

    function initOne(sectionRoot) {
      if (!sectionRoot) return;
      destroyOne(sectionRoot);

      const compareRoots = Array.from(sectionRoot.querySelectorAll('[data-ndev-pctable-root]'));
      const cleanups = [];

      compareRoots.forEach((compareRoot) => {
        const inst = initCompareRoot(sectionRoot, compareRoot);
        if (!inst) return;
        cleanups.push(() => {
          try {
            inst.destroy?.();
          } catch (e) {}
        });
      });

      controllers.set(sectionRoot, {
        destroy: () => {
          cleanups.forEach((fn) => {
            try {
              fn();
            } catch (e) {}
          });
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event?.target || null));
    document.addEventListener('shopify:section:unload', (event) => destroyAll(event?.target || null));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-product-compare-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-product-compare-tabs';
    const ROOT_SELECTOR = '[data-ndev-product-compare-tabs]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const compareRoots = Array.prototype.slice.call(root.querySelectorAll('[data-ndev-pct-tabs-root]'));
      const cleanups = [];

      function initCompare(compareRoot) {
        const tabWrap = compareRoot.querySelector('.ndev-pct__tabs');
        const track = compareRoot.querySelector('.ndev-pct__indicator-track');
        const indicator = compareRoot.querySelector('[data-ndev-pct-indicator]');
        const panelsWrap = compareRoot.querySelector('[data-ndev-pct-panels]');
        if (!tabWrap || !track || !indicator || !panelsWrap) return;

        const panels = Array.prototype.slice.call(panelsWrap.querySelectorAll('[data-ndev-pct-panel]'));
        const tabs = [];
        const blankAsCross = root.getAttribute('data-blank-as-cross') === '1';

        // 从每个 panel 内提取 tab button，塞入 tablist
        for (var i = 0; i < panels.length; i++) {
          const panel = panels[i];
          const btn = panel.querySelector('[data-ndev-pct-tab-btn]');
          if (!btn) continue;
          tabWrap.appendChild(btn);
          tabs.push(btn);
        }

        function ensureRowCells(panel, cols) {
          if (!cols || cols < 1) return;
          const rows = panel.querySelectorAll('[data-ndev-pct-row]');
          for (var r = 0; r < rows.length; r++) {
            const row = rows[r];
            const cells = row.querySelectorAll('.ndev-pct__cell');
            const missing = cols - cells.length;
            if (missing <= 0) continue;
            for (var m = 0; m < missing; m++) {
              const cell = document.createElement('div');
              cell.className = 'ndev-pct__cell';
              cell.setAttribute('data-ndev-pct-cell', '1');
              cell.textContent = blankAsCross ? '×' : '';
              row.appendChild(cell);
            }
          }
        }

        // 标号 + a11y + cols
        for (var j = 0; j < tabs.length; j++) {
          const idx = String(j + 1);
          const blockId = compareRoot.getAttribute('data-block-id') || 'root';
          const tabId = 'ndev-pct-tab-' + root.getAttribute('data-section-id') + '-' + blockId + '-' + idx;
          const panelId = 'ndev-pct-panel-' + root.getAttribute('data-section-id') + '-' + blockId + '-' + idx;

          tabs[j].setAttribute('data-ndev-pct-tab', idx);
          tabs[j].setAttribute('role', 'tab');
          tabs[j].setAttribute('id', tabId);
          tabs[j].setAttribute('aria-controls', panelId);

          panels[j].setAttribute('data-ndev-pct-panel', idx);
          panels[j].setAttribute('role', 'tabpanel');
          panels[j].setAttribute('id', panelId);
          panels[j].setAttribute('aria-labelledby', tabId);

          var productCount = panels[j].querySelectorAll('[data-ndev-pct-product]').length;
          if (!productCount || productCount < 1) productCount = 1;

          var mbMinCols = parseInt(root.getAttribute('data-mb-min-cols') || '1', 10);
          var mbCols = Math.max(productCount, mbMinCols);

          panels[j].style.setProperty('--pct-cols', String(productCount));
          panels[j].style.setProperty('--pct-mb-cols', String(mbCols));
          panels[j].setAttribute('data-cols', String(productCount));
          ensureRowCells(panels[j], productCount);
        }

        function setIndicatorTo(btn) {
          if (!btn) return;
          const trackRect = track.getBoundingClientRect();
          const btnRect = btn.getBoundingClientRect();
          const left = btnRect.left - trackRect.left;
          indicator.style.width = btnRect.width + 'px';
          indicator.style.transform = 'translateX(' + left + 'px)';
        }

        function setActive(indexStr) {
          const index = String(indexStr);
          for (var k = 0; k < tabs.length; k++) {
            const isActive = tabs[k].getAttribute('data-ndev-pct-tab') === index;
            tabs[k].classList.toggle('is-active', isActive);
            tabs[k].setAttribute('aria-selected', isActive ? 'true' : 'false');
            if (isActive) setIndicatorTo(tabs[k]);
          }
          for (var m = 0; m < panels.length; m++) {
            const isActivePanel = panels[m].getAttribute('data-ndev-pct-panel') === index;
            panels[m].classList.toggle('is-active', isActivePanel);
          }
        }

        function onClick(e) {
          const btn = e.target && e.target.closest ? e.target.closest('[data-ndev-pct-tab]') : null;
          if (!btn || !compareRoot.contains(btn)) return;
          e.preventDefault();
          setActive(btn.getAttribute('data-ndev-pct-tab'));
        }

        function onResize() {
          const active = compareRoot.querySelector('[data-ndev-pct-tab].is-active') || tabs[0];
          if (active) setIndicatorTo(active);
        }

        if (tabs.length) {
          compareRoot.addEventListener('click', onClick);
          window.addEventListener('resize', onResize);
          cleanups.push(function () {
            try { compareRoot.removeEventListener('click', onClick); } catch (e) {}
            try { window.removeEventListener('resize', onResize); } catch (e) {}
          });

          const defaultTab = root.getAttribute('data-default-tab') || '1';
          setActive(defaultTab);
          onResize();
        }
      }

      for (var r = 0; r < compareRoots.length; r++) initCompare(compareRoots[r]);

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          for (var i = 0; i < cleanups.length; i++) {
            try { cleanups[i](); } catch (e) {}
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-scroll-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-scroll-gallery')) {
    class NdevScrollGallery extends BaseElement {
      init() {
        if (this.initialized) this.dispose();
        this.initialized = true;
        this.track = this.querySelector('.ndev-scroll-gallery__track');
        this.viewport = this.querySelector('.ndev-scroll-gallery__viewport');
        this.rail = this.querySelector('.ndev-scroll-gallery__rail');
        this.cards = Array.from(this.querySelectorAll('.ndev-scroll-gallery-item'));
        this.segments = Array.from(this.querySelectorAll('.ndev-scroll-gallery__progress-segment'));
        this.images = Array.from(this.querySelectorAll('.ndev-scroll-gallery-item img'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.modeFrame = 0;
        this.isNear = false;
        this.isListening = false;
        this.animationEnabled = false;
        this.inObserverRange = false;
        this.measureDirty = true;
        this.maxDesktopTravel = 0;
        this.activeIndex = -1;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);
        this.onMediaLoad = this.handleMediaLoad.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);
        this.images.forEach((image) => image.addEventListener('load', this.onMediaLoad, { passive: true }));

        if (!this.cards.length) return;

        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this._mq.matches && !this.animationEnabled) return;
            this.measureDirty = true;
            this.scheduleModeSync();
          });
          this.resizeObserver.observe(this.rail);
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inObserverRange = entries.some((entry) => entry.isIntersecting);
            this.setNear(this.inObserverRange);
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.inObserverRange = true;
        }

        this.syncAnimatedMode();
      }

      dispose() {
        if (!this.initialized) return;
        this.setListening(false);
        this.setNear(false);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.images) {
          this.images.forEach((image) => image.removeEventListener('load', this.onMediaLoad));
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.modeFrame) cancelAnimationFrame(this.modeFrame);
        this.frame = 0;
        this.modeFrame = 0;
        this.clearVisualState();
        this.animationEnabled = false;
        this.initialized = false;
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      syncAnimatedMode() {
        const motionAllowed = this.cards.length > 1 && !this.reducedMotion.matches;
        let shouldAnimate = motionAllowed;

        if (motionAllowed && this._mq.matches) {
          this.classList.add('is-ready');
          this.measureDirty = true;
          this.measure();
          shouldAnimate = this.maxDesktopTravel > 0;
        }

        this.animationEnabled = shouldAnimate;
        this.classList.toggle('is-ready', shouldAnimate);

        if (!shouldAnimate) {
          this.setListening(false);
          this.clearVisualState();
          return;
        }

        this.measureDirty = true;
        this.setNear(this.inObserverRange);
      }

      setNear(near) {
        if (near) this.prewarmAround(Math.max(0, this.activeIndex));
        this.isNear = near;
        this.setListening(near && this.animationEnabled);
        if (near) this.requestUpdate();
      }

      setListening(listen) {
        if (this.isListening === listen) return;
        this.isListening = listen;

        if (listen) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }

      handleResize() {
        this.measureDirty = true;
        this.scheduleModeSync();
      }

      handleMediaLoad() {
        this.measureDirty = true;
        this.scheduleModeSync();
      }

      handleModeChange() {
        this.measureDirty = true;
        this.syncAnimatedMode();
      }

      handleBlockSelect(event) {
        if (!this.animationEnabled || !(event.target instanceof Element)) return;
        const selectedCard = event.target.closest('.ndev-scroll-gallery-item');
        if (!selectedCard || !this.contains(selectedCard)) return;

        const cardIndex = this.cards.indexOf(selectedCard);
        const maxIndex = this.cards.length - 1;
        if (cardIndex < 0 || maxIndex < 1) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = Number.parseFloat(getComputedStyle(this.viewport).top) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const targetProgress = cardIndex / maxIndex;
        const trackTop = window.scrollY + trackRect.top;

        window.scrollTo({
          top: trackTop - reservedTop + scrollDistance * targetProgress,
          behavior: 'auto',
        });
        this.requestUpdate();
      }

      scheduleModeSync() {
        if (this.modeFrame) return;
        this.modeFrame = requestAnimationFrame(() => {
          this.modeFrame = 0;
          this.syncAnimatedMode();
        });
      }

      requestUpdate() {
        if (this.frame || !this.classList.contains('is-ready')) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || !this.rail || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const windowHeight = window.innerHeight || 1;
        if (trackRect.bottom < -windowHeight || trackRect.top > windowHeight * 2) return;

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = Number.parseFloat(getComputedStyle(this.viewport).top) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const linearProgress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);

        if (this.measureDirty) this.measure();

        if (this._mq.matches) {
          this.applyDesktopProgress(linearProgress);
          this.setActiveIndex(Math.round(linearProgress * (this.cards.length - 1)));
        } else {
          const sceneProgress = this.getMobileSceneProgress(linearProgress);
          this.applyMobileProgress(sceneProgress);
          this.setActiveIndex(Math.round(sceneProgress));
        }
      }

      measure() {
        const viewportWidth = this.viewport.getBoundingClientRect().width || window.innerWidth || 1;
        this.maxDesktopTravel = Math.max(0, this.rail.scrollWidth - viewportWidth);
        this.measureDirty = false;
      }

      getMobileSceneProgress(linearProgress) {
        const maxIndex = Math.max(0, this.cards.length - 1);
        const rawStep = linearProgress * maxIndex;
        const stepIndex = Math.min(maxIndex, Math.floor(rawStep));
        if (stepIndex >= maxIndex) return maxIndex;

        const fraction = rawStep - stepIndex;
        const heldFraction = this.clamp((fraction - 0.1) / 0.8, 0, 1);
        const easedFraction = 0.5 - Math.cos(Math.PI * heldFraction) / 2;
        return stepIndex + easedFraction;
      }

      applyDesktopProgress(linearProgress) {
        const offset = -this.maxDesktopTravel * linearProgress;
        this.rail.style.transform = `translate3d(${offset.toFixed(2)}px, 0, 0)`;
      }

      applyMobileProgress(sceneProgress) {
        this.rail.style.transform = '';
        this.cards.forEach((card, index) => {
          const reveal = index === 0 ? 1 : this.clamp(sceneProgress - index + 1, 0, 1);
          const shade = this.clamp(sceneProgress - index, 0, 1) * 0.75;
          card.style.setProperty('--ndev-scroll-gallery-stack-x', `${((1 - reveal) * 100).toFixed(3)}%`);
          card.style.setProperty('--ndev-scroll-gallery-shade', shade.toFixed(4));
        });
      }

      setActiveIndex(index) {
        const nextIndex = this.clamp(index, 0, Math.max(0, this.cards.length - 1));
        if (this.activeIndex === nextIndex) return;
        this.activeIndex = nextIndex;
        this.segments.forEach((segment, segmentIndex) => {
          segment.classList.toggle('is-active', segmentIndex === nextIndex);
        });
        this.prewarmAround(nextIndex);
      }

      prewarmAround(index) {
        const imageSelector = this._mq.matches
          ? 'img.show-pc[loading="lazy"]'
          : 'img.show-mb[loading="lazy"]';
        [index, index + 1].forEach((cardIndex) => {
          const card = this.cards[cardIndex];
          if (!card) return;
          card.querySelectorAll(imageSelector).forEach((image) => {
            image.loading = 'eager';
            image.fetchPriority = 'low';
          });
        });
      }

      clearVisualState() {
        if (this.rail) this.rail.style.transform = '';
        if (this.cards) {
          this.cards.forEach((card) => {
            card.style.removeProperty('--ndev-scroll-gallery-stack-x');
            card.style.removeProperty('--ndev-scroll-gallery-shade');
          });
        }
        if (this.segments) {
          this.segments.forEach((segment) => segment.classList.remove('is-active'));
        }
        this.activeIndex = -1;
      }
    }

    customElements.define('ndev-scroll-gallery', NdevScrollGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-site-header"] && !Shopify.designMode) return;
  try {
    
  class NdevSiteHeader extends BaseElement {
    init() {
      this.dispose();
      this._rafId = null;
      this._drawerFocusRafId = null;
      this._cartLinkFocusRafId = null;
      this._searchFocusRafId = null;
      this._navFocusRafId = null;
      this._navResizeRafId = null;
      this._searchDebounceId = null;
      this._searchAbortController = null;
      this._searchRequestSequence = 0;
      this._cartLink = this.querySelector('.header-cart-link');
      this._cartDrawer = document.getElementById('header-cart');
      this._searchTrigger = this.querySelector('.ndev-site-header__search-trigger');
      this._searchPanel = this.querySelector('.ndev-site-header__search-panel');
      this._searchOverlay = this.querySelector('.ndev-site-header__search-overlay');
      this._searchClose = this.querySelector('.ndev-site-header__search-close');
      this._searchForm = this.querySelector('.ndev-site-header__search-form');
      this._searchInput = this.querySelector('.ndev-site-header__search-input');
      this._searchClear = this.querySelector('.ndev-site-header__search-clear');
      this._searchSuggestions = this.querySelector('.ndev-site-header__suggestions');
      this._searchResults = this.querySelector('.ndev-site-header__suggestion-list');
      this._searchStatus = this.querySelector('.ndev-site-header__search-status');
      this._navList = this.querySelector('.site-header-nav-list');
      this._navTrigger = this.querySelector('.ndev-site-header__menu-trigger');
      this._countrySelectorTrigger = this.querySelector('.site-header-nav-list__country-trigger');
      this._navOverlay = this._navList?.querySelector('.site-header-nav-list__overlay');
      this._navGroups = this._navList ? Array.from(this._navList.querySelectorAll('.site-header-nav-grouped-link__details')) : [];
      this._navGroupItems = this._navGroups
        .map((details) => details.closest('.site-header-nav-grouped-link'))
        .filter(Boolean);
      this._navMediaQuery = window.matchMedia('(min-width: 1024px)');
      const searchLabel = this._searchPanel?.getAttribute('search-label');
      const searchCloseLabel = this._searchPanel?.getAttribute('search-close-label');
      if (searchLabel) {
        this._searchTrigger?.setAttribute('aria-label', searchLabel);
        this._searchTrigger?.setAttribute('title', searchLabel);
      }
      if (searchCloseLabel) this._searchClose?.setAttribute('aria-label', searchCloseLabel);
      const navOpenLabel = this._navList?.getAttribute('open-label');
      const navCloseLabel = this._navList?.getAttribute('close-label');
      if (navOpenLabel) {
        this._navTrigger?.setAttribute('aria-label', navOpenLabel);
        this._navTrigger?.setAttribute('data-open-label', navOpenLabel);
      }
      if (navCloseLabel) this._navTrigger?.setAttribute('data-close-label', navCloseLabel);
      this._drawerWasOpen = this._isDrawerOpen();
      this._navWasOpen = false;
      this._shouldFocusDrawer = false;
      this._suppressCartFocusRestore = false;
      this._lastSearchTrigger = null;
      this._lastNavTrigger = null;
      this._activeSuggestionIndex = -1;
      this._onScroll = this._handleScroll.bind(this);
      this._onCartClick = this._handleCartClick.bind(this);
      this._onDocumentKeydown = this._handleDocumentKeydown.bind(this);
      this._onSearchTriggerClick = this._handleSearchTriggerClick.bind(this);
      this._onSearchOverlayClick = this._handleSearchOverlayClick.bind(this);
      this._onSearchCloseClick = this._handleSearchCloseClick.bind(this);
      this._onSearchInput = this._handleSearchInput.bind(this);
      this._onSearchClearClick = this._handleSearchClearClick.bind(this);
      this._onNavTriggerClick = this._handleNavTriggerClick.bind(this);
      this._onCountrySelectorClick = this._handleCountrySelectorClick.bind(this);
      this._onNavOverlayClick = this._handleNavOverlayClick.bind(this);
      this._onNavClick = this._handleNavClick.bind(this);
      this._onNavToggle = this._handleNavToggle.bind(this);
      this._onNavPointerOver = this._handleNavPointerOver.bind(this);
      this._onNavPointerOut = this._handleNavPointerOut.bind(this);
      this._onNavFocusIn = this._handleNavFocusIn.bind(this);
      this._onNavFocusOut = this._handleNavFocusOut.bind(this);
      this._onNavMediaChange = this._syncNavViewport.bind(this);
      this._onNavResize = this._handleNavResize.bind(this);
      this._onThemeBlockSelect = this._handleThemeBlockSelect.bind(this);
      this._onThemeBlockDeselect = this._handleThemeBlockDeselect.bind(this);
      this._onDocumentClick = this._handleDocumentClick.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._cartLink?.addEventListener('click', this._onCartClick);
      this._searchTrigger?.addEventListener('click', this._onSearchTriggerClick);
      this._searchOverlay?.addEventListener('click', this._onSearchOverlayClick);
      this._searchClose?.addEventListener('click', this._onSearchCloseClick);
      this._searchInput?.addEventListener('input', this._onSearchInput);
      this._searchClear?.addEventListener('click', this._onSearchClearClick);
      this._navTrigger?.addEventListener('click', this._onNavTriggerClick);
      this._countrySelectorTrigger?.addEventListener('click', this._onCountrySelectorClick, true);
      this._navOverlay?.addEventListener('click', this._onNavOverlayClick);
      this._navList?.addEventListener('click', this._onNavClick);
      this._navList?.addEventListener('toggle', this._onNavToggle, true);
      this._navGroupItems.forEach((item) => {
        item.addEventListener('pointerenter', this._onNavPointerOver);
        item.addEventListener('pointerleave', this._onNavPointerOut);
      });
      this._navList?.addEventListener('focusin', this._onNavFocusIn);
      this._navList?.addEventListener('focusout', this._onNavFocusOut);
      this._navMediaQuery.addEventListener('change', this._onNavMediaChange);
      window.addEventListener('resize', this._onNavResize, { passive: true });
      this.addEventListener('shopify:block:select', this._onThemeBlockSelect);
      this.addEventListener('shopify:block:deselect', this._onThemeBlockDeselect);
      document.addEventListener('keydown', this._onDocumentKeydown);
      document.addEventListener('click', this._onDocumentClick);

      if (this._cartDrawer) {
        this._drawerObserver = new MutationObserver(() => this._syncDrawerState());
        this._drawerObserver.observe(this._cartDrawer, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
        });
      }

      this._syncScrollState();
      if (this._navList) {
        this._navGroups.forEach((details) => {
          details.open = false;
        });
        this._syncNavViewport();
      }
      this._syncDrawerState();
    }

    dispose() {
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
      }
      if (this._cartLink && this._onCartClick) {
        this._cartLink.removeEventListener('click', this._onCartClick);
      }
      if (this._searchTrigger && this._onSearchTriggerClick) {
        this._searchTrigger.removeEventListener('click', this._onSearchTriggerClick);
      }
      if (this._searchOverlay && this._onSearchOverlayClick) {
        this._searchOverlay.removeEventListener('click', this._onSearchOverlayClick);
      }
      if (this._searchClose && this._onSearchCloseClick) {
        this._searchClose.removeEventListener('click', this._onSearchCloseClick);
      }
      if (this._searchInput && this._onSearchInput) {
        this._searchInput.removeEventListener('input', this._onSearchInput);
      }
      if (this._searchClear && this._onSearchClearClick) {
        this._searchClear.removeEventListener('click', this._onSearchClearClick);
      }
      this._navTrigger?.removeEventListener('click', this._onNavTriggerClick);
      this._countrySelectorTrigger?.removeEventListener('click', this._onCountrySelectorClick, true);
      this._navOverlay?.removeEventListener('click', this._onNavOverlayClick);
      this._navList?.removeEventListener('click', this._onNavClick);
      this._navList?.removeEventListener('toggle', this._onNavToggle, true);
      this._navGroupItems?.forEach((item) => {
        item.removeEventListener('pointerenter', this._onNavPointerOver);
        item.removeEventListener('pointerleave', this._onNavPointerOut);
      });
      this._navList?.removeEventListener('focusin', this._onNavFocusIn);
      this._navList?.removeEventListener('focusout', this._onNavFocusOut);
      this._navMediaQuery?.removeEventListener('change', this._onNavMediaChange);
      if (this._onNavResize) {
        window.removeEventListener('resize', this._onNavResize);
      }
      if (this._onThemeBlockSelect) {
        this.removeEventListener('shopify:block:select', this._onThemeBlockSelect);
      }
      if (this._onThemeBlockDeselect) {
        this.removeEventListener('shopify:block:deselect', this._onThemeBlockDeselect);
      }
      if (this._onDocumentKeydown) {
        document.removeEventListener('keydown', this._onDocumentKeydown);
      }
      if (this._onDocumentClick) {
        document.removeEventListener('click', this._onDocumentClick);
      }
      this._drawerObserver?.disconnect();
      if (this._rafId !== null && this._rafId !== undefined) {
        window.cancelAnimationFrame(this._rafId);
      }
      if (this._drawerFocusRafId !== null && this._drawerFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._drawerFocusRafId);
      }
      if (this._cartLinkFocusRafId !== null && this._cartLinkFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._cartLinkFocusRafId);
      }
      if (this._searchFocusRafId !== null && this._searchFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._searchFocusRafId);
      }
      if (this._navFocusRafId !== null && this._navFocusRafId !== undefined) {
        window.cancelAnimationFrame(this._navFocusRafId);
      }
      if (this._navResizeRafId !== null && this._navResizeRafId !== undefined) {
        window.cancelAnimationFrame(this._navResizeRafId);
      }
      if (this._searchDebounceId !== null && this._searchDebounceId !== undefined) {
        window.clearTimeout(this._searchDebounceId);
      }
      this._searchAbortController?.abort();
      this._closeNav({ restoreFocus: false });
      this._syncNavLayerState({ forceInactive: true });
      this.classList.remove('is-theme-editor-nav-active');
      this._navList?.style.removeProperty('--site-header-nav-panel-top');
      this._searchPanel?.setAttribute('inert', '');
      this._searchPanel?.setAttribute('aria-hidden', 'true');
      if (this._searchPanel) this._searchPanel.hidden = true;
      if (this._searchOverlay) this._searchOverlay.hidden = true;
      if (this._searchClose) this._searchClose.hidden = true;
      this._searchTrigger?.setAttribute('aria-expanded', 'false');
      this.closest('.site-header-section')?.classList.remove('is-search-open');
      this.classList.remove('is-search-open');
      this.classList.remove('is-nav-open');
      document.body.classList.remove('ndev-site-search-open');
      document.body.classList.remove('ndev-site-nav-open');
      this.classList.remove('is-scrolled');
      this._rafId = null;
      this._drawerFocusRafId = null;
      this._cartLinkFocusRafId = null;
      this._searchFocusRafId = null;
      this._navFocusRafId = null;
      this._navResizeRafId = null;
      this._searchDebounceId = null;
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._cartLink = null;
      this._cartDrawer = null;
      this._searchTrigger = null;
      this._searchPanel = null;
      this._searchOverlay = null;
      this._searchClose = null;
      this._searchForm = null;
      this._searchInput = null;
      this._searchClear = null;
      this._searchSuggestions = null;
      this._searchResults = null;
      this._searchStatus = null;
      this._navList = null;
      this._navTrigger = null;
      this._countrySelectorTrigger = null;
      this._navOverlay = null;
      this._navGroups = null;
      this._navGroupItems = null;
      this._navMediaQuery = null;
      this._drawerObserver = null;
      this._drawerWasOpen = false;
      this._navWasOpen = false;
      this._shouldFocusDrawer = false;
      this._lastNavTrigger = null;
      this._selectedThemeNavBlock = null;
      this._onScroll = null;
      this._onCartClick = null;
      this._onDocumentKeydown = null;
      this._onSearchTriggerClick = null;
      this._onSearchOverlayClick = null;
      this._onSearchCloseClick = null;
      this._onSearchInput = null;
      this._onSearchClearClick = null;
      this._onNavTriggerClick = null;
      this._onCountrySelectorClick = null;
      this._onNavOverlayClick = null;
      this._onNavClick = null;
      this._onNavToggle = null;
      this._onNavPointerOver = null;
      this._onNavPointerOut = null;
      this._onNavFocusIn = null;
      this._onNavFocusOut = null;
      this._onNavMediaChange = null;
      this._onNavResize = null;
      this._onThemeBlockSelect = null;
      this._onThemeBlockDeselect = null;
      this._onDocumentClick = null;
    }

    _handleThemeBlockSelect(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this._navList?.contains(target)) return;

      this.classList.add('is-theme-editor-nav-active');
      this._selectedThemeNavBlock = target;

      const group = target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;

      details.open = true;
      if (this._navMediaQuery?.matches) this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleThemeBlockDeselect(event) {
      const target = event.target;
      if (!(target instanceof Element) || !this._navList?.contains(target)) return;
      if (target !== this._selectedThemeNavBlock) return;

      this._selectedThemeNavBlock = null;
      this.classList.remove('is-theme-editor-nav-active');
    }

    _handleNavTriggerClick(event) {
      if (!this._navList || this._navMediaQuery?.matches) return;

      event.preventDefault();
      this._setNavOpen(!this._isNavOpen(), { trigger: event.currentTarget });
    }

    _handleCountrySelectorClick() {
      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
    }

    _handleNavOverlayClick() {
      this._closeNavGroups();
    }

    _handleNavClick(event) {
      if (!this._navList) return;

      const summary = event.target.closest('.site-header-nav-grouped-link__summary');
      if (summary && this._navList.contains(summary)) {
        window.requestAnimationFrame(() => this._syncNavPanelState());
        return;
      }

      const link = event.target.closest('a[href]');
      if (link && this._navList.contains(link) && !this._navMediaQuery?.matches) {
        this._closeNav({ restoreFocus: false });
      }
    }

    _handleNavToggle(event) {
      const details = event.target;
      if (!details?.matches?.('.site-header-nav-grouped-link__details')) return;

      if (details.open) this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavPointerOver(event) {
      if (!this._navMediaQuery?.matches) return;

      const group = event.currentTarget;
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;

      details.open = true;
      this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavPointerOut(event) {
      if (!this._navMediaQuery?.matches) return;

      const group = event.currentTarget;
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navGroups?.includes(details)) return;
      if (event.relatedTarget && group.contains(event.relatedTarget)) return;
      if (group.contains(document.activeElement)) return;

      details.open = false;
      this._syncNavPanelState();
    }

    _handleNavFocusIn(event) {
      if (!this._navMediaQuery?.matches) return;

      const link = event.target.closest('.site-header-nav-item--link > a.site-header-nav-item__action');
      if (link && this._navList?.contains(link)) return;

      const group = event.target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navList?.contains(details)) return;

      details.open = true;
      this._closeNavGroups({ except: details });
      this._syncNavPanelState();
    }

    _handleNavFocusOut(event) {
      if (!this._navMediaQuery?.matches) return;

      const link = event.target.closest('.site-header-nav-item--link > a.site-header-nav-item__action');
      if (link && this._navList?.contains(link)) return;

      const group = event.target.closest('.site-header-nav-grouped-link');
      const details = group?.querySelector(':scope > .site-header-nav-grouped-link__details');
      if (!details || !this._navList?.contains(details)) return;
      if (event.relatedTarget && group.contains(event.relatedTarget)) return;

      details.open = false;
      this._syncNavPanelState();
    }

    _handleDocumentClick(event) {
      if (!this._navMediaQuery?.matches || !this._hasOpenNavPanel()) return;
      if (this._navList?.contains(event.target) || this._navTrigger?.contains(event.target)) return;

      this._closeNavGroups();
    }

    _syncNavViewport() {
      if (!this._navList || !this._navMediaQuery) return;

      if (this._navMediaQuery.matches) {
        this._closeNavGroups();
        this._closeNav({ restoreFocus: false });
      } else {
        this._closeNavGroups();
      }
      this._syncNavPanelState();
    }

    _handleNavResize() {
      if (this._navResizeRafId !== null && this._navResizeRafId !== undefined) return;

      this._navResizeRafId = window.requestAnimationFrame(() => {
        this._navResizeRafId = null;
        this._syncNavPanelGeometry();
      });
    }

    _setNavOpen(isOpen, { trigger = this._navTrigger, restoreFocus = true } = {}) {
      if (!this._navList || !this._navTrigger) return;

      const wasOpen = this._isNavOpen();
      if (isOpen === wasOpen) {
        this._syncNavLayerState();
        return;
      }

      if (isOpen) {
        if (this._isSearchOpen()) this._closeSearch({ restoreFocus: false });
        if (this._isDrawerOpen() && typeof $360 !== 'undefined' && typeof $360.hideHeaderCart === 'function') {
          this._suppressCartFocusRestore = true;
          $360.hideHeaderCart();
        }

        this._lastNavTrigger = trigger;
        this.classList.add('is-nav-open');
        document.body.classList.add('ndev-site-nav-open');
        this._navTrigger.setAttribute('aria-expanded', 'true');
        const closeLabel = this._navTrigger.getAttribute('data-close-label');
        if (closeLabel) this._navTrigger.setAttribute('aria-label', closeLabel);
        this._scheduleNavFocus();
      } else {
        this.classList.remove('is-nav-open');
        document.body.classList.remove('ndev-site-nav-open');
        this._navTrigger.setAttribute('aria-expanded', 'false');
        const openLabel = this._navTrigger.getAttribute('data-open-label');
        if (openLabel) this._navTrigger.setAttribute('aria-label', openLabel);
        this._closeNavGroups();
        if (restoreFocus && wasOpen) this._lastNavTrigger?.focus();
        this._lastNavTrigger = null;
      }

      this._navWasOpen = isOpen;
      this._syncNavLayerState();
    }

    _closeNav({ restoreFocus = true } = {}) {
      this._setNavOpen(false, { restoreFocus });
    }

    _closeNavGroups({ except = null } = {}) {
      this._navGroups?.forEach((details) => {
        if (details !== except) details.open = false;
      });
      this._syncNavPanelState();
    }

    _syncNavPanelState() {
      const hasOpenPanel = Boolean(this._navMediaQuery?.matches && this._hasOpenNavPanel());
      this._syncNavPanelGeometry();
      if (this._navOverlay) this._navOverlay.hidden = !hasOpenPanel;
      this._syncNavLayerState();
    }

    _syncNavLayerState({ forceInactive = false } = {}) {
      const isDesktop = Boolean(this._navMediaQuery?.matches);
      const isActive = !forceInactive && (isDesktop ? this._hasOpenNavPanel() : this._isNavOpen());
      this.closest('.site-header-section')?.classList.toggle('is-nav-layer-active', isActive);
    }

    _syncNavPanelGeometry() {
      if (!this._navList || !this._navMediaQuery?.matches) return;

      const panelTop = Math.max(0, this.getBoundingClientRect().bottom);
      this._navList.style.setProperty('--site-header-nav-panel-top', `${panelTop}px`);
    }

    _scheduleNavFocus() {
      if (this._navFocusRafId !== null && this._navFocusRafId !== undefined) return;

      this._navFocusRafId = window.requestAnimationFrame(() => {
        this._navFocusRafId = null;
        if (!this._isNavOpen()) return;

        this._getNavFocusableElements().find((element) => element !== this._navTrigger)?.focus();
      });
    }

    _trapNavFocus(event) {
      const focusableElements = this._getNavFocusableElements();
      if (focusableElements.length === 0) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!focusableElements.includes(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _getNavFocusableElements() {
      if (!this._navList || !this._navTrigger) return [];

      const navElements = Array.from(this._navList.querySelectorAll(
        'summary, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');

      return [this._navTrigger, ...navElements];
    }

    _hasOpenNavPanel() {
      return Boolean(this._navGroups?.some((details) => details.open));
    }

    _isNavOpen() {
      return this.classList.contains('is-nav-open');
    }

    _handleScroll() {
      if (this._rafId !== null) return;

      this._rafId = window.requestAnimationFrame(() => {
        this._rafId = null;
        this._syncScrollState();
      });
    }

    _syncScrollState() {
      this.classList.toggle('is-scrolled', window.scrollY > 0);
      this._syncNavPanelGeometry();
    }

    _handleSearchTriggerClick(event) {
      if (!this._searchPanel || !this._searchInput) return;

      event.preventDefault();
      this._openSearch(event.currentTarget);
    }

    _handleSearchOverlayClick() {
      this._closeSearch();
    }

    _handleSearchCloseClick() {
      this._closeSearch();
    }

    _handleSearchInput() {
      if (!this._searchInput) return;

      const query = this._searchInput.value.trim();
      this._searchClear.hidden = query.length === 0;
      this._searchInput.setAttribute('aria-activedescendant', '');
      this._activeSuggestionIndex = -1;
      this._clearSuggestionResults();

      if (this._searchDebounceId !== null) {
        window.clearTimeout(this._searchDebounceId);
        this._searchDebounceId = null;
      }
      this._searchAbortController?.abort();
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._setSearchBusy(false);

      if (query.length < 2) {
        this._setSearchStatus('');
        return;
      }

      const requestSequence = this._searchRequestSequence;
      this._searchDebounceId = window.setTimeout(() => {
        this._searchDebounceId = null;
        this._fetchSuggestions(query, requestSequence);
      }, 200);
    }

    _handleSearchClearClick() {
      if (!this._searchInput) return;

      this._searchInput.value = '';
      this._handleSearchInput();
      this._searchInput.focus();
    }

    _handleSearchKeydown(event) {
      if (!this._searchPanel || !this._searchInput) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this._closeSearch();
        return;
      }

      if (event.key === 'Tab') {
        this._trapSearchFocus(event);
        return;
      }

      if (document.activeElement !== this._searchInput || !this._searchResults) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = this._getSuggestionLinks();
        if (links.length === 0) return;

        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = this._activeSuggestionIndex + direction;
        this._setActiveSuggestion((nextIndex + links.length) % links.length);
      } else if (event.key === 'Enter' && this._activeSuggestionIndex >= 0) {
        const activeLink = this._getSuggestionLinks()[this._activeSuggestionIndex];
        if (!activeLink) return;

        event.preventDefault();
        activeLink.click();
      }
    }

    _openSearch(trigger) {
      if (this._isSearchOpen()) return;

      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
      if (this._hasOpenNavPanel()) this._closeNavGroups();

      if (this._isDrawerOpen()) {
        this._suppressCartFocusRestore = true;
        if (this._cartLinkFocusRafId !== null) {
          window.cancelAnimationFrame(this._cartLinkFocusRafId);
          this._cartLinkFocusRafId = null;
        }
        if (typeof $360 !== 'undefined' && typeof $360.hideHeaderCart === 'function') {
          $360.hideHeaderCart();
        }
      }

      this._lastSearchTrigger = trigger || this._searchTrigger;
      this.classList.add('is-search-open');
      this.closest('.site-header-section')?.classList.add('is-search-open');
      document.body.classList.add('ndev-site-search-open');
      this._searchPanel.hidden = false;
      this._searchPanel.removeAttribute('inert');
      this._searchPanel.setAttribute('aria-hidden', 'false');
      this._searchOverlay.hidden = false;
      this._searchClose.hidden = false;
      this._searchTrigger.setAttribute('aria-expanded', 'true');
      this._searchInput.focus({ preventScroll: true });
      this._scheduleSearchFocus();
    }

    _closeSearch({ restoreFocus = true } = {}) {
      if (!this._isSearchOpen()) return;

      if (this._searchDebounceId !== null) {
        window.clearTimeout(this._searchDebounceId);
        this._searchDebounceId = null;
      }
      this._searchAbortController?.abort();
      this._searchAbortController = null;
      this._searchRequestSequence += 1;
      this._clearSuggestionResults();
      this._setSearchBusy(false);
      this._searchInput.value = '';
      this._searchClear.hidden = true;
      this._setSearchStatus('');
      this._searchInput.setAttribute('aria-activedescendant', '');
      this._activeSuggestionIndex = -1;
      if (this._searchPanel.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      this._searchPanel.hidden = true;
      this._searchPanel.setAttribute('inert', '');
      this._searchPanel.setAttribute('aria-hidden', 'true');
      this._searchOverlay.hidden = true;
      this._searchClose.hidden = true;
      this._searchTrigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-search-open');
      this.closest('.site-header-section')?.classList.remove('is-search-open');
      document.body.classList.remove('ndev-site-search-open');

      if (restoreFocus) {
        this._lastSearchTrigger?.focus();
      }
      this._lastSearchTrigger = null;
    }

    _scheduleSearchFocus() {
      if (this._searchFocusRafId !== null) return;

      this._searchFocusRafId = window.requestAnimationFrame(() => {
        this._searchFocusRafId = null;
        if (this._isSearchOpen()) this._searchInput?.focus();
      });
    }

    _trapSearchFocus(event) {
      const focusableElements = this._getSearchFocusableElements();
      if (focusableElements.length === 0) {
        event.preventDefault();
        this._searchInput?.focus();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!this._searchPanel.contains(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _getSearchFocusableElements() {
      if (!this._searchPanel) return [];

      return Array.from(this._searchPanel.querySelectorAll(
        'a[href], button:not([disabled]):not([hidden]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');
    }

    _getSuggestionLinks() {
      return this._searchResults ? Array.from(this._searchResults.querySelectorAll('.ndev-site-header__suggestion-link')) : [];
    }

    _setActiveSuggestion(index) {
      const links = this._getSuggestionLinks();
      if (links.length === 0) return;

      this._activeSuggestionIndex = index;
      links.forEach((link, linkIndex) => {
        const isActive = linkIndex === index;
        link.setAttribute('aria-selected', String(isActive));
        if (isActive) {
          const optionId = link.id;
          this._searchInput.setAttribute('aria-activedescendant', optionId);
          link.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    async _fetchSuggestions(query, requestSequence) {
      let endpoint;

      try {
        endpoint = new URL(this.getAttribute('predictive-url'), window.location.origin);
      } catch (error) {
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
        return;
      }

      if (endpoint.origin !== window.location.origin) {
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
        return;
      }

      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', '5');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
      this._searchAbortController = new AbortController();
      this._setSearchBusy(true);

      try {
        const response = await fetch(endpoint.toString(), {
          headers: { Accept: 'application/json' },
          signal: this._searchAbortController.signal,
        });
        if (!response.ok) throw new Error(`Predictive search request failed: ${response.status}`);

        const payload = await response.json();
        if (requestSequence !== this._searchRequestSequence || !this._isSearchOpen()) return;

        const products = payload?.resources?.results?.products || payload?.resources?.products || [];
        this._renderSuggestions(products, query);
      } catch (error) {
        if (error?.name === 'AbortError' || requestSequence !== this._searchRequestSequence) return;
        this._clearSuggestionResults();
        this._setSearchStatus(this._searchPanel?.getAttribute('search-failed-message') || '');
      } finally {
        if (requestSequence === this._searchRequestSequence) {
          this._setSearchBusy(false);
          this._searchAbortController = null;
        }
      }
    }

    _renderSuggestions(products, query) {
      const validProducts = Array.isArray(products) ? products.filter((product) => product && product.available !== false).slice(0, 5) : [];
      this._clearSuggestionResults();

      if (validProducts.length === 0) {
        this._setSearchStatus(this._searchPanel?.getAttribute('no-results-message') || '');
        return;
      }

      validProducts.forEach((product, index) => {
        let productUrl;
        try {
          productUrl = new URL(product.url, window.location.origin);
        } catch (error) {
          return;
        }
        if (productUrl.origin !== window.location.origin) return;

        const item = document.createElement('li');
        item.setAttribute('role', 'presentation');
        const link = document.createElement('a');
        link.id = `${this._searchResults.id}-option-${index}`;
        link.className = 'ndev-site-header__suggestion-link';
        link.href = productUrl.href;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        const title = document.createElement('span');
        title.className = 'ndev-site-header__suggestion-title';
        this._appendHighlightedTitle(title, product.title || '', query);
        link.append(title);
        item.append(link);
        this._searchResults.append(item);
      });

      if (this._searchResults.children.length === 0) {
        this._setSearchStatus(this._searchPanel?.getAttribute('no-results-message') || '');
        return;
      }

      this._searchSuggestions.hidden = false;
      this._searchInput.setAttribute('aria-expanded', 'true');
      this._setSearchStatus('');
    }

    _appendHighlightedTitle(container, title, query) {
      const normalizedQuery = query.trim().toLocaleLowerCase();
      const normalizedTitle = title.toLocaleLowerCase();
      if (!normalizedQuery) {
        container.textContent = title;
        return;
      }

      let cursor = 0;
      let matchIndex = normalizedTitle.indexOf(normalizedQuery, cursor);
      if (matchIndex === -1) {
        container.textContent = title;
        return;
      }

      while (matchIndex !== -1) {
        if (matchIndex > cursor) {
          container.append(document.createTextNode(title.slice(cursor, matchIndex)));
        }
        const match = document.createElement('mark');
        match.className = 'ndev-site-header__suggestion-match';
        match.textContent = title.slice(matchIndex, matchIndex + normalizedQuery.length);
        container.append(match);
        cursor = matchIndex + normalizedQuery.length;
        matchIndex = normalizedTitle.indexOf(normalizedQuery, cursor);
      }

      if (cursor < title.length) {
        container.append(document.createTextNode(title.slice(cursor)));
      }
    }

    _clearSuggestionResults() {
      if (!this._searchResults) return;

      while (this._searchResults.firstChild) {
        this._searchResults.firstChild.remove();
      }
      this._searchSuggestions.hidden = true;
      this._searchInput?.setAttribute('aria-expanded', 'false');
      this._activeSuggestionIndex = -1;
    }

    _setSearchBusy(isBusy) {
      this._searchInput?.setAttribute('aria-busy', String(isBusy));
    }

    _setSearchStatus(message) {
      if (this._searchStatus) this._searchStatus.textContent = message;
    }

    _handleCartClick(event) {
      if (typeof $360 === 'undefined' || typeof $360.showHeaderCart !== 'function') return;

      event.preventDefault();
      if (this._isSearchOpen()) this._closeSearch({ restoreFocus: false });
      if (this._isNavOpen()) this._closeNav({ restoreFocus: false });
      if (this._hasOpenNavPanel()) this._closeNavGroups();
      $360.showHeaderCart();
    }

    _handleDocumentKeydown(event) {
      if (this._isSearchOpen()) {
        this._handleSearchKeydown(event);
        return;
      }

      if (this._isNavOpen()) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this._closeNav();
          return;
        }

        if (event.key === 'Tab') {
          this._trapNavFocus(event);
          return;
        }
      }

      if (this._navMediaQuery?.matches && this._hasOpenNavPanel() && event.key === 'Escape') {
        event.preventDefault();
        this._closeNavGroups();
        return;
      }

      if (!this._isDrawerOpen()) return;

      if (event.key === 'Escape') {
        if (typeof $360 === 'undefined' || typeof $360.hideHeaderCart !== 'function') return;

        event.preventDefault();
        $360.hideHeaderCart();
        return;
      }

      if (event.key !== 'Tab' || !this._cartDrawer) return;

      const focusableElements = Array.from(
        this._cartDrawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true');

      if (focusableElements.length === 0) {
        event.preventDefault();
        this._cartDrawer.focus();
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      const activeElement = document.activeElement;

      if (!this._cartDrawer.contains(activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastElement : firstElement).focus();
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }

    _isDrawerOpen() {
      return Boolean(this._cartDrawer?.classList.contains('active'));
    }

    _isSearchOpen() {
      return this.classList.contains('is-search-open');
    }

    _syncDrawerState() {
      if (!this._cartLink || !this._cartDrawer) return;

      const isOpen = this._isDrawerOpen();
      if (isOpen && this._isSearchOpen()) {
        this._closeSearch({ restoreFocus: false });
      }
      if (isOpen && this._isNavOpen()) {
        this._closeNav({ restoreFocus: false });
      }
      this._cartLink.setAttribute('aria-expanded', String(isOpen));
      this._cartDrawer.setAttribute('aria-hidden', String(!isOpen));

      if (isOpen) {
        if (this._cartLinkFocusRafId !== null) {
          window.cancelAnimationFrame(this._cartLinkFocusRafId);
          this._cartLinkFocusRafId = null;
        }
        this._cartDrawer.removeAttribute('inert');
      } else {
        this._cartDrawer.setAttribute('inert', '');
      }

      if (isOpen && !this._drawerWasOpen) {
        this._shouldFocusDrawer = true;
      }

      if (isOpen && this._shouldFocusDrawer) {
        this._scheduleDrawerFocus();
      } else if (!isOpen && this._drawerWasOpen) {
        this._shouldFocusDrawer = false;
        if (this._suppressCartFocusRestore) {
          this._suppressCartFocusRestore = false;
        } else {
          this._scheduleCartLinkFocus();
        }
      }

      this._drawerWasOpen = isOpen;
    }

    _scheduleDrawerFocus() {
      if (this._drawerFocusRafId !== null) return;

      this._drawerFocusRafId = window.requestAnimationFrame(() => {
        this._drawerFocusRafId = null;
        const closeButton = this._cartDrawer?.querySelector('.header-cart-close');

        if (!closeButton || !this._isDrawerOpen()) return;
        if (!closeButton.getAttribute('aria-label')) {
          closeButton.setAttribute('aria-label', 'Close cart');
        }

        closeButton.focus();
        this._shouldFocusDrawer = document.activeElement !== closeButton;
      });
    }

    _scheduleCartLinkFocus() {
      if (this._cartLinkFocusRafId !== null) return;

      this._cartLinkFocusRafId = window.requestAnimationFrame(() => {
        this._cartLinkFocusRafId = window.requestAnimationFrame(() => {
          this._cartLinkFocusRafId = null;
          if (!this._isDrawerOpen()) {
            this._cartLink?.focus();
          }
        });
      });
    }
  }

  if (!customElements.get('ndev-site-header')) {
    customElements.define('ndev-site-header', NdevSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-standard-accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const swiperMap = new WeakMap();

    function getState(root) {
      if (!swiperMap.has(root)) {
        swiperMap.set(root, { swipers: {}, activeGroup: 0 });
      }
      return swiperMap.get(root);
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function renderPagination(current, total) {
      return '<div class="ndev-standard-accessories__pagination-info">' +
        '<span class="ndev-standard-accessories__pagination-current">' + formatPageNum(current) + '</span>' +
        '<span class="ndev-standard-accessories__pagination-total">/' + formatPageNum(total) + '</span>' +
        '</div>' +
        '<div class="ndev-standard-accessories__pagination-buttons">' +
        '<button class="ndev-standard-accessories__pagination-button ndev-standard-accessories__pagination-button--prev" type="button" aria-label="Previous slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button class="ndev-standard-accessories__pagination-button ndev-standard-accessories__pagination-button--next" type="button" aria-label="Next slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div>';
    }

    function checkNavigationButtons(root, group) {
      const state = getState(root);
      const swiper = state.swipers[group];
      if (!swiper) return;
      const swiperEl = root.querySelector('[data-swiper-instance="' + group + '"]');
      let navButtons = root.querySelector('[data-nav-prev="' + group + '"]');
      if (!swiperEl || !navButtons) return;
      navButtons = navButtons.closest('.ndev-standard-accessories__nav-buttons');
      if (!navButtons) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      if (wrapper.scrollWidth > swiperEl.offsetWidth + 1) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function destroySwiper(root, group) {
      const state = getState(root);
      const swiper = state.swipers[group];
      if (swiper) {
        const pagKey = '_pag' + group;
        const pag = state[pagKey];
        if (pag && pag.el) pag.el.removeEventListener('click', pag.handler);
        delete state[pagKey];
        try { swiper.destroy(true, true); } catch (e) {}
        delete state.swipers[group];
      }
    }

    function initSwiper(root, group) {
      if (typeof window.Swiper === 'undefined') return;
      const state = getState(root);
      if (state.swipers[group]) return;
      const groupEl = root.querySelector('[data-tab-group="' + group + '"]');
      if (!groupEl) return;
      const swiperEl = groupEl.querySelector('[data-swiper-instance="' + group + '"]');
      const paginationEl = groupEl.querySelector('[data-pagination="' + group + '"]');
      const navPrevEl = groupEl.querySelector('[data-nav-prev="' + group + '"]');
      const navNextEl = groupEl.querySelector('[data-nav-next="' + group + '"]');
      if (!swiperEl) return;

      const enableSideNav = root.getAttribute('data-nav-side') !== 'false';
      const enablePagPc = root.getAttribute('data-pagination-pc') !== 'false';
      const enablePagMb = root.getAttribute('data-pagination-mb') !== 'false';
      const isMobile = window.innerWidth < 768;
      const enablePagination = isMobile ? enablePagMb : enablePagPc;

      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        },
        on: {
          init: function () {
            if (enableSideNav) {
              window.setTimeout(() => checkNavigationButtons(root, group), 100);
            }
          },
          resize: function () {
            if (enableSideNav) {
              checkNavigationButtons(root, group);
            }
          }
        }
      };

      if (enableSideNav && navNextEl && navPrevEl) {
        config.navigation = {
          nextEl: navNextEl,
          prevEl: navPrevEl,
          disabledClass: 'swiper-button-disabled'
        };
      }

      if (enablePagination && paginationEl) {
        config.pagination = {
          el: paginationEl,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            if (total <= 1) return '';
            return renderPagination(current, total);
          }
        };
      }

      const swiper = new window.Swiper(swiperEl, config);
      state.swipers[group] = swiper;

      if (enablePagination && paginationEl) {
        const handlePaginationClick = (e) => {
          let target = e.target;
          while (target && target !== paginationEl) {
            if (target.classList && target.classList.contains('ndev-standard-accessories__pagination-button--prev')) {
              swiper.slidePrev();
              return;
            }
            if (target.classList && target.classList.contains('ndev-standard-accessories__pagination-button--next')) {
              swiper.slideNext();
              return;
            }
            target = target.parentElement;
          }
        };
        paginationEl.addEventListener('click', handlePaginationClick);
        state['_pag' + group] = { el: paginationEl, handler: handlePaginationClick };
      }
    }

    function switchTab(root, targetIndex) {
      const state = getState(root);
      if (targetIndex === state.activeGroup) return;

      destroySwiper(root, state.activeGroup);

      const oldGroup = root.querySelector('[data-tab-group="' + state.activeGroup + '"]');
      const newGroup = root.querySelector('[data-tab-group="' + targetIndex + '"]');
      if (oldGroup) oldGroup.setAttribute('hidden', '');
      if (newGroup) newGroup.removeAttribute('hidden');

      root.querySelectorAll('.ndev-standard-accessories__tab').forEach((tab) => {
        const idx = parseInt(tab.getAttribute('data-tab-index'), 10);
        tab.setAttribute('aria-selected', idx === targetIndex ? 'true' : 'false');
      });

      state.activeGroup = targetIndex;
      initSwiper(root, targetIndex);
    }

    function init(root) {
      if (!root) return;

      root.querySelectorAll('.ndev-standard-accessories__tab').forEach((tab) => {
        tab.addEventListener('click', () => {
          const idx = parseInt(tab.getAttribute('data-tab-index'), 10);
          switchTab(root, idx);
        });
      });

      const eventName = root.getAttribute('data-id') + ':tab-change';
      document.addEventListener(eventName, function (e) {
        const value = e.detail && e.detail.value;
        if (value == null) return;
        switchTab(root, parseInt(value, 10));
      });

      const state = getState(root);
      const defaultActiveTab = root.querySelector('.ndev-standard-accessories__tab[data-tab-index="0"]');
      if (defaultActiveTab && defaultActiveTab.getAttribute('aria-selected') === 'true') {
        state.activeGroup = 0;
      }

      initSwiper(root, state.activeGroup);
    }

    function dispose(root) {
      if (!root) return;
      const state = getState(root);
      Object.keys(state.swipers).forEach((k) => {
        destroySwiper(root, parseInt(k, 10));
      });
      swiperMap.delete(root);
    }

    ComponentRegistry.register({
      ns: 'ndev-standard-accessories',
      mode: 'component',
      selector: '[data-ndev-accessories]',
      init: init,
      dispose: dispose
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-all-purpose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-all-purpose')) {
    class NdevV50AllPurpose extends BaseElement {
      init() {
        this.introTravelVh = this.readNumber('intro-travel-vh', 118);
        this.frameHeightVh = this.readNumber('frame-height-vh', 220);
        this.topExitGapPc = this.readNumber('top-exit-gap-pc', 0);
        this.topExitGapMb = this.readNumber('top-exit-gap-mb', 0);
        this.track = this.querySelector('.ndev-v50-all-purpose__track');
        this.viewport = this.querySelector('.ndev-v50-all-purpose__viewport');
        this.introContent = this.querySelector('[v50-all-purpose-intro-content]');
        this.frame = this.querySelector('[v50-all-purpose-frame]');
        this._mq = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.raf = 0;
        this.frameActive = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onViewportModeChange = this.requestUpdate.bind(this);
        this.onMotionChange = () => {
          this.frameActive = null;
          this.requestUpdate();
        };

        this.classList.add('is-ready');
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (this._mq.addEventListener) {
          this._mq.addEventListener('change', this.onViewportModeChange);
        } else if (this._mq.addListener) {
          this._mq.addListener(this.onViewportModeChange);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this.onViewportModeChange);
        } else if (this._mq.removeListener) {
          this._mq.removeListener(this.onViewportModeChange);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.classList.remove('is-ready');
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.update());
      }

      getReservedTop(isDesktop) {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        const extra = isDesktop ? this.topExitGapPc : this.topExitGapMb;
        return header + navbar + extra;
      }

      getCssNumber(name, fallback) {
        const value = parseFloat(getComputedStyle(this).getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      }

      update() {
        this.raf = 0;

        const vh = this.viewport ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1 : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const trackTop = this.track ? this.track.getBoundingClientRect().top + scrollTop : this.getBoundingClientRect().top + scrollTop;
        const introPx = (this.introTravelVh / 100) * vh;
        const frameHoldPx = (this.frameHeightVh / 100) * vh;
        const totalTravel = Math.max(0, scrollTop - trackTop);
        const travel = this.clamp(totalTravel, 0, introPx);
        const isDesktop = this._mq.matches;

        const introOffset = this.reducedMotion.matches && travel > 0 ? -introPx : -travel;
        this.style.setProperty('--v50-all-purpose-intro-content-y', introOffset.toFixed(2) + 'px');

        const reservedTop = this.getReservedTop(isDesktop);
        const introContentRect = this.introContent ? this.introContent.getBoundingClientRect() : null;
        const exitPx = introContentRect ? travel + Math.max(0, introContentRect.bottom - reservedTop) : introPx;
        const overlayEndPx = Math.max(1, Math.min(exitPx, introPx));
        const frameStartPx = Math.max(1, Math.min(exitPx, introPx));
        const overlayProgress = this.clamp(travel / overlayEndPx, 0, 1);
        const maskStart = this.getCssNumber('--v50-all-purpose-mask-start-opacity', 0.6);
        const maskEnd = this.getCssNumber('--v50-all-purpose-mask-end-opacity', 0);
        const maskOpacity = maskStart + (maskEnd - maskStart) * overlayProgress;
        const frameActive = totalTravel >= frameStartPx;
        const frameProgress = frameHoldPx > 0 ? this.clamp((totalTravel - frameStartPx) / frameHoldPx, 0, 1) : Number(frameActive);

        this.style.setProperty('--v50-all-purpose-mask-opacity', maskOpacity.toFixed(4));
        this.style.setProperty('--v50-all-purpose-gradient-opacity', maskOpacity.toFixed(4));
        this.setFrameActive(frameActive);
        this.dispatchFrameProgress(frameActive, frameProgress);
      }

      setFrameActive(active) {
        if (this.frameActive === active) return;
        this.frameActive = active;
        this.classList.toggle('is-frame-active', active);
        if (this.introContent) this.introContent.setAttribute('aria-hidden', active ? 'true' : 'false');
        if (this.frame) this.frame.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      dispatchFrameProgress(active, progress) {
        this.dispatchEvent(new CustomEvent('ndev-v50-frame-progress', {
          detail: {
            active,
            progress,
          },
        }));
      }
    }

    customElements.define('ndev-v50-all-purpose', NdevV50AllPurpose);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-anti-tangle-animation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-anti-tangle-animation')) {
    class NdevV50AntiTangleAnimation extends BaseElement {
      init() {
        this.endTriggerVh = this.readNumber('end-trigger-vh', 100);
        this.viewport = this.querySelector('.ndev-v50-anti-tangle-animation__viewport');
        this.middleStage = this.querySelector('.ndev-v50-anti-tangle-animation__stage--middle');
        this.endStage = this.querySelector('.ndev-v50-anti-tangle-animation__stage--end');
        this.media = this.querySelector('.ndev-v50-anti-tangle-animation__media-block');
        this.desktopVideo = this.media?.querySelector('.show-pc video.ndev-media__video') || null;
        this.mobileVideo = this.media?.querySelector('.show-mb video.ndev-media__video') || null;
        this.videos = Array.from(this.media?.querySelectorAll('video.ndev-media__video') || []);
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.state = null;
        this.inView = false;
        this.readyFrame = 0;
        this.observer = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onLayoutChange = this.handleEnvironmentChange.bind(this);
        this.onVisibilityChange = this.syncVideo.bind(this);
        this.onIntersection = this.handleIntersection.bind(this);

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
        });

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addMediaListener(this.desktopMedia, this.onLayoutChange);
        this.addMediaListener(this.reducedMotion, this.onLayoutChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0.1 });
          this.observer.observe(this);
        } else {
          this.inView = true;
        }

        this.update({ initial: true });
        this.readyFrame = requestAnimationFrame(() => {
          this.readyFrame = requestAnimationFrame(() => this.classList.add('is-ready'));
        });
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeMediaListener(this.desktopMedia, this.onLayoutChange);
        this.removeMediaListener(this.reducedMotion, this.onLayoutChange);
        if (this.observer) this.observer.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.readyFrame) cancelAnimationFrame(this.readyFrame);
        this.pauseVideos();
        this.classList.remove('is-ready');
        this.frame = 0;
        this.readyFrame = 0;
      }

      addMediaListener(query, listener) {
        if (query.addEventListener) query.addEventListener('change', listener);
        else query.addListener(listener);
      }

      removeMediaListener(query, listener) {
        if (query.removeEventListener) query.removeEventListener('change', listener);
        else query.removeListener(listener);
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      handleEnvironmentChange() {
        this.state = null;
        this.requestUpdate();
        this.syncVideo();
      }

      handleIntersection(entries) {
        const entry = entries.find((item) => item.target === this);
        if (!entry) return;
        this.inView = entry.isIntersecting;
        this.syncVideo();
      }

      update(options = {}) {
        this.frame = 0;

        if (!this.desktopMedia.matches || this.reducedMotion.matches) {
          this.setState('static', options.initial);
          this.syncVideo();
          return;
        }

        const viewportHeight = this.viewport
          ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1
          : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rootTop = this.getBoundingClientRect().top + scrollTop;
        const travel = scrollTop - rootTop;
        const endTrigger = (this.endTriggerVh / 100) * viewportHeight;
        const nextState = travel < 0 ? 'intro' : travel < endTrigger ? 'middle' : 'end';

        this.setState(nextState, options.initial);
        this.syncVideo();
      }

      setState(nextState, force) {
        if (!force && this.state === nextState) return;
        this.state = nextState;
        this.setAttribute('state', nextState);

        const showAll = nextState === 'static';
        if (this.middleStage) {
          this.middleStage.setAttribute('aria-hidden', showAll || nextState === 'middle' ? 'false' : 'true');
        }
        if (this.endStage) {
          this.endStage.setAttribute('aria-hidden', showAll || nextState === 'end' ? 'false' : 'true');
        }
      }

      syncVideo() {
        if (!this.videos.length) return;
        const activeVideo = this.desktopMedia.matches ? this.desktopVideo : this.mobileVideo;
        const shouldPlay = this.inView && !this.reducedMotion.matches && !document.hidden;

        this.videos.forEach((video) => {
          if (!shouldPlay || video !== activeVideo) this.pauseVideo(video);
        });

        if (!shouldPlay || !activeVideo) {
          return;
        }

        activeVideo.muted = true;
        const promise = activeVideo.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      }

      pauseVideo(video) {
        try {
          video.pause();
        } catch (error) {}
      }

      pauseVideos() {
        this.videos.forEach((video) => this.pauseVideo(video));
      }
    }

    customElements.define('ndev-v50-anti-tangle-animation', NdevV50AntiTangleAnimation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-dirt-overview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-dirt-overview')) {
    class NdevV50DirtOverview extends BaseElement {
      init() {
        this.introTravelVh = this.readNumber('intro-travel-vh', 110);
        this.metricsTravelVh = this.readNumber('metrics-travel-vh', 92);
        this.maskStartPc = this.readNumber('intro-mask-start-pc', 0.6);
        this.maskEndPc = this.readNumber('intro-mask-end-pc', 0);
        this.maskStartMb = this.readNumber('intro-mask-start-mb', 0.8);
        this.maskEndMb = this.readNumber('intro-mask-end-mb', 0.4);
        this.viewport = this.querySelector('.ndev-v50-dirt-overview__viewport');
        this.introEl = this.querySelector('.ndev-v50-dirt-overview-intro');
        this.metricsEl = this.querySelector('.ndev-v50-dirt-overview-metrics');
        this.countups = Array.from(this.querySelectorAll('ndev-scroll-countup'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.countupTimer = 0;
        this.countupsActive = false;
        this.metricsActive = null;
        this.onScroll = this.requestUpdate.bind(this);
        this.onMotionChange = () => {
          this.metricsActive = null;
          this.requestUpdate();
        };

        this.classList.add('is-ready');
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.countupTimer) clearTimeout(this.countupTimer);
        this.classList.remove('is-ready');
        this.frame = 0;
        this.countupTimer = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;

        if (this.reducedMotion.matches) {
          this.style.setProperty('--v50-dirt-intro-y', '0vh');
          this.style.setProperty('--v50-dirt-intro-opacity', '1');
          this.style.setProperty('--v50-dirt-mask-opacity', '0');
          if (this.countupTimer) clearTimeout(this.countupTimer);
          this.countupTimer = 0;
          this.metricsActive = false;
          this.classList.remove('is-metrics-active');
          if (this.introEl) this.introEl.setAttribute('aria-hidden', 'false');
          if (this.metricsEl) this.metricsEl.setAttribute('aria-hidden', 'false');
          this.setCountupsActive(true);
          return;
        }

        const vh = this.viewport ? this.viewport.getBoundingClientRect().height || window.innerHeight || 1 : window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const rootTop = this.getBoundingClientRect().top + scrollTop;
        const introPx = (this.introTravelVh / 100) * vh;
        const metricsPx = (this.metricsTravelVh / 100) * vh;
        const totalPx = introPx + metricsPx;
        const travel = this.clamp(scrollTop - rootTop, 0, totalPx);
        const introProgress = introPx > 0 ? this.clamp(travel / introPx, 0, 1) : 1;
        const metricsActive = travel >= introPx;
        const isDesktop = this._mq ? this._mq.matches : window.matchMedia('(min-width: 1024px)').matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const maskEnd = isDesktop ? this.maskEndPc : this.maskEndMb;
        const maskOpacity = maskStart + (maskEnd - maskStart) * introProgress;
        const introShiftVh = isDesktop ? -32 : -36;
        const introY = introProgress * introShiftVh;

        this.style.setProperty('--v50-dirt-intro-y', introY.toFixed(3) + 'vh');
        this.style.setProperty('--v50-dirt-intro-opacity', '1');
        this.style.setProperty('--v50-dirt-mask-opacity', maskOpacity.toFixed(4));
        this.setMetricsActive(metricsActive);
      }

      setMetricsActive(active) {
        if (this.metricsActive === active) return;
        this.metricsActive = active;
        this.classList.toggle('is-metrics-active', active);
        if (this.introEl) this.introEl.setAttribute('aria-hidden', active ? 'true' : 'false');
        if (this.metricsEl) this.metricsEl.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (this.countupTimer) clearTimeout(this.countupTimer);
        this.countupTimer = 0;

        if (active) {
          this.countupTimer = window.setTimeout(() => {
            this.countupTimer = 0;
            this.setCountupsActive(true);
          }, 180);
        } else {
          this.setCountupsActive(false);
        }
      }

      setCountupsActive(active) {
        if (this.countupsActive === active) return;
        this.countupsActive = active;

        this.countups.forEach((countup) => {
          if (active) {
            countup.setAttribute('active', '');
          } else {
            countup.removeAttribute('active');
          }
        });
      }
    }

    customElements.define('ndev-v50-dirt-overview', NdevV50DirtOverview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-dirtscan"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-dirtscan')) {
    class NdevV50Dirtscan extends BaseElement {
      init() {
        this.activationTravelVh = this.readNumber('activation-travel-vh', 24);
        this.track = this.querySelector('.ndev-v50-dirtscan__track');
        this.viewport = this.querySelector('.ndev-v50-dirtscan__viewport');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.lightOn = this.classList.contains('is-light-on');
        this.raf = 0;
        this.onViewportChange = this.requestUpdate.bind(this);
        this.onMotionChange = this.requestUpdate.bind(this);

        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        window.addEventListener('resize', this.onViewportChange, { passive: true });
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }
        this.requestUpdate();
      }

      dispose() {
        window.removeEventListener('scroll', this.onViewportChange);
        window.removeEventListener('resize', this.onViewportChange);
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      smoothstep(value) {
        return value * value * (3 - 2 * value);
      }

      requestUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.update());
      }

      getReservedTop() {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        return header + navbar;
      }

      setLightOn() {
        if (this.lightOn) return;
        this.lightOn = true;
        this.classList.add('is-light-on');
      }

      update() {
        this.raf = 0;

        if (!this.track || !this.viewport) return;

        if (this.reducedMotion.matches) {
          this.setLightOn();
          this.style.setProperty('--v50-dirtscan-exit-progress', '0');
          return;
        }

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        const trackTop = this.track.getBoundingClientRect().top + scrollTop;
        const travel = scrollTop - trackTop;
        const activationTravel = Math.max((this.activationTravelVh / 100) * viewportHeight, this.getReservedTop());

        if (!this.lightOn && travel >= activationTravel) this.setLightOn();

        const stickyTravel = Math.max(1, this.track.offsetHeight - viewportHeight);
        const exitStart = stickyTravel * 0.58;
        const exitLinearProgress = this.clamp((travel - exitStart) / Math.max(1, stickyTravel - exitStart), 0, 1);
        const exitProgress = this.smoothstep(exitLinearProgress);
        this.style.setProperty('--v50-dirtscan-exit-progress', exitProgress.toFixed(4));
      }
    }

    customElements.define('ndev-v50-dirtscan', NdevV50Dirtscan);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-free-in-coverage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-free-in-coverage')) {
    class NdevV50FreeInCoverage extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-free-in-coverage__track');
        this.viewport = this.querySelector('.ndev-v50-free-in-coverage__viewport');
        this.content = this.querySelector('.ndev-v50-free-in-coverage__content');
        this.maskStartPc = this.readNumber('mask-start-pc', 0.6);
        this.maskStartMb = this.readNumber('mask-start-mb', 0.5);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.contentTravel = 0;
        this.mobileTarget = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
        this.mobileImageScale = 1;
        this.mobileImageFinalY = 0;
        this.frame = 0;
        this.isNear = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.recalculate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.content);
        } else {
          window.addEventListener('resize', this.onResize, { passive: true });
        }

        this.recalculate();
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        } else {
          window.removeEventListener('resize', this.onResize);
        }
        this.resizeObserver = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      lerp(start, end, progress) {
        return start + (end - start) * progress;
      }

      getReservedTop() {
        const stickyTop = parseFloat(getComputedStyle(this.viewport).top);
        return Number.isFinite(stickyTop) ? stickyTop : 0;
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.recalculate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        this.recalculate();
      }

      recalculate() {
        if (!this.track || !this.viewport || !this.content) return;

        const viewportRect = this.viewport.getBoundingClientRect();
        const contentRect = this.content.getBoundingClientRect();
        const isDesktop = this._mq.matches;
        const finalTop = isDesktop ? 128 : 32;

        this.viewportWidth = viewportRect.width || window.innerWidth || 1;
        this.viewportHeight = viewportRect.height || window.innerHeight || 1;
        this.contentTravel = Math.max(0, (this.viewportHeight - contentRect.height) / 2 - finalTop);

        const mobileMediaTop = finalTop + contentRect.height + 24;
        const availableWidth = Math.max(0, Math.min(342, this.viewportWidth - 48));
        const availableHeight = Math.max(0, this.viewportHeight - mobileMediaTop - 24);
        const mobileWidth = Math.min(availableWidth, availableHeight * 342 / 300);
        const mobileHeight = mobileWidth * 300 / 342;
        const mobileLeft = (this.viewportWidth - mobileWidth) / 2;
        const mobileRight = this.viewportWidth - mobileLeft - mobileWidth;
        const mobileBottom = this.viewportHeight - mobileMediaTop - mobileHeight;

        this.mobileTarget = {
          top: mobileMediaTop,
          right: Math.max(0, mobileRight),
          bottom: Math.max(0, mobileBottom),
          left: Math.max(0, mobileLeft),
          width: mobileWidth,
          height: mobileHeight,
        };
        this.mobileImageScale = mobileHeight / this.viewportHeight;
        this.mobileImageFinalY = mobileMediaTop + mobileHeight / 2 - this.viewportHeight / 2;

        this.style.setProperty('--v50-free-in-coverage-mb-target-width', mobileWidth.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-target-height', mobileHeight.toFixed(2) + 'px');
        this.classList.add('is-ready');

        if (this.reducedMotion.matches) {
          this.applyProgress(1);
        } else {
          this.requestUpdate();
        }
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const reservedTop = this.getReservedTop();
        const scrollDistance = Math.max(1, trackRect.height - this.viewportHeight);
        const progress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);

        this.applyProgress(progress);
      }

      applyProgress(progress) {
        const safeProgress = this.clamp(progress, 0, 1);
        const isDesktop = this._mq.matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const contentY = this.contentTravel * (1 - safeProgress);
        const maskOpacity = maskStart * (1 - safeProgress);
        const pcImageScale = this.lerp(1.395, 1, safeProgress);
        const pcGradientOpacity = 0.3 * safeProgress;
        const mobileGradientOpacity = 1 - safeProgress;
        const mobileImageScale = this.lerp(1, this.mobileImageScale, safeProgress);
        const mobileImageStartX = -this.viewportWidth * 0.13333;
        const mobileImageX = this.lerp(mobileImageStartX, 0, safeProgress);
        const mobileImageY = this.mobileImageFinalY * safeProgress;

        this.style.setProperty('--v50-free-in-coverage-content-y', contentY.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mask-opacity', maskOpacity.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-pc-image-scale', pcImageScale.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-pc-gradient-opacity', pcGradientOpacity.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-mb-gradient-opacity', mobileGradientOpacity.toFixed(4));
        this.style.setProperty(
          '--v50-free-in-coverage-clip-top',
          (this.mobileTarget.top * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-right',
          (this.mobileTarget.right * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-bottom',
          (this.mobileTarget.bottom * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty(
          '--v50-free-in-coverage-clip-left',
          (this.mobileTarget.left * safeProgress).toFixed(2) + 'px'
        );
        this.style.setProperty('--v50-free-in-coverage-clip-radius', (8 * safeProgress).toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-image-scale', mobileImageScale.toFixed(4));
        this.style.setProperty('--v50-free-in-coverage-mb-image-x', mobileImageX.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-coverage-mb-image-y', mobileImageY.toFixed(2) + 'px');
      }
    }

    customElements.define('ndev-v50-free-in-coverage', NdevV50FreeInCoverage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-free-in-hand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-free-in-hand')) {
    class NdevV50FreeInHand extends BaseElement {
      init() {
        this.viewport = this.querySelector('.ndev-v50-free-in-hand__viewport');
        this.content = this.querySelector('.ndev-v50-free-in-hand__content');
        this.maskStartPc = this.readNumber('mask-start-pc', 0.6);
        this.maskStartMb = this.readNumber('mask-start-mb', 0.8);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.travelPx = 1;
        this.frame = 0;
        this.isActive = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.recalculate.bind(this);
        this.onMotionChange = this.recalculate.bind(this);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setActive(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setActive(true);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.content);
        } else {
          window.addEventListener('resize', this.onResize, { passive: true });
        }

        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onMotionChange);
        }

        this.recalculate();
      }

      dispose() {
        this.setActive(false);
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        } else {
          window.removeEventListener('resize', this.onResize);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.removeEventListener('change', this.onMotionChange);
        } else if (this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onMotionChange);
        }
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      setActive(active) {
        if (this.isActive === active) return;
        this.isActive = active;

        if (active) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.recalculate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      }

      recalculate() {
        if (!this.viewport || !this.content) return;

        if (this.reducedMotion.matches) {
          this.style.setProperty('--v50-free-in-hand-content-y', '0px');
          this.style.setProperty('--v50-free-in-hand-mask-opacity', '0');
          return;
        }

        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const contentHeight = this.content.getBoundingClientRect().height;
        const finalTop = this.content.offsetTop;
        const centeredTop = Math.max(0, (viewportHeight - contentHeight) / 2);
        const travelPx = Math.max(0, centeredTop - finalTop);

        this.travelPx = Math.max(travelPx, 1);
        this.style.setProperty('--v50-free-in-hand-content-y', travelPx.toFixed(2) + 'px');
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (this.reducedMotion.matches) return;

        const travel = this.clamp(-this.getBoundingClientRect().top, 0, this.travelPx);
        const progress = this.travelPx > 0 ? travel / this.travelPx : 1;
        const isDesktop = this._mq ? this._mq.matches : window.matchMedia('(min-width: 1024px)').matches;
        const maskStart = isDesktop ? this.maskStartPc : this.maskStartMb;
        const contentY = this.travelPx - travel;
        const maskOpacity = maskStart * (1 - progress);

        this.style.setProperty('--v50-free-in-hand-content-y', contentY.toFixed(2) + 'px');
        this.style.setProperty('--v50-free-in-hand-mask-opacity', maskOpacity.toFixed(4));
      }
    }

    customElements.define('ndev-v50-free-in-hand', NdevV50FreeInHand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-lightweight-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-lightweight-scenes')) {
    class NdevV50LightweightScenes extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-lightweight-scenes__track');
        this.viewport = this.querySelector('.ndev-v50-lightweight-scenes__viewport');
        this.rail = this.querySelector('.ndev-v50-lightweight-scenes__rail');
        this.cards = Array.from(this.querySelectorAll('.ndev-v50-lightweight-scene-card'));
        this.segments = Array.from(this.querySelectorAll('.ndev-v50-lightweight-scenes__progress-segment'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.isNear = false;
        this.activeIndex = -1;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.requestUpdate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this._mq, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if (!this.cards.length) return;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        this.applyProgress(0);
        this.classList.add('is-ready');
        this.requestUpdate();
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.removeMediaListener(this._mq, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.requestUpdate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        this.activeIndex = -1;
        if (this.reducedMotion.matches) this.applyProgress(0);
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame || !this.cards.length) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = parseFloat(getComputedStyle(this).getPropertyValue('--v50-lightweight-reserved-top')) || 0;
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const linearProgress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);
        const maxIndex = Math.max(0, this.cards.length - 1);
        const rawStep = linearProgress * maxIndex;
        const stepIndex = Math.min(maxIndex, Math.floor(rawStep));
        const fraction = stepIndex >= maxIndex ? 0 : rawStep - stepIndex;
        const heldFraction = this.clamp((fraction - 0.1) / 0.8, 0, 1);
        const easedFraction = 0.5 - Math.cos(Math.PI * heldFraction) / 2;
        const sceneProgress = Math.min(maxIndex, stepIndex + easedFraction);

        this.applyProgress(sceneProgress);
      }

      applyProgress(progress) {
        if (!this.cards.length || !this.viewport || !this.rail) return;

        const maxIndex = this.cards.length - 1;
        const safeProgress = this.clamp(progress, 0, maxIndex);
        const baseIndex = Math.min(maxIndex, Math.floor(safeProgress));
        const nextIndex = Math.min(maxIndex, baseIndex + 1);
        const localProgress = nextIndex === baseIndex ? 0 : safeProgress - baseIndex;
        const isDesktop = this._mq.matches && !this.reducedMotion.matches;
        const viewportWidth = this.viewport.getBoundingClientRect().width || window.innerWidth || 1;
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;

        if (isDesktop) {
          this.applyDesktopLayout(baseIndex, nextIndex, localProgress, viewportWidth, viewportHeight);
        } else if (!this.reducedMotion.matches) {
          this.rail.style.transform = `translate3d(${-safeProgress * viewportWidth}px, 0, 0)`;
          this.cards.forEach((card, index) => {
            const focus = index === baseIndex ? 1 - localProgress : index === nextIndex ? localProgress : 0;
            this.setCardVisualState(card, focus);
          });
        } else {
          this.rail.style.transform = '';
          this.cards.forEach((card) => this.setCardVisualState(card, 1));
        }

        this.segments.forEach((segment, index) => {
          const fill = this.clamp(safeProgress - index + 1, 0, 1);
          segment.style.setProperty('--v50-lightweight-progress-fill', fill.toFixed(4));
        });

        this.setActiveIndex(Math.round(safeProgress));
      }

      applyDesktopLayout(baseIndex, nextIndex, localProgress, viewportWidth, viewportHeight) {
        const copyTop = this.clamp(viewportHeight * 0.1296, 40, 128);
        const bottomSpace = this.clamp(viewportHeight * 0.0324, 24, 32);
        const activeSize = Math.min(
          708,
          viewportWidth * 0.6,
          Math.max(224, viewportHeight - copyTop - 152 - bottomSpace)
        );
        const thumbSize = Math.min(224, viewportWidth * 0.2, activeSize);
        const galleryCenter = copyTop + 152 + activeSize / 2;
        const gap = 20;
        const centers = [];
        let cursor = 0;

        this.style.setProperty('--v50-lightweight-copy-top', `${copyTop.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-active-size', `${activeSize.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-thumb-size', `${thumbSize.toFixed(2)}px`);
        this.style.setProperty('--v50-lightweight-gallery-center', `${galleryCenter.toFixed(2)}px`);

        this.cards.forEach((card, index) => {
          const focus = index === baseIndex ? 1 - localProgress : index === nextIndex ? localProgress : 0;
          const size = thumbSize + (activeSize - thumbSize) * focus;
          card.style.setProperty('--v50-lightweight-card-size', `${size.toFixed(2)}px`);
          this.setCardVisualState(card, focus);
          centers[index] = cursor + size / 2;
          cursor += size + gap;
        });

        const targetCenter = centers[baseIndex] + (centers[nextIndex] - centers[baseIndex]) * localProgress;
        const offset = viewportWidth / 2 - targetCenter;
        this.rail.style.transform = `translate3d(${offset.toFixed(2)}px, 0, 0)`;
      }

      setCardVisualState(card, focus) {
        const safeFocus = this.clamp(focus, 0, 1);
        card.style.setProperty('--v50-lightweight-card-radius', `${(4 + safeFocus * 4).toFixed(2)}px`);
        card.style.setProperty('--v50-lightweight-media-opacity', (0.5 + safeFocus * 0.5).toFixed(4));
        card.style.setProperty('--v50-lightweight-copy-opacity', safeFocus.toFixed(4));
      }

      setActiveIndex(index) {
        const nextIndex = this.clamp(index, 0, Math.max(0, this.cards.length - 1));
        if (this.activeIndex === nextIndex) return;
        this.activeIndex = nextIndex;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === nextIndex;
          card.classList.toggle('is-active', active);
          if (active) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('ndev-v50-lightweight-scenes', NdevV50LightweightScenes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-v50-stardust-light"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndev-v50-stardust-light')) {
    class NdevV50StardustLight extends BaseElement {
      init() {
        this.track = this.querySelector('.ndev-v50-stardust-light__track');
        this.viewport = this.querySelector('.ndev-v50-stardust-light__viewport');
        this.intro = this.querySelector('.ndev-v50-stardust-light__intro');
        this.states = Array.from(this.querySelectorAll('.ndev-v50-stardust-light-state'));
        this.desktopMedia = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.readyFrame = 0;
        this.state = null;
        this.isNear = false;
        this.onScroll = this.requestUpdate.bind(this);
        this.onResize = this.requestUpdate.bind(this);
        this.onModeChange = this.handleModeChange.bind(this);

        this.addMediaListener(this.desktopMedia, this.onModeChange);
        this.addMediaListener(this.reducedMotion, this.onModeChange);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setNear(entries.some((entry) => entry.isIntersecting));
          }, { rootMargin: '100% 0px' });
          this.observer.observe(this);
        } else {
          this.setNear(true);
        }

        this.applyProgress(0);
        this.update();
        this.readyFrame = requestAnimationFrame(() => {
          this.readyFrame = requestAnimationFrame(() => {
            this.readyFrame = 0;
            this.classList.add('is-ready');
          });
        });
      }

      dispose() {
        this.setNear(false);
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        this.removeMediaListener(this.desktopMedia, this.onModeChange);
        this.removeMediaListener(this.reducedMotion, this.onModeChange);
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.readyFrame) cancelAnimationFrame(this.readyFrame);
        this.frame = 0;
        this.readyFrame = 0;
        this.state = null;
        this.classList.remove('is-ready');
      }

      addMediaListener(media, listener) {
        if (!media) return;
        if (media.addEventListener) media.addEventListener('change', listener);
        else if (media.addListener) media.addListener(listener);
      }

      removeMediaListener(media, listener) {
        if (!media) return;
        if (media.removeEventListener) media.removeEventListener('change', listener);
        else if (media.removeListener) media.removeListener(listener);
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      lerp(start, end, progress) {
        return start + (end - start) * progress;
      }

      range(progress, start, end) {
        if (end <= start) return Number(progress >= end);
        return this.clamp((progress - start) / (end - start), 0, 1);
      }

      ease(progress) {
        const value = this.clamp(progress, 0, 1);
        return value * value * (3 - 2 * value);
      }

      getReservedTop() {
        const css = getComputedStyle(this);
        const header = parseFloat(css.getPropertyValue('--header-height')) || 0;
        const navbar = parseFloat(css.getPropertyValue('--navbar-height')) || 0;
        return header + navbar;
      }

      setNear(near) {
        if (this.isNear === near) return;
        this.isNear = near;
        if (near && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          this.requestUpdate();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
        }
      }

      handleModeChange() {
        this.state = null;
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        if (this.isNear && !this.reducedMotion.matches) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        if (this.reducedMotion.matches) this.applyProgress(0);
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        this.frame = 0;
        if (!this.track || !this.viewport || this.reducedMotion.matches) return;

        const trackRect = this.track.getBoundingClientRect();
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const reservedTop = this.getReservedTop();
        const scrollDistance = Math.max(1, trackRect.height - viewportHeight);
        const progress = this.clamp((reservedTop - trackRect.top) / scrollDistance, 0, 1);

        this.applyProgress(progress);
      }

      applyProgress(progress) {
        if (!this.viewport || !this.intro) return;

        const firstState = this.states[0];
        const secondState = this.states[1];
        const nextState = progress < 0.4 ? 'intro' : progress < 0.7 || !secondState ? 'double' : 'single';
        const viewportHeight = this.viewport.getBoundingClientRect().height || window.innerHeight || 1;
        const introHeight = this.intro.querySelector('.ndev-v50-stardust-light__intro-content')?.offsetHeight || 0;
        const introTop = this.desktopMedia.matches ? 128 : 32;
        const introStartTop = (viewportHeight - introHeight) / 2;
        const introTravel = this.ease(this.range(progress, 0, 0.33));
        const introY = this.lerp(0, introTop - introStartTop, introTravel);
        const introOpacity = nextState === 'intro' ? 1 : 0;
        const mediaStartY = viewportHeight * (this.desktopMedia.matches ? 0.34 : 0.36);
        const firstMediaY = this.lerp(mediaStartY, 0, introTravel) - 10 * this.ease(this.range(progress, 0.33, 0.66));

        this.style.setProperty('--v50-stardust-intro-y', `${introY.toFixed(2)}px`);
        this.style.setProperty('--v50-stardust-intro-opacity', introOpacity.toFixed(4));
        this.setState(nextState);

        if (firstState) {
          const firstContent = nextState === 'intro' ? 0 : 1;
          firstState.style.setProperty('--v50-stardust-state-background-opacity', String(firstContent));
          firstState.style.setProperty('--v50-stardust-state-media-opacity', '1');
          firstState.style.setProperty('--v50-stardust-state-media-y', `${firstMediaY.toFixed(2)}px`);
          firstState.style.setProperty('--v50-stardust-state-content-opacity', String(firstContent));
          firstState.style.setProperty('--v50-stardust-state-content-y', firstContent ? '0px' : '16px');
          firstState.style.setProperty(
            '--v50-stardust-state-content-pointer-events',
            nextState === 'double' && firstContent > 0.01 ? 'auto' : 'none'
          );
        }

        if (secondState) {
          secondState.style.setProperty('--v50-stardust-state-background-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-media-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-media-y', '0px');
          secondState.style.setProperty('--v50-stardust-state-content-opacity', '1');
          secondState.style.setProperty('--v50-stardust-state-content-y', '0px');
          secondState.style.setProperty('--v50-stardust-state-content-pointer-events', nextState === 'single' ? 'auto' : 'none');
        }
      }

      setState(nextState) {
        const resolvedState = this.reducedMotion.matches ? 'static' : nextState;
        if (this.state === resolvedState) return;
        this.state = resolvedState;
        this.setAttribute('state', resolvedState);

        if (this.reducedMotion.matches) {
          this.intro.setAttribute('aria-hidden', 'false');
          this.states.forEach((state) => state.setAttribute('aria-hidden', 'false'));
          return;
        }

        this.intro.setAttribute('aria-hidden', nextState === 'intro' ? 'false' : 'true');
        this.states.forEach((state, index) => {
          const isActive = (nextState === 'double' && index === 0) || (nextState === 'single' && index === 1);
          state.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }
    }

    customElements.define('ndev-v50-stardust-light', NdevV50StardustLight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndev-x30-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const NS = 'ndev-x30-sale';
    const ROOT_SELECTOR = '[data-ndev-x30-sale]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevSectionControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 初始化逻辑（建议事件绑定都挂在 root 上，并在 destroy 里移除）

      controllers.set(root, {
        root: root,
        destroy: function () {
          // 清理事件监听器、定时器等（注意移除你在 init 里绑定的监听）
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  class NdevPageBanner extends BaseElement {
    init() {
      this.dispose();

      this.viewport = this.querySelector('.page-banner__swiper');
      this.track = this.querySelector('.swiper-wrapper');
      this.verticalTabs = this.querySelector('.page-banner__vertical-tabs');
      this.horizontalTabs = this.querySelector('.page-banner__horizontal-tabs');
      this.horizontalTabsPc = this.querySelector('.page-banner__horizontal-tabs-pc');
      this.navigation = this.querySelector('.page-banner__navigation');
      this.previousButton = this.querySelector('.page-banner__navigation-button--prev');
      this.nextButton = this.querySelector('.page-banner__navigation-button--next');
      this.status = this.querySelector('.page-banner__status');
      this.listeners = [];
      this.swiper = null;
      this.waitFrame = null;
      this.resizeFrame = null;
      this.adaptiveHeightFrame = null;
      this.inView = !('IntersectionObserver' in window);
      this.activeIndex = 0;
      this.autoplayEnabled = this.getAttribute('autoplay') === 'true';
      this.autoplayDelay = Math.max(1000, Number(this.getAttribute('autoplay-delay')) || 5000);
      this.loopEnabled = this.getAttribute('loop') === 'true';
      this.showPagination = this.getAttribute('show-pagination') === 'true';
      this.showNavigation = this.getAttribute('show-navigation') === 'true';
      this.paginationVariant = this.getAttribute('pagination-variant') || 'tabs';
      this.adaptiveHeightEnabled = this.getAttribute('adaptive-height') === 'true';
      this.pcBannerHeight = Number(this.getAttribute('pc-banner-height'));
      this.bannerSection = this.closest('.page-banner');
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.viewport || !this.track) return;

      this.slideHosts = Array.from(this.track.children).filter((child) => child.nodeType === Node.ELEMENT_NODE);
      this.slideCount = this.slideHosts.length;
      this.loopEnabled = this.loopEnabled && this.slideCount > 1;
      this.setupAdaptiveHeight();

      this.editorSelectedBlock = null;

      this.bindActions();
      this.observeVisibility();
      this.on(document, 'visibilitychange', () => this.syncRuntimeState());
      this.on(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
      this.on(document, 'shopify:block:deselect', (event) => this.handleBlockDeselect(event));
      this.on(window, 'resize', () => this.handleResize());

      if (this.motionQuery.addEventListener) {
        this.on(this.motionQuery, 'change', () => this.handleMotionChange());
      } else if (this.motionQuery.addListener) {
        this.motionListener = () => this.handleMotionChange();
        this.motionQuery.addListener(this.motionListener);
      }

      this.buildPagination();
      this.hideControls();
      this.syncSlideState(0);

      if (this.slideCount <= 1) {
        this.removeAttribute('role');
        this.removeAttribute('aria-roledescription');
        this.removeAttribute('aria-label');
        this.setAttribute('ready', '');
        return;
      }

      this.setAttribute('role', 'region');
      this.setAttribute('aria-roledescription', 'carousel');
      this.setAttribute('aria-label', 'Banner carousel');
      this.waitForSwiper();
    }

    dispose() {
      if (this.waitFrame) cancelAnimationFrame(this.waitFrame);
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      if (this.adaptiveHeightFrame) cancelAnimationFrame(this.adaptiveHeightFrame);
      this.waitFrame = null;
      this.resizeFrame = null;
      this.adaptiveHeightFrame = null;

      if (this.adaptiveHeightObserver) this.adaptiveHeightObserver.disconnect();
      this.adaptiveHeightObserver = null;

      if (this.bannerSection) {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
      }
      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        slide.style.removeProperty('--page-banner-scaled-content-padding-top');
      });
      this.adaptiveHeightRunId = (this.adaptiveHeightRunId || 0) + 1;

      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      this.intersectionObserver = null;

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => {
          target.removeEventListener(type, handler, options);
        });
      }
      this.listeners = [];

      if (this.motionListener && this.motionQuery && this.motionQuery.removeListener) {
        this.motionQuery.removeListener(this.motionListener);
      }
      this.motionListener = null;

      if (this.swiper && this.swiper.destroy) this.swiper.destroy(true, true);
      this.swiper = null;

      // 背景视频由 ndev-page-banner-slide 自管，控制器不再集中暂停

      this.editorSelectedBlock = null;
      this.classList.remove('is-autoplaying', 'is-autoplay-runtime-paused', 'is-reduced-motion');
      this.removeAttribute('ready');
    }

    on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    getSlide(host) {
      // Block tag: null 后 host 即 `.page-banner__slide`，无 Shopify wrapper 层
      return host && host.matches('.page-banner__slide') ? host : null;
    }

    setupAdaptiveHeight() {
      if (
        !this.adaptiveHeightEnabled
        || !this.bannerSection
        || !Number.isFinite(this.pcBannerHeight)
        || this.pcBannerHeight <= 0
      ) return;

      const contentInners = this.slideHosts
        .map((host) => {
          const slide = this.getSlide(host);
          return slide && slide.querySelector('.page-banner__content-inner');
        })
        .filter(Boolean);

      const runId = this.adaptiveHeightRunId;
      if ('ResizeObserver' in window && contentInners.length) {
        this.adaptiveHeightObserver = new ResizeObserver(() => {
          if (this.adaptiveHeightRunId === runId) this.scheduleAdaptiveHeight();
        });
        contentInners.forEach((contentInner) => this.adaptiveHeightObserver.observe(contentInner));
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected && this.adaptiveHeightRunId === runId) this.scheduleAdaptiveHeight();
        });
      }

      this.scheduleAdaptiveHeight();
    }

    scheduleAdaptiveHeight() {
      if (!this.adaptiveHeightEnabled || !this.bannerSection) return;
      if (this.adaptiveHeightFrame) return;
      this.adaptiveHeightFrame = requestAnimationFrame(() => {
        this.adaptiveHeightFrame = null;
        this.syncAdaptiveHeight();
      });
    }

    syncAdaptiveHeight() {
      if (!this.adaptiveHeightEnabled || !this.bannerSection) return;

      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      if (!isDesktop) {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
        this.clearScaledContentPadding();
        return;
      }

      let requiredBannerHeight = 0;
      this.slideHosts.forEach((host) => {
        const slide = this.getSlide(host);
        const measurement = this.getAdaptiveContentMeasurement(slide);
        if (!measurement || measurement.contentHeight <= 0) return;

        let slideRequiredHeight = measurement.contentHeight;
        if (!measurement.centered) {
          if (measurement.paddingTop >= this.pcBannerHeight) {
            slideRequiredHeight = measurement.paddingTop + measurement.contentHeight;
          } else {
            const remainingRatio = 1 - (measurement.paddingTop / this.pcBannerHeight);
            slideRequiredHeight = measurement.contentHeight / remainingRatio;
          }
        }

        if (Number.isFinite(slideRequiredHeight)) {
          requiredBannerHeight = Math.max(requiredBannerHeight, slideRequiredHeight);
        }
      });

      if (requiredBannerHeight > 0 && Number.isFinite(requiredBannerHeight)) {
        this.bannerSection.style.setProperty(
          '--page-banner-adaptive-content-min-height',
          `${requiredBannerHeight}px`
        );
      } else {
        this.bannerSection.style.removeProperty('--page-banner-adaptive-content-min-height');
      }

      const bannerHeight = this.bannerSection.getBoundingClientRect().height;
      if (!Number.isFinite(bannerHeight) || bannerHeight <= 0) {
        this.clearScaledContentPadding();
        return;
      }

      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        const measurement = this.getAdaptiveContentMeasurement(slide);
        if (!measurement || measurement.centered || measurement.contentHeight <= 0) {
          slide.style.removeProperty('--page-banner-scaled-content-padding-top');
          return;
        }

        const scaledPadding = measurement.paddingTop * bannerHeight / this.pcBannerHeight;
        const availablePadding = Math.max(0, bannerHeight - measurement.contentHeight);
        const safePadding = Math.max(0, Math.min(scaledPadding, availablePadding));
        slide.style.setProperty('--page-banner-scaled-content-padding-top', `${safePadding}px`);
      });
    }

    getAdaptiveContentMeasurement(slide) {
      if (!slide) return null;
      const slideContent = slide.querySelector('.page-banner__slide-content');
      const contentInner = slide.querySelector('.page-banner__content-inner');
      if (!slideContent || !contentInner) return null;

      const contentHeight = Math.max(
        contentInner.getBoundingClientRect().height,
        contentInner.scrollHeight
      );
      const paddingTop = parseFloat(getComputedStyle(slide).getPropertyValue('--pb-content-padding-top'));
      return {
        centered: getComputedStyle(slide).getPropertyValue('--pb-v-align').trim() === 'center',
        contentHeight: Number.isFinite(contentHeight) ? Math.max(0, contentHeight) : 0,
        paddingTop: Number.isFinite(paddingTop) ? Math.max(0, paddingTop) : 0
      };
    }

    clearScaledContentPadding() {
      this.querySelectorAll('.page-banner__slide').forEach((slide) => {
        slide.style.removeProperty('--page-banner-scaled-content-padding-top');
      });
    }

    buildPagination() {
      const containers = [this.verticalTabs, this.horizontalTabs, this.horizontalTabsPc].filter(Boolean);
      containers.forEach((container) => {
        container.replaceChildren();
        container.hidden = true;
        container.style.setProperty('--count', this.slideCount);
      });

      if (!this.showPagination || this.slideCount <= 1) return;

      this.slideHosts.forEach((host, index) => {
        const slide = this.getSlide(host);
        const title = (slide && slide.getAttribute('data-tab-title')) || `Slide ${index + 1}`;

        if (this.verticalTabs && this.paginationVariant === 'tabs') {
          this.verticalTabs.appendChild(this.createPaginationButton('page-banner__vertical-tab', title, index, true));
        }

        if (this.horizontalTabsPc && this.paginationVariant === 'tabs_pc_horizontal') {
          const button = this.createPaginationButton('page-banner__horizontal-tab-pc', title, index, false);
          const label = document.createElement('span');
          label.className = 'page-banner__horizontal-tab-pc-title';
          label.textContent = title;
          button.appendChild(label);
          this.horizontalTabsPc.appendChild(button);
        }

        if (this.horizontalTabs) {
          this.horizontalTabs.appendChild(this.createPaginationButton('page-banner__horizontal-tab', title, index, false));
        }
      });
    }

    createPaginationButton(className, title, index, showText) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.setAttribute('aria-label', `Show ${title}`);
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      if (showText) button.textContent = title;
      this.on(button, 'click', () => {
        if (!this.swiper) return;
        if (this.loopEnabled && this.swiper.slideToLoop) this.swiper.slideToLoop(index);
        else this.swiper.slideTo(index);
        this.announceSlide(index);
      });
      return button;
    }

    waitForSwiper() {
      const startedAt = performance.now();
      const check = () => {
        if (!this.isConnected) return;
        if (window.Swiper) {
          this.createSwiper();
          return;
        }
        if (performance.now() - startedAt < 5000) {
          this.waitFrame = requestAnimationFrame(check);
        }
      };
      check();
    }

    createSwiper() {
      if (this.swiper || !window.Swiper || this.slideCount <= 1) return;

      const reducedMotion = this.motionQuery.matches;
      this.classList.toggle('is-reduced-motion', reducedMotion);

      this.swiper = new window.Swiper(this.viewport, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: this.loopEnabled,
        simulateTouch: true,
        allowTouchMove: true,
        speed: reducedMotion ? 0 : 300,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        slideClass: 'page-banner__slide',
        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              stopOnLastSlide: !this.loopEnabled
            }
          : false,
        on: {
          init: (swiper) => this.handleSlideChange(this.getSwiperIndex(swiper), swiper),
          slideChange: (swiper) => this.handleSlideChange(this.getSwiperIndex(swiper), swiper)
        }
      });

      this.setAttribute('ready', '');
      this.showControls();
      this.syncAutoplay();
      this.scheduleAdaptiveHeight();
    }

    getSwiperIndex(swiper = this.swiper) {
      if (swiper && Number.isFinite(swiper.realIndex)) return swiper.realIndex;
      if (swiper && Number.isFinite(swiper.activeIndex)) return swiper.activeIndex;
      return 0;
    }

    handleSlideChange(index, swiper = this.swiper) {
      this.activeIndex = index;
      this.syncSlideState(index);
      this.syncPagination(index);
      this.syncNavigation(swiper);
      if (this.swiper) this.syncAutoplay();
      this.restartProgress();
    }

    syncNavigation(swiper = this.swiper) {
      const navigationRequired = this.showNavigation && this.slideCount > 1 && swiper;
      const canWrap = Boolean(swiper && swiper.params && (swiper.params.loop || swiper.params.rewind));
      if (this.previousButton) this.previousButton.hidden = !navigationRequired || (!canWrap && swiper.isBeginning);
      if (this.nextButton) this.nextButton.hidden = !navigationRequired || (!canWrap && swiper.isEnd);
    }

    syncPagination(activeIndex) {
      const mappings = [
        ['.page-banner__vertical-tab', 'page-banner__vertical-tab--active'],
        ['.page-banner__horizontal-tab', 'page-banner__horizontal-tab--active'],
        ['.page-banner__horizontal-tab-pc', 'page-banner__horizontal-tab-pc--active']
      ];

      mappings.forEach(([selector, activeClass]) => {
        this.querySelectorAll(selector).forEach((button, index) => {
          const active = index === activeIndex;
          button.classList.toggle(activeClass, active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      });

      if (this.verticalTabs) {
        this.verticalTabs.style.setProperty('--top', `${activeIndex * (19.2 + 18)}px`);
      }
    }

    syncSlideState(activeIndex) {
      if (!this.slideHosts) return;

      this.slideHosts.forEach((host, index) => {
        const active = index === activeIndex;
        const slide = this.getSlide(host);
        host.toggleAttribute('inert', !active);
        host.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (slide && slide !== host) {
          slide.toggleAttribute('inert', !active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        }
        // 背景媒体播放/暂停由 ndev-page-banner-slide 依据上述活性属性自治处理
      });
    }

    shouldAutoplay() {
      return Boolean(
        this.swiper
        && this.swiper.autoplay
        && this.autoplayEnabled
        && !this.motionQuery.matches
        && this.inView
        && !document.hidden
        && !this.editorSelectedBlock
        && (this.loopEnabled || !this.swiper.isEnd)
      );
    }

    syncAutoplay() {
      if (!this.swiper || !this.swiper.autoplay) {
        this.classList.remove('is-autoplaying', 'is-autoplay-runtime-paused');
        return;
      }

      const shouldRun = this.shouldAutoplay();
      if (shouldRun) {
        if (!this.swiper.autoplay.running) this.swiper.autoplay.start();
      } else if (this.swiper.autoplay.running) {
        this.swiper.autoplay.stop();
      }

      this.classList.toggle('is-autoplaying', shouldRun);
      this.classList.toggle('is-autoplay-runtime-paused', this.autoplayEnabled && !shouldRun);
    }

    restartProgress() {
      const shouldRun = this.shouldAutoplay();
      this.classList.remove('is-autoplaying');
      void this.offsetWidth;
      this.classList.toggle('is-autoplaying', shouldRun);
    }

    syncRuntimeState() {
      this.syncAutoplay();
      this.syncSlideState(this.activeIndex || 0);
      if (this.shouldAutoplay()) this.restartProgress();
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const wasInView = this.inView;
        this.inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
        if (wasInView !== this.inView) this.syncRuntimeState();
      }, { threshold: [0, 0.01] });
      this.intersectionObserver.observe(this);
    }

    handleResize() {
      if (this.resizeFrame) cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        if (this.swiper && this.swiper.update) this.swiper.update();
        this.syncSlideState(this.activeIndex || 0);
        this.scheduleAdaptiveHeight();
      });
    }

    handleMotionChange() {
      const reducedMotion = this.motionQuery.matches;
      this.classList.toggle('is-reduced-motion', reducedMotion);
      if (this.swiper) this.swiper.params.speed = reducedMotion ? 0 : 300;
      this.syncRuntimeState();
    }

    bindActions() {
      // 按钮动作分发与 Slide 整块跳转分别由子级自定义元素
      // ndev-page-banner-button / ndev-page-banner-slide 自治处理，控制器不再委托。

      this.on(this.previousButton, 'click', () => {
        if (!this.swiper) return;
        this.swiper.slidePrev();
        this.announceSlide(this.getSwiperIndex());
      });

      this.on(this.nextButton, 'click', () => {
        if (!this.swiper) return;
        this.swiper.slideNext();
        this.announceSlide(this.getSwiperIndex());
      });
    }

    announceSlide(index) {
      if (!this.status || !this.slideHosts[index]) return;
      const slide = this.getSlide(this.slideHosts[index]);
      const title = (slide && slide.getAttribute('data-tab-title')) || `Slide ${index + 1}`;
      this.status.textContent = `${title}, slide ${index + 1} of ${this.slideCount}`;
    }

    showControls() {
      if (this.slideCount <= 1) return;
      if (this.showPagination) {
        if (this.paginationVariant === 'tabs' && this.verticalTabs) this.verticalTabs.hidden = false;
        if (this.paginationVariant === 'tabs_pc_horizontal' && this.horizontalTabsPc) this.horizontalTabsPc.hidden = false;
        if (this.horizontalTabs) this.horizontalTabs.hidden = false;
      }
      if (this.navigation) this.navigation.hidden = !this.showNavigation && !this.showPagination;
      this.syncNavigation();
    }

    hideControls() {
      if (this.verticalTabs) this.verticalTabs.hidden = true;
      if (this.horizontalTabs) this.horizontalTabs.hidden = true;
      if (this.horizontalTabsPc) this.horizontalTabsPc.hidden = true;
      if (this.navigation) this.navigation.hidden = true;
      if (this.previousButton) this.previousButton.hidden = true;
      if (this.nextButton) this.nextButton.hidden = true;
    }

    handleBlockSelect(event) {
      if (!event || !event.target || !this.contains(event.target) || !this.swiper) return;
      let current = event.target.nodeType === Node.ELEMENT_NODE ? event.target : event.target.parentElement;

      while (current && current !== this) {
        const index = this.slideHosts.indexOf(current);
        if (index >= 0) {
          // 编辑该 Block（或其内部子 Block）期间保持该 Slide 常显，停止自动轮播
          this.editorSelectedBlock = event.target;
          if (this.loopEnabled && this.swiper.slideToLoop) this.swiper.slideToLoop(index);
          else this.swiper.slideTo(index);
          this.syncAutoplay();
          return;
        }
        current = current.parentElement;
      }
    }

    handleBlockDeselect(event) {
      if (!event || !event.target || !this.contains(event.target)) return;
      if (event.target !== this.editorSelectedBlock) return;

      this.editorSelectedBlock = null;
      this.syncRuntimeState();
    }
  }

  if (!customElements.get('ndev-page-banner')) {
    customElements.define('ndev-page-banner', NdevPageBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page1"]) return;
  try {
    
  (function() {
      let hydro = { install: 'yes', list: [] };
      let lastTar = null;
      const btn = document.getElementById('page1-next');
      const events = Array.prototype.slice.apply(document.getElementById('page1-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item; 
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          if (index === 2) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/bathroom';
          } else if (index === 4) {
              hydro.list[0] = { result: 'no' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/balcony';
          } else {
              hydro.list[0] = { result: 'yes' };
              window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
              location.href = '/pages/hydroease-question2';
          }
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page2"]) return;
  try {
    
  (function() {
      let hydro = window.sessionStorage.getItem('__hydro__');
      try {
          hydro = JSON.parse(hydro);
      } catch (e) {
          hydro = { install: 'no' };
      }
      document.getElementById('page2-no').addEventListener('click', function() {
          hydro.install = 'no';
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

      document.getElementById('page2-yes').addEventListener('click', function() {
          if (hydro.install === 'yes') {
              hydro.list[1] = { result: 'yes' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question3';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page3"]) return;
  try {
    
(function() {
    let lastTar = null;
    const btn = document.getElementById('page3-next');
    const events = Array.prototype.slice.apply(document.getElementById('page3-room').querySelectorAll('.item'));
    events.forEach(item => {
        item.addEventListener('click', function() {
            if (lastTar !== null) {
                lastTar.classList.remove('selected');
            } 

            lastTar = item;
            item.classList.add('selected');
            btn.style.display = 'block';
        });
    });

    btn.addEventListener('click', function() {
        const index = Number(lastTar.dataset.index);
        let hydro = window.sessionStorage.getItem('__hydro__');
        try {
            hydro = JSON.parse(hydro);
            if (index === 1) {
                hydro.intall = 'no';
            } else {
                hydro.list[2] = { result: 'yes' };
            }
        } catch (e) {
            hydro = { install: 'no' };
        }
        window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
        location.href = '/pages/hydroease-question4';
    });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page4"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page4-next');
      const events = Array.prototype.slice.apply(document.getElementById('page4-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[3] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question5';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page5"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page5-next');
      const events = Array.prototype.slice.apply(document.getElementById('page5-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected'); 
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[4] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question6';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page6"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page6-next');
      const events = Array.prototype.slice.apply(document.getElementById('page6-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) { 
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          });
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[5] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }
          window.sessionStorage.setItem('__hydro__', JSON.stringify(hydro));
          location.href = '/pages/hydroease-question7';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page7"]) return;
  try {
    
   (function() {
      let lastTar = null;
      const btn = document.getElementById('page7-next');
      const events = Array.prototype.slice.apply(document.getElementById('page7-room').querySelectorAll('.item'));
      events.forEach(item => {
          item.addEventListener('click', function() {
              if (lastTar !== null) {
                  lastTar.classList.remove('selected');
              }

              lastTar = item;
              item.classList.add('selected');
              btn.style.display = 'block';
          }); 
      });

      btn.addEventListener('click', function() {
          const index = Number(lastTar.dataset.index);
          let hydro = window.sessionStorage.getItem('__hydro__');
          window.sessionStorage.removeItem('__hydro__');
          try {
              hydro = JSON.parse(hydro);
              if (index === 1) {
                  hydro.intall = 'no';
              } else {
                  hydro.list[6] = { result: 'yes' };
              }
          } catch (e) {
              hydro = { install: 'no' };
          }

          if (hydro.install === 'yes') {
              if (hydro.list.filter(r => r && r.result === 'yes').length === 7) {
                  location.href = '/pages/freo-hydroease-product';
                  return false;
              }
          }

          location.href = '/pages/freo-product';
      });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixlee-widget"]) return;
  try {
    
  (function(){
    window.PixleeAsyncInit = function() { //2
        Pixlee.init({ apiKey: "t8hC3pFQ7Vc2z2RTMZrm" });
        Pixlee.addCategoryWidget({ widgetId: "7876231", containerId: 'pixlee-widget-box' });
        Pixlee.resizeWidget();
    };
    var pix = document.createElement('script');
    pix.src = '//assets.pxlecdn.com/assets/pixlee_widget_1_0_0.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(pix, s);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-buy-box')) {
    class ProductBuyBox extends BaseElement {
      init() {
        if (this.getAttribute('hidden-product') === 'true') {
          window.location.href = this.getAttribute('redirect-url') || '/';
          return;
        }

        const variantIdAttr = this.getAttribute('data-ndev-product-variant-id');
        this._variantId = variantIdAttr ? parseInt(variantIdAttr) : null;
        this._variantPrice = 0;
        this._compareAtPrice = 0;
        this._available = this.getAttribute('data-ndev-product-variant-available') !== 'false';
        this._sources = {};

        const priceAttr = this.getAttribute('data-ndev-product-variant-price');
        if (priceAttr != null) this._variantPrice = parseInt(priceAttr) || 0;

        const titleEl = this.querySelector('.product-buy-box__title');
        this._productTitle = titleEl ? titleEl.textContent.trim() : '';
        this._mobileBlocksEl = this.querySelector('.product-buy-box__blocks');
        this._galleryExtraEl = this.querySelector('[data-pbb-gallery-extra]');
        this._featureListEl = this.querySelector('.product-buy-box-block--feature-list');
        this._desktopFeatureNextSibling = this._featureListEl ? this._featureListEl.nextSibling : null;
        this._desktopFeatureParent = this._featureListEl ? this._featureListEl.parentNode : null;
        this._stickyZoneEl = this.querySelector('[data-product-buy-box-sticky-zone]');
        this._siteHeaderEl = document.querySelector('#site-header');

        this._onVariantChange = (e) => {
          const d = e.detail || {};
          if (d.variantId) {
            this._variantId = d.variantId;
            this.setAttribute('data-ndev-product-variant-id', String(d.variantId));
          }
          if (d.price != null) {
            this._variantPrice = d.price;
            this.setAttribute('data-ndev-product-variant-price', String(d.price));
          }
          if (d.compareAtPrice != null) this._compareAtPrice = d.compareAtPrice;
          if (d.available != null) this._available = d.available;
          this._dispatchTotalUpdate();
        };

        this._onSourceChange = (e) => {
          const d = e.detail || {};
          const src = d.source;
          if (!src) return;
          if (d.total == null) {
            delete this._sources[src];
          } else {
            this._sources[src] = { total: d.total, items: d.items || [] };
          }
          this._dispatchTotalUpdate();
        };

        this._onMediaChange = () => {
          this._placeResponsiveBlocks();
          this._syncStickyReplacementOffset();
        };
        this._onResize = () => this._syncStickyReplacementOffset();
        this._onStickyNavVisibilityChange = (e) => this._syncStickyDisplay(e.detail || {});

        this.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.addEventListener('product-buy-box:source-change', this._onSourceChange);
        this.addEventListener('ndev-sticky-anchor-navbar:visibility-change', this._onStickyNavVisibilityChange);

        this._mediaQuery = window.matchMedia('(max-width: 1023px)');
        this._mediaQuery.addEventListener('change', this._onMediaChange);
        window.addEventListener('resize', this._onResize, { passive: true });
        if (window.ResizeObserver && this._stickyZoneEl) {
          this._stickyZoneObserver = new ResizeObserver(() => this._syncStickyReplacementOffset());
          this._stickyZoneObserver.observe(this._stickyZoneEl);
        }
        this._syncStickyDisplay({ visible: false });
        this._placeResponsiveBlocks();
        this._syncStickyReplacementOffset();
        this._dispatchTotalUpdate();
      }

      dispose() {
        this.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.removeEventListener('product-buy-box:source-change', this._onSourceChange);
        this.removeEventListener('ndev-sticky-anchor-navbar:visibility-change', this._onStickyNavVisibilityChange);
        this._setHeaderHidden(false);
        this.style.removeProperty('--product-buy-box-sticky-replacement-height');
        this._stickyZoneObserver?.disconnect();
        window.removeEventListener('resize', this._onResize);
        this._mediaQuery?.removeEventListener('change', this._onMediaChange);
      }

      _syncStickyDisplay(detail) {
        const mode = this._stickyZoneEl?.getAttribute('data-display-mode') || 'replace_header';
        const replacing = mode === 'replace_header' && Boolean(detail.visible);
        this.classList.toggle('is-sticky-replacing-header', replacing);
        this._setHeaderHidden(replacing);
        this._syncStickyReplacementOffset();
      }

      _setHeaderHidden(hidden) {
        if (!this._siteHeaderEl) return;
        this._siteHeaderEl.classList.toggle('is-hidden', hidden);
      }

      _syncStickyReplacementOffset() {
        const height = this.classList.contains('is-sticky-replacing-header')
          ? this._getStickyZoneHeight()
          : 0;
        this.style.setProperty('--product-buy-box-sticky-replacement-height', `${height}px`);
      }

      _getStickyZoneHeight() {
        if (!this._stickyZoneEl || !document.body.contains(this._stickyZoneEl)) return 0;
        const rect = this._stickyZoneEl.getBoundingClientRect();
        return Math.max(0, Math.ceil(rect.height || 0));
      }

      _computeSourcesTotal() {
        let t = 0;
        for (const s in this._sources) {
          t += this._sources[s].total;
        }
        return t;
      }

      _dispatchTotalUpdate() {
        const sourcesTotal = this._computeSourcesTotal();
        const totalPrice = this._variantPrice + sourcesTotal;

        this.dispatchEvent(new CustomEvent('product-buy-box:total-update', {
          bubbles: true,
          composed: true,
          detail: {
            variantId: this._variantId,
            variantPrice: this._variantPrice,
            compareAtPrice: this._compareAtPrice,
            available: this._available,
            sources: Object.assign({}, this._sources),
            sourcesTotal,
            totalPrice
          }
        }));
      }

      _placeResponsiveBlocks() {
        if (!this._featureListEl || !this._mobileBlocksEl || !this._desktopFeatureParent) return;

        if (this._mediaQuery.matches) {
          if (this._featureListEl.parentNode !== this._mobileBlocksEl) {
            this._mobileBlocksEl.appendChild(this._featureListEl);
          }
        } else if (this._featureListEl.parentNode !== this._desktopFeatureParent) {
          if (this._desktopFeatureNextSibling && this._desktopFeatureNextSibling.parentNode === this._desktopFeatureParent) {
            this._desktopFeatureParent.insertBefore(this._featureListEl, this._desktopFeatureNextSibling);
          } else {
            this._desktopFeatureParent.appendChild(this._featureListEl);
          }
        }
      }

      getCartItems() {
        const nonce = Date.now() + Math.floor(Math.random() * 100000);
        const sourceItems = [];
        for (const s in this._sources) {
          const items = this._sources[s].items || [];
          for (let i = 0; i < items.length; i++) {
            sourceItems.push(items[i]);
          }
        }

        if (!sourceItems.length) {
          return [{ varId: this._variantId, qty: 1 }];
        }

        const result = [];
        for (let j = 0; j < sourceItems.length; j++) {
          const item = sourceItems[j];
          result.push({
            varId: item.variantId,
            qty: item.quantity || 1,
            properties: Object.assign({}, item.properties || {}, {
              _group_id: nonce,
              _group_parent: false,
              For: this._productTitle
            })
          });
        }
        result.push({
          varId: this._variantId,
          qty: 1,
          properties: {
            _group_id: nonce,
            _group_parent: true
          }
        });
        return result;
      }
    }
    customElements.define('product-buy-box', ProductBuyBox);
  }

  } catch(e) { console.error(e); }
})();
})();
